import React, { createRef } from "react";
import { toast } from "../../NewUI/NewComponents/toastService.js";
import { Autocomplete, Backdrop, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import {
    address,
    address2,
    ccity,
    ccountry,
    clientname,
    contactnumber,
    cstate,
    cstatecode,
    currency,
    currentTenant,
    czip,
    dataaccess,
    einvoice,
    financialyearend,
    financialyearstart,
    taxtype,
    theme,
    thousandsdisplay,
    transactionFrom,
    userid,
    userwhid,
} from "../../Common/Credentials.js";
import { FieldArray, Form, Formik } from "formik";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import Footer from "../../Component/Footer";
import SalesServices from "../SalesServices";
import downloadfiles from "../../Common/upload/downloadfiles.js";
import { NumericFormat } from "react-number-format";
import {
    Box,
    Checkbox,
    Collapse,
    FormControlLabel,
    Tooltip,
    IconButton,
    TextField,
    Typography,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Accordion,
    AccordionDetails,
    AccordionSummary,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import moment from "moment";
import { Modal, Spinner } from "react-bootstrap";
import InventoryService from "../../inventory/InventoryService.js";
import SettingsServices from "../../Settings/SettingsServices.js";
import MasterService from "../../Masters/MasterService.js";
import UsercustomerService from "../../Masters/Usercustomers/UsercustomerService.js";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Swal from "sweetalert2";
import TransporterServices from "../../Masters/Transporter/TransporterServices.js";
import CategoryServices from "../../Masters/Category/CategoryServices.js";
import WarehouseServices from "../../Masters/Warehouse/WarehouseServices.js";
import CustomerService from "../../Masters/Customers/CustomerService.js";
import { DateTimePicker, DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DepartmentServices from "../../Masters/Department/DepartmentServices.js";
import NonInvInvoice from "./NonInvInvoice.jsx";
import UpArrow from "../../images/Icons/up-arrow.png";
import dayjs from 'dayjs';
import SalesCalculationServices from "../../Masters/SalesCalculation/SalesCalculationServices.js";
import { SelectableRadio } from "../../NewUI/NewComponents/SelectableRadio.jsx";
import { OSSwitch } from "../../NewUI/NewComponents/OSSwitch.jsx";
import EditIcon from "../../images/Icons/edit.png";
import DeleteIcon from "../../images/Icons/delete.png";
import DatePickerField from "../../NewUI/NewComponents/DatePickerField.jsx";
import SelectField from "../../NewUI/NewComponents/SelectField.jsx";
import AutoCompeteField from "../../NewUI/NewComponents/AutoCompeteField.jsx";
import RoundedTabButton from "../../NewUI/NewComponents/RoundedTabButton.jsx";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
import TextareaField from "../../NewUI/NewComponents/TextareaField.jsx";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";
import TextFeildWithSelect from "../../NewUI/NewComponents/TextFeildWithSelect.jsx";
import RectangularTabButton from "../../NewUI/NewComponents/RectangularTabButton.jsx";
import FuturisticTimePicker from "../../NewUI/NewComponents/FuturisticTimePicker.jsx";
import InlineTimePicker from "../../NewUI/NewComponents/InlineTimePicker.jsx";
import { BoxesIcon, BoxIcon, WrenchIcon } from "lucide-react";
import TabSwitch from "../../NewUI/NewComponents/TabSwitch.jsx";
import TaxServices from "../../Masters/Tax/TaxServices.js";

let datalist = [];

// TabButton Component (from InvoiceTable)
const TabButton = ({ active, onClick, children }) => (
    <fieldset
        onClick={onClick}
        className={`tab-button ${active ? "active-tab" : "inactive-tab"}`}
        style={{
            cursor: "pointer",
            transition: "all 0.3s ease",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            borderRadius: "50px",
            border: "1px solid #e2e8f0",
            padding: "8px 16px",
            fontSize: "0.8rem",
            fontWeight: 500,
        }}
    >
        {children}
        <img
            src={UpArrow}
            alt="Up Arrow"
            style={{
                width: "1.5rem",
                height: "1.5rem",
                padding: "4px",
                transform: active ? "rotate(30deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
            }}
        />
    </fieldset>
);

const isInvalid = ["", 0, "0", null, "null", NaN, "NaN", undefined];

class Invoice extends React.Component {
    constructor(props) {
        super(props);
        this.productSectionRef = createRef();
        this.serviceSectionRef = createRef();
        this.mySectionRef = createRef()
        this.state = {
            invtype: this.props.location.state.pagename === "New Proforma Invoice" ? "Order Invoice" : "Direct Invoice",
            isclone: this.props.location?.state?.clone || false,
            subject: "",
            finacialLatestInvoiceNumber: null,
            showPricesIn: 0,
            invid: this.props.location?.state?.clone ? -1 : this.props.location.state.id,
            pagename: this.props.location.state.pagename,
            saleorderdata: [],
            usercustomers: [],
            saleorderid: "",
            saleorderitems: [],
            taxesList: [],
            custom: [],
            customer: "",
            custid: "",
            agent: "",
            agentid: "",
            customerdetails: "",
            debitamount: 0,
            openingbalance: 0,
            adjustdebit: false,
            adjustopen: false,
            itemid: "",
            itemname: "",
            salesenum: "",
            additionalparams: 0,
            quantity: 0,
            orderedquantity: "",
            pendingquantity: "",
            grandtotal: 0,          // will be overwritten by recomputeTotals
            ccgrandtotal: 0,
            status: "0",
            sodata: "",
            addservice: false,
            serviceList: [],
            milestones: [],
            contracttype: "",
            DnIDList: [],
            dndata: "",
            dnid: "",
            completed: "",
            backdateinvoicestatus: false,
            sotype: 0,
            show: 0,
            open: false,
            open1: false,
            openDuePicker: false,
            openCustomPicker: false,
            po: "",
            accepteditems: [],
            filterserv: [],
            loader: false,
            creditperiod: 0,
            serviceid: "",
            currencylist: [],
            currencyid: "",
            currency: currency,
            curconversionrate: 1,
            invtotalamountwtax: 0,
            ccinvtotalamountwtax: 0,
            tcsreq: false,
            tcs: 0,
            tcsamount: 0,
            whdata: [],
            itemquantitylist: [],
            batchidlist: [],
            batchid: "",
            quantitywindow: false,
            pouploadm: "",
            vehiclenum: null,
            distance: 0,
            transporterid: null,
            name: "",
            phoneno: "",
            pincode: "",
            state: "",
            statecode: "",
            city: "",
            houseno: "",
            areaname: "",
            country: "",
            billname: "",
            billphoneno: "",
            billpincode: "",
            billstate: "",
            billstatecode: "",
            billcity: "",
            billhouseno: "",
            billareaname: "",
            billcountry: "",
            disname: "",
            disphoneno: "",
            dispincode: "",
            disstate: "",
            disstatecode: "",
            discity: "",
            dishouseno: "",
            disareaname: "",
            discountry: "",
            err: false,
            adderr: false,
            editservie: false,
            CountryData: [],
            StatesData: [],
            CitiesData: [],
            disStatesData: [],
            disCitiesData: [],
            defaultadd: true,
            defaultdisadd: true,
            dnrequired: false,
            fifoprice: "",
            lifoprice: "",
            avgprice: "",
            insurancereq: false,
            insurance: 0,
            tcsableamount: 0,
            insuranceamount: 0,
            insurancetax: 0,
            einvoice: false,
            additionalchargeslist: [],
            additionalcharges: 0,
            additionalchargestax: 0,
            totaladditionalcharges: 0,
            cctotaladditionalcharges: 0,
            additionalchargestaxamount: 0,
            natureofcharge: "",
            invoiceadditionalcharges: 0,
            ccinvoiceadditionalcharges: 0,
            invoiceadditionalchargestax: 0,
            ccinvoiceadditionalchargestax: 0,
            totalinsuranceamount: 0,
            samedaydelivery: einvoice ? false : true,
            totalinvoice: 0,
            cctotalinvoice: 0,
            totaltaxamount: 0,
            cctotaltaxamount: 0,
            totaldiscount: 0,
            cctotaldiscount: 0,
            serviceeditIndex: null,
            itemeditIndex: null,
            addtype: "Dispatch details",
            errormsg: [],
            transportername: null,
            deliverymethods: [
                { value: "1", name: "Own Vehicle" },
                { value: "2", name: "Hired Vehicle" },
                { value: "3", name: "GTA" },
                { value: "4", name: "Others" },
            ],
            transmode: 1,
            vehicletypes: [
                { value: "O", name: "ODC" },
                { value: "R", name: "Regular" },
            ],
            vehicletype: "R",
            supplytype: "O",
            transportationmode: 1,
            transactiontype: 1,
            dlryaccordian: true,
            addchraccordian: true,
            itemstock: 0,
            iscomposite: false,
            transporterslist: [],
            transporterselectiontype: false,
            validtrnsid: einvoice ? false : true,

            WarehouseList: [],
            DepartmentList: [],
            CategoryList: [],
            ServiceCategoryList: [],
            itemList: [],
            filteritemlist: [],
            sizelist: [],
            whdata: [],
            warehouse: "",
            whid: "",
            department: "",
            deptid: "",
            itemname: "",
            hsnid: "",
            hsn: "",
            price: "",
            type: "",
            uom: "",
            category: "",
            categoryid: "",
            uomid: "",
            description: "",
            brand: "",
            model: "",
            size: "",
            colour: "",
            thickness: "",
            totalmtrroll: "",
            settings: "",
            discounttype: "%",
            discount: "",
            discountamount: "",
            pricevariance: 0,
            taxtypelist: ["GST", "VAT"],
            gsttypelist: ["INTRASTATE", "INTERSTATE"],
            taxtype: taxtype,
            gsttype: "INTRASTATE",
            taxrequired: true,
            convertionreq: false,
            basecurrency: currency,
            tax: 0,
            sgst: 0,
            cgst: 0,
            serviceitemList: [],
            service: "",
            serviceid: "",
            servicecategory: "",
            servicecatid: "",
            servicecode: "",
            servicetax: "",
            servicecost: "",
            servicecostconv: 0,
            servicediscount: 0,
            servicediscountamount: 0,
            servicemarkup: 0,
            servicecgst: "",
            servicesgst: "",
            serviceigst: "",
            servicegst: "",
            servicevat: "",
            servicetaxamount: "",
            servicecostwttaxconv: 0,
            servicecostwttax: "",
            servicedescription: "",
            servicetotal: "",
            serviceerr: "",
            grandservicetotal: 0,
            ccgrandservicetotal: 0,
            servicedata: [],
            transidreq: false,
            autojre: false,
            valueroundoff: 0,
            markup1: 0,
            markup: 0,
            invoiceremarks: "",
            customcreatedAt: "",
            SDdate: false,
            multiCurrency: false,
            duedate: new Date(moment().format("YYYY-MM-DD HH:mm:ss")),
            soitemdata: null,
            // hover state for modern UI
            hovered: null,
            isActionHovered: null,

            // --- NEW computed totals (will be set by recomputeTotals) ---
            subtotal: 0,
            ccsubtotal: 0,
            taxTotal: 0,
            cctaxTotal: 0,
            additionalChargesTotal: 0,
            ccadditionalChargesTotal: 0,
            insuranceTotal: 0,
            ccinsuranceTotal: 0,
            tcsTotal: 0,
            cctcsTotal: 0,
            tdsTotal: 0,
            cctdsTotal: 0,
            // --- flags for UI panels ---
            additionalChargesEnabled: false,
            insuranceEnabled: false,
            tcsEnabled: false,
            isTCSMode: true, // true = TCS, false = TDS
            tds: 0,
            tdsamount: 0,
            tdsableamount: 0,
            recurring: false,
            recurringenddate: "",
            recurringperiod: "Daily",
            recurringconfirm: "Manual"
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.validate = this.validate.bind(this);
    }

    // ==================== VALIDATION ====================
    validate(values) {
        const errors = {};
        // Customer is required for all invoice types
        if (!this.state.custid || this.state.custid === "") {
            errors.customer = "Please select a customer.";
        }
        return errors;
    }

    // ==================== CENTRAL RECALCULATION ====================
    recomputeTotals = () => {
        const {
            accepteditems,
            serviceList,
            additionalchargeslist,
            curconversionrate,
            insuranceEnabled,
            insurance,
            insurancetax,
            tcsEnabled,
            isTCSMode,
            tcs,
            tds,
            taxrequired,
            taxtype,
            gsttype,
            currency,
            basecurrency,
        } = this.state;

        const isMultiCurrency = currency !== basecurrency;

        // Helper to compute one item's totals in invoice currency and base currency
        const computeItem = (item) => {
            let priceInv, priceBase, markupInv, markupBase;
            if (isMultiCurrency) {
                // Multi‑currency: ccprice / ccmarkup1 are invoice values
                priceInv = item.ccprice || 0;
                priceBase = item.price || (priceInv / (curconversionrate || 1));
                markupInv = item.ccmarkup1 || 0;
                markupBase = item.markup1 || (markupInv / (curconversionrate || 1));
            } else {
                // Single currency: price / markup1 are invoice values
                priceInv = item.price || 0;
                priceBase = item.ccprice || priceInv;
                markupInv = item.markup1 || 0;
                markupBase = item.ccmarkup1 || markupInv;
            }

            let qty = item.quantity || 0;
            let discountPct = item.discount || 0;
            let taxPct = item.tax || 0;
            let priceVariance = item.pricevariance || 0;

            let effectivePriceInv = (priceInv) * (1 + priceVariance / 100);
            let effectivePriceBase = (priceBase) * (1 + priceVariance / 100);

            let baseInv = effectivePriceInv * qty;
            let baseBase = effectivePriceBase * qty;

            let discountInv = baseInv * (discountPct / 100);
            let discountBase = baseBase * (discountPct / 100);

            let afterDiscountInv = baseInv - discountInv;
            let afterDiscountBase = baseBase - discountBase;

            let taxInv = 0, taxBase = 0;
            if (taxrequired && taxPct) {
                if (taxtype === "GST" && ccountry === "India" && gsttype === "INTRASTATE") {
                    taxInv = afterDiscountInv * (taxPct / 100);
                    taxBase = afterDiscountBase * (taxPct / 100);
                } else {
                    taxInv = afterDiscountInv * (taxPct / 100);
                    taxBase = afterDiscountBase * (taxPct / 100);
                }
            }

            return {
                baseInv: afterDiscountInv,
                baseBase: afterDiscountBase,
                taxInv,
                taxBase,
                totalInv: afterDiscountInv + taxInv,
                totalBase: afterDiscountBase + taxBase,
                discountInv,
                discountBase,
            };
        };

        // Helper for services (already correct – ccservicecost = invoice, servicecost = base)
        const computeService = (svc) => {
            let costInv = svc.ccservicecost || 0;
            let costBase = svc.servicecost || (costInv * curconversionrate);
            let markupInv = svc.ccmarkup1 || 0;
            let markupBase = svc.markup1 || (markupInv * curconversionrate);
            let qty = svc.quantity || 1;
            let discountPct = svc.servicediscount || 0;
            let taxPct = svc.servicetax || 0;

            let baseInv = (costInv + markupInv) * qty;
            let baseBase = (costBase + markupBase) * qty;

            let discountInv = baseInv * (discountPct / 100);
            let discountBase = baseBase * (discountPct / 100);

            let afterDiscountInv = baseInv - discountInv;
            let afterDiscountBase = baseBase - discountBase;

            let taxInv = 0, taxBase = 0;
            if (taxrequired && taxPct) {
                if (taxtype === "GST" && ccountry === "India" && gsttype === "INTRASTATE") {
                    taxInv = afterDiscountInv * (taxPct / 100);
                    taxBase = afterDiscountBase * (taxPct / 100);
                } else {
                    taxInv = afterDiscountInv * (taxPct / 100);
                    taxBase = afterDiscountBase * (taxPct / 100);
                }
            }

            return {
                baseInv: afterDiscountInv,
                baseBase: afterDiscountBase,
                taxInv,
                taxBase,
                totalInv: afterDiscountInv + taxInv,
                totalBase: afterDiscountBase + taxBase,
                discountInv,
                discountBase,
            };
        };

        // Sum products
        let itemsTotalInv = 0, itemsTotalBase = 0;
        let subtotalInv = 0, subtotalBase = 0;
        let taxTotalInv = 0, taxTotalBase = 0;
        let discountTotalInv = 0, discountTotalBase = 0;
        accepteditems.forEach(item => {
            const res = computeItem(item);
            itemsTotalInv += res.totalInv;
            itemsTotalBase += res.totalBase;
            subtotalInv += res.baseInv;
            subtotalBase += res.baseBase;
            taxTotalInv += res.taxInv;
            taxTotalBase += res.taxBase;
            discountTotalInv += res.discountInv;
            discountTotalBase += res.discountBase;
        });

        // Sum services
        let servicesTotalInv = 0, servicesTotalBase = 0;
        if (this.state.milestones.length === 0) {
            if (this.state.invtype === "Order Invoice") {
                serviceList.filter(e => e.status).forEach(svc => {
                    const res = computeService(svc);
                    servicesTotalInv += res.totalInv;
                    servicesTotalBase += res.totalBase;
                    subtotalInv += res.baseInv;
                    subtotalBase += res.baseBase;
                    taxTotalInv += res.taxInv;
                    taxTotalBase += res.taxBase;
                    discountTotalInv += res.discountInv;
                    discountTotalBase += res.discountBase;
                });
            } else {
                serviceList.forEach(svc => {
                    const res = computeService(svc);
                    servicesTotalInv += res.totalInv;
                    servicesTotalBase += res.totalBase;
                    subtotalInv += res.baseInv;
                    subtotalBase += res.baseBase;
                    taxTotalInv += res.taxInv;
                    taxTotalBase += res.taxBase;
                    discountTotalInv += res.discountInv;
                    discountTotalBase += res.discountBase;
                });
            }
        } else {
            //  const res = computeService(svc);
            servicesTotalInv += this.state.completed.cctotalprice;
            servicesTotalBase += this.state.completed.totalprice;
            subtotalInv += this.state.completed.cctotalprice;
            subtotalBase += this.state.completed.totalprice;
            taxTotalInv += this.state.completed.cctaxamount;
            taxTotalBase += this.state.completed.taxamount;
            discountTotalInv += this.state.completed.ccdiscountInv;
            discountTotalBase += this.state.completed.discountBase;
        }

        // Additional charges (unchanged)
        let additionalChargesTotalInv = 0, additionalChargesTotalBase = 0;
        additionalchargeslist.forEach(charge => {
            let amtInv = charge.ccadditionalcharges || 0;
            let amtBase = charge.additionalcharges || (amtInv * curconversionrate);
            let taxPct = charge.additionalchargestax || 0;
            let totalInv = amtInv * (1 + taxPct / 100);
            let totalBase = amtBase * (1 + taxPct / 100);
            additionalChargesTotalInv += totalInv;
            additionalChargesTotalBase += totalBase;
        });

        // Insurance (unchanged)
        let insuranceTotalInv = 0, insuranceAmtInv = 0, insuranceAmtBase = 0, insuranceTaxInv = 0, insuranceTaxBase = 0, insuranceTotalBase = 0;
        if (insuranceEnabled) {
            let baseForInsuranceInv = subtotalInv;
            let baseForInsuranceBase = subtotalBase;
            insuranceAmtInv = baseForInsuranceInv * (insurance / 100);
            insuranceAmtBase = baseForInsuranceBase * (insurance / 100);
            insuranceTaxInv = insuranceAmtInv * (insurancetax / 100);
            insuranceTaxBase = insuranceAmtBase * (insurancetax / 100);
            insuranceTotalInv = insuranceAmtInv + insuranceTaxInv;
            insuranceTotalBase = insuranceAmtBase + insuranceTaxBase;
        }

        // TCS / TDS (unchanged)
        let tcsTotalInv = 0, tcsTotalBase = 0;
        let tdsTotalInv = 0, tdsTotalBase = 0;
        if (tcsEnabled) {
            let baseForDeductionInv = subtotalInv + taxTotalInv + additionalChargesTotalInv + insuranceTotalInv;
            let baseForDeductionBase = subtotalBase + taxTotalBase + additionalChargesTotalBase + insuranceTotalBase;
            if (isTCSMode) {
                tcsTotalInv = baseForDeductionInv * (tcs / 100);
                tcsTotalBase = baseForDeductionBase * (tcs / 100);
            } else {
                tdsTotalInv = baseForDeductionInv * (tds / 100);
                tdsTotalBase = baseForDeductionBase * (tds / 100);
            }
        }

        // Grand total
        let grandTotalInv = subtotalInv + taxTotalInv + additionalChargesTotalInv + insuranceTotalInv + tcsTotalInv - tdsTotalInv;
        let grandTotalBase = subtotalBase + taxTotalBase + additionalChargesTotalBase + insuranceTotalBase + tcsTotalBase - tdsTotalBase;

        // Update state
        this.setState({
            subtotal: subtotalInv,
            ccsubtotal: subtotalBase,
            taxTotal: taxTotalInv,
            cctaxTotal: taxTotalBase,
            additionalChargesTotal: additionalChargesTotalInv,
            ccadditionalChargesTotal: additionalChargesTotalBase,
            insuranceamount: insuranceAmtInv,
            insuranceTotal: insuranceTotalInv,
            tcsTotal: tcsTotalInv,
            cctcsTotal: tcsTotalBase,
            tdsTotal: tdsTotalInv,
            cctdsTotal: tdsTotalBase,
            grandtotal: grandTotalInv,
            ccgrandtotal: grandTotalBase,
            totaltaxamount: taxTotalInv,
            cctotaltaxamount: taxTotalBase,
            totaldiscount: discountTotalInv,
            cctotaldiscount: discountTotalBase,
            totalinvoice: subtotalInv,
            cctotalinvoice: subtotalBase,
            invtotalamountwtax: grandTotalInv,
            ccinvtotalamountwtax: grandTotalBase,
            tcsableamount: grandTotalInv,
            grandservicetotal: servicesTotalInv,
            ccgrandservicetotal: servicesTotalBase,
            granditemstotal: itemsTotalInv,
            ccgranditemstotal: itemsTotalBase,
            totaliv: subtotalInv,
            cctotaliv: subtotalBase,
            totalinsuranceamount: insuranceTotalInv,
        });
    };

    // ==================== ORIGINAL METHODS (adapted) ====================

    handleServicecategory = (value, values) => {
        if (values !== "" && values && typeof values === "object") {
            this.setState({
                servicecatid: values.id,
                servicecategory: values.category,
                filterserv: this.state.serviceitemList.filter(
                    (e) => e.catid === values.id
                ),
                servicecost: "",
                servicecostwttax: "",
                servicetaxamount: "",
                milestonelist: [],
                percentagemessage: "",
                milestonesavebtn: false,
            });
        } else {
            this.setState({
                servicecatid: "",
                servicecategory: "",
                filterserv: [],
                servicecost: "",
                servicecostwttax: "",
                servicetaxamount: "",
                milestonelist: [],
                percentagemessage: "",
                milestonesavebtn: false,
            });
        }
    };

    handleService = (value, values) => {
        if (values !== "" && values && typeof values === "object") {
            this.setState({
                serviceid: values.id,
                service: values.service,
                // servicetax: this.state.taxrequired === true ? values.servicetax : 0,
                servicecode: values.servicecode,
                servicedescription: values.description,
                servicecost: "",
                servicecostwttax: "",
                servicetaxamount: "",
                milestonelist: [],
                percentagemessage: "",
                milestonesavebtn: false,
            });
        } else {
            this.setState({
                serviceid: "",
                service: "",
                servicetax: 0,
                servicecode: "",
                servicedescription: "",
                servicecost: "",
                servicecostwttax: "",
                servicetaxamount: "",
                milestonelist: [],
                percentagemessage: "",
                milestonesavebtn: false,
            });
        }
    };

    handleServiceAmountChange = (value, quantity) => {
        let val = parseFloat(value) * (quantity && quantity !== 0 ? parseFloat(quantity) : 1)
        this.setState({
            servicecost: value,
            servicecostconv:
                val * this.state.curconversionrate,
            servicetaxamount:
                (this.state.servicetax / 100) * val,
            servicecgst:
                ((this.state.servicetax / 100) * val) / 2,
            servicesgst:
                ((this.state.servicetax / 100) * val) / 2,
            serviceigst: (this.state.servicetax / 100) * val,
            servicegst: (this.state.servicetax / 100) * val,
            servicevat: (this.state.servicetax / 100) * val,
            servicecostwttax:
                val +
                (this.state.servicetax / 100) * val,
            servicecostwttaxconv:
                (val +
                    (this.state.servicetax / 100) * val) *
                this.state.curconversionrate,
        });
    };

    handleaddService = () => {
        // Run the generic validation (customer, etc.)
        const errors = this.validate(this.state);

        // Add service‑specific validation
        let serviceErrors = {};
        if (!this.state.serviceid) {
            serviceErrors.service = "Please select a service.";
        }
        if (!this.state.servicecost || parseFloat(this.state.servicecost) <= 0) {
            serviceErrors.servicecost = "Service amount must be greater than 0.";
        }
        if (!this.state.quantity || parseFloat(this.state.quantity) <= 0) {
            serviceErrors.quantity = "Quantity must be greater than 0.";
        }

        // Combine all errors
        const allErrors = { ...errors, ...serviceErrors };
        if (Object.keys(allErrors).length > 0) {
            Object.values(allErrors).forEach((value) => {
                toast(value, "error");
            });

            // Swal.fire({
            //     title: "Validation Error",
            //     html: Object.values(allErrors).join("<br/>"),
            //     icon: "error",
            //     confirmButtonText: "Ok",
            //     confirmButtonColor: "#152f5f",
            // });
            return;
        }

        // Original calculations (unchanged)

        const disc = this.state.discounttype === "%" ? this.state.servicediscount : ((this.state.servicediscountamount / (parseFloat(isInvalid.includes(this.state.servicecost) ? 0 : this.state.servicecost) +
            parseFloat(isInvalid.includes(this.state.servicemarkup) ? 0 : this.state.servicemarkup))) * 100)

        const discountamt = (
            (
                parseFloat(isInvalid.includes(this.state.servicecost) ? 0 : this.state.servicecost) +
                parseFloat(isInvalid.includes(this.state.servicemarkup) ? 0 : this.state.servicemarkup)
            ) * (parseFloat(isInvalid.includes(disc) ? 0 : disc) / 100)
        );

        const totalamount = (
            (
                parseFloat(isInvalid.includes(this.state.servicecost) ? 0 : this.state.servicecost) +
                parseFloat(isInvalid.includes(this.state.servicemarkup) ? 0 : this.state.servicemarkup) -
                discountamt
            ) * parseFloat(isInvalid.includes(this.state.quantity) ? 0 : this.state.quantity)
        );

        const totalamountinbase = (
            (
                parseFloat(isInvalid.includes(this.state.servicecost) ? 0 : this.state.servicecost) +
                parseFloat(isInvalid.includes(this.state.servicemarkup) ? 0 : this.state.servicemarkup) -
                discountamt
            ) * parseFloat(isInvalid.includes(this.state.curconversionrate) ? 1 : this.state.curconversionrate)
        ) * parseFloat(isInvalid.includes(this.state.quantity) ? 0 : this.state.quantity);

        let servicedata = {
            serviceid: this.state.serviceid,
            service: this.state.service,
            servicecategory: this.state.servicecategory,
            servicecatid: this.state.servicecatid,
            servicedescription: this.state.servicedescription,
            servicetax: this.state.servicetax,
            servicediscount: (parseFloat(isInvalid.includes(disc) ? 0 : disc) / 100),
            servicecost: (parseFloat(isInvalid.includes(this.state.servicecost) ? 0 : this.state.servicecost)) * (parseFloat(isInvalid.includes(this.state.curconversionrate) ? 1 : parseFloat(this.state.curconversionrate))),
            ccservicecost: parseFloat(isInvalid.includes(this.state.servicecost) ? 0 : this.state.servicecost),
            servicecode: this.state.servicecode,
            markup: this.state.markup * parseFloat(isInvalid.includes(this.state.curconversionrate) ? 1 : this.state.curconversionrate),
            markup1: this.state.servicemarkup * parseFloat(isInvalid.includes(this.state.curconversionrate) ? 1 : this.state.curconversionrate),
            ccmarkup: parseFloat(this.state.markup),
            ccmarkup1: parseFloat(this.state.servicemarkup),
            servicetaxamount: totalamountinbase * (this.state.servicetax / 100),
            halfservicetaxamount: totalamountinbase * ((this.state.servicetax / 2) / 100),
            ccservicetaxamount: totalamount * (this.state.servicetax / 100),
            cchalfservicetaxamount: totalamount * ((this.state.servicetax / 2) / 100),
            servicecgst: totalamountinbase * ((this.state.servicetax / 2) / 100),
            servicesgst: totalamountinbase * ((this.state.servicetax / 2) / 100),
            serviceigst: totalamountinbase * (this.state.servicetax / 100),
            servicegst: totalamountinbase * (this.state.servicetax / 100),
            servicevat: totalamountinbase * (this.state.servicetax / 100),
            quantity: !this.state.quantity || parseFloat(this.state.quantity) === 0 ? 1 : parseFloat(this.state.quantity),
            servicetotal: totalamountinbase,
            ccservicetotal: totalamount,
            servicediscount: parseFloat(isInvalid.includes(disc) ? 0 : disc),
            servicediscountamount: discountamt * parseFloat(isInvalid.includes(this.state.curconversionrate) ? 1 : this.state.curconversionrate),
            ccservicediscountamount: discountamt,
            servicetotalwtax: totalamountinbase + (totalamountinbase * (this.state.servicetax / 100)),
            ccservicetotalwtax: totalamount + (totalamount * (this.state.servicetax / 100)),
            servicecompleted: 0,
            recurrencetill: this.state.recurrencetill,
        };
        console.log(servicedata)
        // Determine if this is an update or addition
        const isUpdate = this.state.serviceeditIndex !== null;

        if (isUpdate) {
            const ss = this.state.serviceList[this.state.serviceeditIndex];
            if (ss.id) {
                servicedata = { ...servicedata, id: ss.id };
            }
            this.state.serviceList.splice(this.state.serviceeditIndex, 1, servicedata);
        } else {
            this.state.serviceList.push(servicedata);
        }

        this.setState({
            serviceeditIndex: null,
            quantity: 0,
            serviceList: [...this.state.serviceList],
            serviceErrors: {},
        }, () => {
            this.recomputeTotals();
            toast("Service Added", "success");
            // Swal.fire({
            //     icon: 'success',
            //     title: 'Success',
            //     text: `Service ${isUpdate ? 'updated' : 'added'} to the list.`,
            //     timer: 1500,
            //     showConfirmButton: false
            // });
        });
    };

    handleCustomer = (value, values) => {
        if (values !== "" && typeof values === "object" && values !== null) {
            SalesServices.GetCustomerTerms(values.id).then((res) =>
                SalesServices.IsPaymentPending(values.id).then((response) => {
                    if (
                        response.data &&
                        res.data !== null &&
                        res.data.creditstatus === "Required"
                    ) {
                        Swal.fire({
                            title: 'Pending payment from customer!',
                            text: "Payment is due from the customer, please settle it before continuing",
                            icon: "warning",
                            confirmButtonColor: "#152f5f",
                        }).then(() =>
                            this.setState({
                                custid: "",
                                customer: "",
                                saleorderid: "",
                                customerdetails: "",
                                saleorderdata: [],
                                accepteditems: [],
                                tcsableamount: 0,
                                totaladditionalcharges: 0,
                                invoiceadditionalcharges: 0,
                                invoiceadditionalchargestax: 0,
                            }, this.recomputeTotals)
                        )
                    } else {
                        this.setState({
                            custid: values.id,
                            customer: values.companyname,
                            debitamount: values.debitamount,
                            openingbalance: values.openingbalance,
                            adjustopen: false,
                            adjustdebit: values.debitamount > 0 ? true : false,
                            einvoice:
                                this.state.einvoice && values.countryname === "India"
                                    ? true
                                    : false,
                            saleorderid: "",
                            tcsableamount: 0,
                            totaladditionalcharges: 0,
                            invoiceadditionalcharges: 0,
                            invoiceadditionalchargestax: 0,
                            name: values.companyname,
                            phoneno: values.contactnumber,
                            pincode: values.zip,
                            state: values.statename,
                            city: values.cityname,
                            houseno: values.address,
                            areaname: values.address2,
                            country: values.countryname,
                            billname: values.companyname,
                            billphoneno: values.contactnumber,
                            billpincode: values.zip,
                            billstate: values.statename,
                            billstatecode: values.statecode,
                            billcity: values.cityname,
                            billhouseno: values.address,
                            billareaname: values.address2,
                            billcountry: values.countryname,
                            statecode: values.statecode,
                            currency: values.currency,
                            currencyid: this.state.currencylist.find(
                                (e) => e.currency === values.currency
                            ).id,
                            taxtype: values.taxtype,
                            gsttype:
                                values.statename === cstate && values.countryname === "India"
                                    ? "INTRASTATE"
                                    : "INTERSTATE",
                            convertionreq:
                                values.currency === this.state.basecurrency ? false : true,
                        });

                        const id = values.id;
                        datalist = [];

                        let selectedcustomer = this.state.custom.filter(
                            (customer) => customer.id === id
                        );
                        this.setState({ customerdetails: selectedcustomer });

                        let datadao = {
                            tenantid: currentTenant,
                            startdate: financialyearstart,
                            enddate: financialyearend,
                            userid: userid,
                            dataaccess: dataaccess,
                            whid: userwhid,
                            id: id,
                            poupload: this.state.pouploadm === "YES" ? true : false,
                        };

                        if (this.state.pagename === "New Proforma Invoice") {
                            SalesServices.GetSObycustidforProformaInvoice(datadao)
                                .then((res) =>
                                    this.setState({
                                        saleorderdata: res.data,
                                        accepteditems: [],
                                    }, this.recomputeTotals)
                                )
                                .catch((e) => {
                                    if (e.response.data.error === "Unauthorized") {
                                        alert("Your Session is Lost: Please login Back to resume");
                                        this.props.navigate(`/`);
                                    }
                                });
                        } else {
                            if (this.state.settings.salesautojre === "YES") {
                                if (values.ledgerid === null || values.ledgerid === "" || values.ledgerid === undefined) {
                                    Swal.fire({
                                        title: '',
                                        text: "As ledger is not created for the customer journal entry cannot be auto inserted, please do the manual entry.",
                                        icon: "warning",
                                        confirmButtonColor: "#152f5f",
                                    }).then(() => this.setState({ autojre: false }))
                                } else {
                                    this.setState({ autojre: true })
                                }
                            } else {
                                this.setState({ autojre: false })
                            }
                            SalesServices.getSoByCustidForInvoice(datadao)
                                .then((res) =>
                                    this.setState({
                                        saleorderdata: res.data,
                                    })
                                )
                                .catch((e) => {
                                    if (e.response.data.error === "Unauthorized") {
                                        alert("Your Session is Lost: Please login Back to resume");
                                        this.props.navigate(`/`);
                                    }
                                });

                            MasterService.getDistance(this.state.dispincode, values.zip).then(
                                (res) => this.setState({ distance: res.data === '' || res.data === null || res.data === undefined ? 0 : res.data })
                            );
                        }
                    }
                })
            );
        } else {
            this.setState({
                custid: "",
                customer: "",
                saleorderid: "",
                customerdetails: "",
                saleorderdata: [],
                accepteditems: [],
                tcsableamount: 0,
                totaladditionalcharges: 0,
                invoiceadditionalcharges: 0,
                invoiceadditionalchargestax: 0,
            }, this.recomputeTotals);
        }
    };

    handleWarehouse = (value, values) => {
        if (values !== "" && typeof values === "object" && values !== null) {
            this.setState({
                warehouse: values.name,
                whid: values.id,
                deptid: "",
                department: "",
                itemname: "",
                hsnid: "",
                hsn: "",
                quantity: "",
                price: "",
                type: "",
                uom: "",
                uomid: "",
                description: "",
            });
            DepartmentServices.deptbywarehouse(values.id).then((response) => {
                this.setState({
                    DepartmentList: response.data
                })
                if (response.data.length === 1) {
                    this.setState({
                        department: response.data[0].name,
                        deptid: response.data[0].id
                    })
                }
            });
        } else {
            this.setState({ warehouse: "", whid: "" });
        }
    };

    handleDepartment = (value, values) => {
        if (values !== "" && typeof values === 'object' && values !== null) {
            this.setState({
                department: values.name,
                deptid: values.id
            })
        } else {
            this.setState({ department: '', deptid: '' })
        }
    }

    handleCategory = (value, values) => {

        if (values !== "" && typeof values === "object" && values !== null && this.state.custid) {
            this.setState({
                categoryid: values.id,
                category: values.category,
                filteritemlist: this.state.itemList.filter(
                    (e) => e.catid === values.id
                ),
                itemid: "",
                itemname: "",
                hsn: "",
                tax: "",
                price: "",
                quantity: "",
            });
        } else {
            if (!this.state.custid) {
                toast("Please Select Customer", "warning")
            }
            this.setState({
                categoryid: "",
                category: "",
                filteritemlist: [],
                itemid: "",
                itemname: "",
                hsn: "",
                tax: "",
                price: "",
                quantity: "",
            });

        }

    };

    handleitem = (value, values) => {
        if (this.state.whid === "" || this.state.warehouse === "") {
            alert("Please Select Org Unit");
        } else {
            if (values !== "" && typeof values === "object" && values !== null) {
                this.setState({
                    itemid: values.itemid,
                    itemname: values.name,
                    quantity: "",
                    totalpricewtax: "",
                });
                const id = values.itemid;
                let itemdata = this.state.itemList.filter((e) => e.itemid === id);
                itemdata.map((data) =>
                    this.setState({
                        type:
                            this.state.salescalreq === "YES"
                                ? "LIFO"
                                : data.type === null || data.type === undefined
                                    ? "LIFO"
                                    : data.type,
                        price: data.price / (isInvalid.includes(this.state.curconversionrate) ? 1 : parseFloat(this.state.curconversionrate)),
                        markup1: data.markup1 / (isInvalid.includes(this.state.curconversionrate) ? 1 : parseFloat(this.state.curconversionrate)),
                        markup: data.markup / (isInvalid.includes(this.state.curconversionrate) ? 1 : parseFloat(this.state.curconversionrate)),
                        hsn: data.hsn,
                        uom: data.uom,
                        uomid: data.uomid,
                        brand: data.brand,
                        model: data.model,
                        // tax: this.state.taxrequired === true ? data.tax : 0,
                        // cgst: this.state.taxrequired === true ? data.tax / 2 : 0,
                        // sgst: this.state.taxrequired === true ? data.tax / 2 : 0,
                        additionalparams: data.additionalparams,
                        description: data.description,
                    })
                );
                let warehousedata = this.state.whdata.filter(
                    (e) => e.whid === this.state.whid
                );
                let saleslist = warehousedata.find((e) => e).saleslist;
                let a = saleslist.filter((e) => e.itemid === id);
                let stock = a.reduce(
                    (total, currentValue) => (total = total + currentValue.currentstock),
                    0
                );
                this.setState({ stock: stock });
                SalesCalculationServices.costType(values.itemid, 0).then((res) => this.setState({ avgprice: res.data }))
                SalesCalculationServices.costType(values.itemid, 1).then((res) => this.setState({ fifoprice: res.data }))
                SalesCalculationServices.costType(values.itemid, 2).then((res) => this.setState({ lifoprice: res.data }))
            } else {
                this.setState({ itemname: "", itemid: "" });
            }
        }
    };

    handleSelectDiscountType = (e) => {
        this.setState({ discounttype: e.target.value, discount: 0, discountamount: 0, servicediscountamount: 0, servicediscount: 0 });
    }

    handleDiscountChange = (e) => {
        if (this.state.discounttype === "%") {
            this.setState({ discount: e.target.value, discountamount: 0 })
        } else {
            this.setState({ discount: 0, discountamount: e.target.value })
        }
    }

    handleServiceDiscountChange = (e) => {
        if (this.state.discounttype === "%") {
            this.setState({ servicediscount: e.target.value, servicediscountamount: 0 })
        } else {
            this.setState({ servicediscount: 0, servicediscountamount: e.target.value })
        }
    }
    handleTypeChange = (e) => {
        this.setState({ type: e.target.value });
    };

    handlemarkup1Change = (e) => {
        this.setState({
            markup1: e.target.value,
        })
    }

    handleSize = (value, values) => {
        if (
            value !== "" &&
            this.state.sizelist.includes(values) &&
            values !== null
        ) {
            this.setState({ size: values });
        } else {
            this.setState({ size: "" });
        }
    };

    handleColour = (value, values) => {
        if (
            values !== "" &&
            this.state.colourlist.includes(values) &&
            values !== null
        ) {
            this.setState({ colour: values });
        } else {
            this.setState({ colour: "" });
        }
    };

    handlemilestonestatus = (i) => {
        this.state.milestones.find((e, index) => index === i).servicestatus =
            "Completed";
        this.setState({
            completed: this.state.milestones.find((e, index) => index === i),
        }, () => this.recomputeTotals());
    };

    handleSaleOrder = (value, values) => {
        if (
            values !== "" &&
            this.state.saleorderdata.includes(values) &&
            values !== null
        ) {
            this.setState({
                saleorderid: values,
                tcsableamount: 0,
                totaladditionalcharges: 0,
                invoiceadditionalcharges: 0,
                invoiceadditionalchargestax: 0,
            });
            const id = values;
            datalist = [];

            SalesServices.GetDataforInvoice(id).then((response) =>
                this.setState({
                    sodata: response.data,
                    agent: response.data.agent,
                    agentid: response.data.agentid,
                    whid: response.data.whid,
                    deptid: response.data.deptid,
                    currency: response.data.currency,
                    curconversionrate: response.data.curconversionrate,
                    gsttype: response.data.gsttype,
                    taxtype: response.data.taxtype,
                    serviceList: response.data.servicelist,
                    saleorderitems: response.data.saleorderitems,
                    serviceid:
                        response.data.sotype === 1
                            ? response.data.servicelist.find((e) => e).serviceid
                            : "",
                    milestones:
                        response.data.sotype === 1
                            ? response.data.servicelist.find((e) => e).milestones
                            : [],
                    contracttype:
                        response.data.sotype === 1
                            ? response.data.servicelist.find((e) => e).contracttype
                            : "",
                    totaltaxamount: response.data.totaltaxamount,
                    totaliv: response.data.totaliv,
                    grandtotal: response.data.grandtotalproducttotal,
                    grandservicetotal: response.data.grandservicetotal,
                    sotype: response.data.sotype,
                    creditperiod:
                        response.data.creditperiod === null ||
                            response.data.creditperiod === undefined
                            ? 0
                            : response.data.creditperiod,
                    accepteditems:
                        this.state.pagename === "New Proforma Invoice" ||
                            response.data.sotype === 2
                            ? response.data.saleorderitems
                            : [],
                    completed:
                        response.data.sotype === 1 &&
                            this.state.pagename === "New Proforma Invoice"
                            ? response.data.servicelist.find((e) => e).milestones[0]
                            : "",
                    addservice: response.data.sotype === 2 ? true : false,
                    pricevariance: response.data.pricevariance,
                    curconversionrate: response.data.curconversionrate,
                    currency: response.data.currency,
                    convertionreq: response.data.currency === currency ? false : true,
                    multiCurrency: response.data.currency !== currency
                }, this.recomputeTotals)
            );
        } else {
            this.setState({
                saleorderid: "",
                DnIDList: [],
                accepteditems: [],
                sodata: "",
                serviceList: [],
                saleorderitems: [],
                serviceid: "",
                milestones: [],
                contracttype: "",
                totaltaxamount: 0,
                totaliv: 0,
                grandtotal: 0,
                grandservicetotal: 0,
                sotype: 0,
                tcsableamount: 0,
                totaladditionalcharges: 0,
                invoiceadditionalcharges: 0,
                invoiceadditionalchargestax: 0,
            }, this.recomputeTotals);
        }
    };

    TransporteridChange = (e) => {
        this.setState({ transporterid: e.target.value?.trim().toUpperCase() });
        if (this.state.einvoice) {
            if (e.target.value.length === 15) {
                let data = {
                    tenantId: currentTenant,
                    reqparam: e.target.value.trim().toUpperCase(),
                };
                SalesServices.validateGSTIN(data)
                    .then((response) => {
                        if (
                            response.data.body === null ||
                            response.data.body.statusCodeValue === 400
                        ) {
                            this.setState({ err: true, validtrnsid: false });
                            Swal.fire({
                                title: `Invalid Transporter ID`,
                                text: "",
                                icon: "error",
                                confirmButtonText: "Ok",
                                confirmButtonColor: "#152f5f",
                            });
                        } else {
                            this.setState({ validtrnsid: true, err: false });
                        }
                    })
                    .catch(() => this.setState({ err: true, validtrnsid: false }));
            } else {
                this.setState({
                    err: false,
                    validtrnsid: false,
                });
            }
        } else {
            this.setState({
                transporterid: e.target.value,
                err: false,
                validtrnsid: true,
            });
        }
    };

    handleinsurancereq = (e) => {
        this.setState({ insurancereq: !this.state.insurancereq });
    };

    handleInsuranceChange = (e) => {
        this.setState({
            insurance: e.target.value === "" ? 0 : parseFloat(e.target.value),
        }, this.recomputeTotals);
    };

    handleInsuranceAmount = (e) => {
        this.setState({
            insuranceamount: e.target.value === "" ? 0 : parseFloat(e.target.value),
        }, this.recomputeTotals);
    };

    handleInsuranceTax = (e) => {
        this.setState({
            insurancetax: parseFloat(e.target.value),
        }, this.recomputeTotals);
    };

    handleDefaultadd = () => {
        let data = this.state.custom.find((e) => e.id === this.state.custid);
        this.setState(
            {
                defaultadd: !this.state.defaultadd,
            },
            () => {
                if (this.state.defaultadd === true && data) {
                    this.setState({
                        name: data.companyname,
                        phoneno: data.contactnumber,
                        pincode: data.zip,
                        state: data.statename,
                        city: data.cityname,
                        houseno: data.address,
                        areaname: data.address2,
                        country: data.countryname,
                        statecode: data.statecode,
                    });
                } else {
                    this.setState({
                        name: "",
                        phoneno: "",
                        pincode: "",
                        state: "",
                        city: "",
                        houseno: "",
                        areaname: "",
                        country: "",
                        statecode: ""
                    });
                }
            }
        );
    };

    handleDefaultdisadd = () => {
        this.setState(
            {
                defaultdisadd: !this.state.defaultdisadd,
            },
            () => {
                if (this.state.defaultdisadd === true) {
                    this.setState({
                        disname: clientname || "",
                        disphoneno: contactnumber || "",
                        dispincode: czip || "",
                        disstate: cstate || "",
                        disstatecode: cstatecode || "",
                        discity: ccity || "",
                        dishouseno: address || "",
                        disareaname: address2 || "",
                        discountry: ccountry || "",
                    });
                } else {
                    this.setState({
                        disname: "",
                        disphoneno: "",
                        dispincode: "",
                        disstate: "",
                        discity: "",
                        dishouseno: "",
                        disareaname: "",
                        discountry: "",
                        disstatecode: "",
                    });
                }
            }
        );
    };
    handleDNreq = () => {
        this.setState({
            dnrequired: !this.state.dnrequired,
        });
    };

    handleCountryChange = (e, newValue) => {
        if (newValue === "" || newValue === null || newValue === undefined) {
        } else {
            this.setState({
                country: newValue.name,
                StatesData: newValue.states,
                err: false,
            });
        }
    };

    handleStateChange = (e, newValue) => {
        if (newValue === "" || newValue === null || newValue === undefined) {
        } else {
            this.setState({
                state: newValue.name,
                statecode: newValue.code,
                CitiesData: newValue.cities,
                err: false,
            });
        }
    };
    handleCityChange = (e, newValue) => {
        if (newValue === "" || newValue === null || newValue === undefined) {
        } else {
            this.setState({ city: newValue.name, err: false });
        }
    };

    handleDisCountryChange = (e, newValue) => {
        if (newValue === "" || newValue === null || newValue === undefined) {
        } else {
            this.setState({
                discountry: newValue.name,
                disStatesData: newValue.states,
                err: false,
            });
        }
    };

    handleDisStateChange = (e, newValue) => {
        if (newValue === "" || newValue === null || newValue === undefined) {
        } else {
            this.setState({
                disstate: newValue.name,
                disstatecode: newValue.code,
                disCitiesData: newValue.cities,
                err: false,
            });
        }
    };
    handleDisCityChange = (e, newValue) => {
        if (newValue === "" || newValue === null || newValue === undefined) {
        } else {
            this.setState({ discity: newValue.name, err: false });
        }
    };

    handletcsreq = (e) => {
        this.setState({ tcsreq: !this.state.tcsreq });
    };
    handletcsChange = (e) => {
        const dtcs = this.state.tcsableamount.toFixed(2)
        const tcsamt = ((parseFloat(e.target.value) / 100) * parseFloat(dtcs)).toFixed(2)
        console.log(parseFloat(e.target.value) / 100, dtcs, tcsamt)
        this.setState({
            tcs: parseFloat(e.target.value),
            tcsamount: parseFloat(tcsamt),
        }, this.recomputeTotals);
    };

    handledownload = (file) => {
        downloadfiles.download(this.state.sodata.popath, this.state.sodata.pofile);
    };

    handleAccept = (id) => {
        let itemsdetails = this.state.saleorderitems.filter(
            (data) => data.id === id
        );
        this.setState({ quantity: "", description: "", show: 1 });
        itemsdetails.map((data) =>
            this.setState(
                {
                    soitemdata: data,
                    id: data.id,
                    itemid: data.itemid,
                    itemname: data.name,
                    hsn: data.hsn,
                    price: data.price,
                    salesenum: data.salesenum,
                    tax: data.tax,
                    categoryid: data.categoryid,
                    taxamount: data.taxamount,
                    markup: data.markup,
                    markup1: data.markup1,
                    orderedquantity: parseFloat(data.quantity),
                    pendingquantity: parseFloat(data.pending),
                    uom: data.uom,
                    totalprice: data.totalprice,
                    brand: data.brand,
                    colour: data.colour,
                    totalpricewtax: data.totalpricewtax,
                    size: data.size,
                    thickness: data.thickness,
                    totalmtrroll: data.totalmtrroll,
                    description: data.description,
                    insurance: data.insurance,
                    discount: data.discount,
                    discountamount: data.discountamount,
                    pricevariance: data.pricevariance,
                    fifoprice: data.fifoprice,
                    lifoprice: data.lifoprice,
                    avgprice: data.avgprice,
                    additionalchargestax: 0,
                    additionalcharges: 0,
                    totaladditionalcharges: 0,
                    additionalchargestaxamount: 0,
                    natureofcharge: "",
                    type: data.salesenum
                },
                () =>
                    this.setState({
                        itemstock: this.state.whdata
                            ?.find((e) => e.whid === this.state.sodata.whid)
                            ?.saleslist?.find((e) => e.itemid === this.state.itemid)
                            ?.totalstock,
                        itemquantitylist: this.state.whdata
                            .find((e) => e.whid === this.state.sodata.whid)
                            .saleslist.filter(
                                (sl) => sl.itemid === this.state.itemid && sl.currentstock !== 0
                            )
                            .map((e) => Object.assign(e, { enteredquantity: 0 })),
                    })
            )
        );
    };

    AdditionalCharges = () => {
        if (
            this.state.additionalcharges === "" ||
            this.state.natureofcharge === ""
        ) {
            this.setState({ adderr: true });
        } else {
            let data = this.state.additionalchargeslist;
            data.push({
                additionalcharges: this.state.additionalcharges * this.state.curconversionrate,
                ccadditionalcharges: this.state.additionalcharges,
                additionalchargestax: this.state.additionalchargestax,
                additionalchargestaxamount: this.state.additionalchargestaxamount * this.state.curconversionrate,
                ccadditionalchargestaxamount: this.state.additionalchargestaxamount,
                totaladditionalcharges: parseFloat(this.state.totaladditionalcharges) * this.state.curconversionrate,
                cctotaladditionalcharges: parseFloat(this.state.totaladditionalcharges),
                natureofcharge: this.state.natureofcharge,
            });
            this.setState({
                additionalchargeslist: data,
                additionalcharges: 0,
                additionalchargestax: 0,
                additionalchargestaxamount: 0,
                totaladditionalcharges: 0,
                invoiceadditionalcharges: this.state.invoiceadditionalcharges + (parseFloat(this.state.totaladditionalcharges) * this.state.curconversionrate),
                invoiceadditionalchargestax: this.state.invoiceadditionalchargestax + (parseFloat(this.state.additionalchargestaxamount) * this.state.curconversionrate),
                ccinvoiceadditionalcharges: this.state.ccinvoiceadditionalcharges + (parseFloat(this.state.totaladditionalcharges)),
                ccinvoiceadditionalchargestax: this.state.ccinvoiceadditionalchargestax + (parseFloat(this.state.additionalchargestaxamount)),
                natureofcharge: "",
            }, () => {
                this.recomputeTotals();
                if (this.state.autojre) {
                    Swal.fire({
                        title: '',
                        text: "As you are adding additional charges Auto journal entry is not possible, please do the manual entry.",
                        icon: "warning",
                        confirmButtonColor: "#152f5f",
                    })
                }
            });
        }
    };

    RemoveAdditionalCharges = (i) => {
        let data = this.state.additionalchargeslist.filter((e, idx) => idx !== i);
        this.setState({
            additionalchargeslist: data,
        }, this.recomputeTotals);
    };

    handleTransporterChange = (value, newValue) => {
        if (newValue === "" || newValue === null || newValue === undefined) {
            this.setState({
                transportername: "",
                transporterid: "",
                validtrnsid: false,
            });
        } else {
            this.setState({
                transportername: newValue.transname,
                transporterid: newValue.transid,
                validtrnsid: true,
            });
        }
    };
    onSubmit() {
        // --- Customer validation (for Only Products & Products and Services) ---
        if (this.state.sotype === 0 || this.state.sotype === 2) {
            if (!this.state.custid || this.state.custid === "") {
                // Swal.fire({
                //     title: "Validation Error",
                //     text: "Please select a Customer before adding a product.",
                //     icon: "error",
                //     confirmButtonText: "Ok",
                //     confirmButtonColor: "#152f5f",
                // });
                toast("Please select a Customer before adding a product", "error")
                return;
            }
            // --- Quantity validation ---
            if (!this.state.quantity || this.state.quantity === "" || parseFloat(this.state.quantity) <= 0) {
                // Swal.fire({
                //     title: "Validation Error",
                //     text: "Please enter a valid Quantity (must be greater than 0).",
                //     icon: "error",
                //     confirmButtonText: "Ok",
                //     confirmButtonColor: "#152f5f",
                // });
                toast("Please enter a valid Quantity (must be greater than 0).", "error")

                return;
            }
        }

        if (this.state.quantity === "0") {
            return;
        }

        const baseamount = parseFloat(this.state.convertionreq ? this.state.price * this.state.curconversionrate : this.state.price);
        const basemarkup = parseFloat(this.state.convertionreq ? (parseFloat(isInvalid.includes(this.state.markup1) ? 0 : parseFloat(this.state.markup1)) * this.state.curconversionrate) : parseFloat(isInvalid.includes(this.state.markup1) ? 0 : this.state.markup1));
        const ccamount = parseFloat(this.state.price);
        const ccmarkup = parseFloat(isInvalid.includes(this.state.markup1) ? 0 : this.state.markup1);


        if (this.state.invtype === "Order Invoice") {
            // Order Invoice logic (no editing support – always "added")
            let disc = (this.state.price * this.state.discount) / 100;
            let ccdisc = (this.state.soitemdata?.ccprice * this.state.discount) / 100;
            let halftaxroundoff = ((parseFloat(this.state.tax / 2) * ((this.state.price - disc) * parseFloat(this.state.quantity))) / 100).toFixed(2);
            let cchalftaxroundoff = ((parseFloat(this.state.tax / 2) * ((this.state.soitemdata?.ccprice - ccdisc) * parseFloat(this.state.quantity))) / 100).toFixed(2);
            let taxroundoff = this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE"
                ? (parseFloat(halftaxroundoff) + parseFloat(halftaxroundoff))
                : ((parseFloat(this.state.tax) * ((this.state.price - disc) * parseFloat(this.state.quantity))) / 100).toFixed(2);
            let cctaxroundoff = this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE"
                ? (parseFloat(cchalftaxroundoff) + parseFloat(cchalftaxroundoff))
                : ((parseFloat(this.state.tax) * ((this.state.soitemdata?.ccprice - disc) * parseFloat(this.state.quantity))) / 100).toFixed(2);

            let totalpriceroundoff = ((this.state.price - disc) * parseFloat(this.state.quantity)).toFixed(2);
            let cctotalpriceroundoff = ((this.state.soitemdata?.ccprice - ccdisc) * parseFloat(this.state.quantity)).toFixed(2);

            let list = {
                id: this.state.id,
                soitemid: this.state.id,
                itemid: this.state.itemid,
                name: this.state.itemname,
                hsn: this.state.hsn,
                baseprice: this.state.soitemdata.price,
                ccbaseprice: this.state.soitemdata.ccprice,
                categoryid: this.state.categoryid,
                quantity: parseFloat(this.state.quantity),
                price: this.state.price,
                ccprice: this.state.soitemdata?.ccprice,
                markup: this.state.markup,
                ccmarkup1: isInvalid.includes(this.state.soitemdata.ccmarkup1) ? 0 : this.state.soitemdata.markup1,
                salesenum: this.state.salesenum,
                tax: this.state.tax,
                discount: this.state.discount,
                discountamount: disc * parseFloat(this.state.quantity),
                ccdiscountamount: ccdisc * parseFloat(this.state.quantity),
                taxamount: parseFloat(taxroundoff),
                cctaxamount: parseFloat(cctaxroundoff),
                description: this.state.description,
                totalprice: parseFloat(totalpriceroundoff),
                cctotalprice: parseFloat(cctotalpriceroundoff),
                pending: this.state.pendingquantity - this.state.quantity,
                uom: this.state.uom,
                brand: this.state.brand,
                colour: this.state.colour,
                totalpricewtax: parseFloat(taxroundoff) + parseFloat(totalpriceroundoff) + parseFloat(this.state.totaladditionalcharges),
                cctotalpricewtax: parseFloat(cctaxroundoff) + parseFloat(cctotalpriceroundoff),
                size: this.state.size,
                thickness: this.state.thickness,
                totalmtrroll: this.state.totalmtrroll,
                pricevariance: this.state.pricevariance,
                fifoprice: this.state.fifoprice,
                lifoprice: this.state.lifoprice,
                avgprice: this.state.avgprice,
                additionalchargestax: this.state.additionalchargestax,
                additionalcharges: this.state.additionalcharges,
                totaladditionalcharges: this.state.totaladditionalcharges,
                additionalchargestaxamount: this.state.additionalchargestaxamount,
                natureofcharge: this.state.natureofcharge,
            };
            console.log(list)
            datalist.push(list);
            let checklist = datalist.filter(e => e.categoryid !== this.state.categoryid);
            if (checklist.length > 0 && this.state.autojre) {
                // Swal.fire({
                //     title: '',
                //     text: "As different ledger are added journal entry cannot be auto inserted, please do the manual entry.",
                //     icon: "warning",
                //     confirmButtonColor: "#152f5f",
                // });
                toast("As different ledger are added journal entry cannot be auto inserted, please do the manual entry.", "warning")
            }

            if (this.state.pendingquantity === 0) {
                this.setState({
                    saleorderitems: this.state.saleorderitems.filter((data) => data.id !== this.state.id),
                });
            } else {
                this.state.saleorderitems.find((e) => e.id === this.state.id).pending =
                    this.state.saleorderitems.find((e) => e.id === this.state.id).pending - this.state.quantity;
            }

            let data = this.state.itemquantitylist;
            let am = data.filter((a) => a.enteredquantity !== 0);
            am.map(
                (a) =>
                (this.state.whdata
                    .find((e) => e.whid === this.state.sodata.whid)
                    .saleslist.find((sl) => sl.batchid === a.batchid).currentstock =
                    this.state.whdata
                        .find((e) => e.whid === this.state.sodata.whid)
                        .saleslist.find((sl) => sl.batchid === a.batchid).currentstock -
                    a.enteredquantity)
            );

            this.setState(
                {
                    accepteditems: datalist,
                    quantity: "",
                    show: 0,
                    description: "",
                    additionalchargestax: 0,
                    additionalcharges: 0,
                    totaladditionalcharges: 0,
                    natureofcharge: "",
                    autojre: this.state.autojre && checklist.length === 0 ? true : false,
                },
                () => {
                    this.recomputeTotals();

                    // Swal.fire({
                    //     icon: 'success',
                    //     title: 'Success',
                    //     text: 'Product added successfully.',
                    //     timer: 1500,
                    //     showConfirmButton: false
                    // });
                    toast("Product added successfully", "success")
                }
            );
        } else {
            // Direct Invoice – can be add or edit
            let price = (baseamount + basemarkup) + ((baseamount + basemarkup) * parseFloat(isInvalid.includes(this.state.pricevariance) ? 0 : this.state.pricevariance)) / 100;
            let ccprice = (ccamount + ccmarkup);
            const disc = this.state.discounttype === "%" ? this.state.discount : parseFloat(((this.state.discountamount / ccprice) * 100).toFixed(3))

            let d = ((parseFloat(price) * parseFloat(isInvalid.includes(disc) ? 0 : disc)) / 100);
            let ccd = ((parseFloat(ccprice) * parseFloat(isInvalid.includes(disc) ? 0 : disc)) / 100);

            let halftaxroundoff = this.state.taxrequired === false || this.state.taxrequired === "NA" ? 0 : ((parseFloat(this.state.tax / 2) * ((price - d) * parseFloat(this.state.quantity))) / 100).toFixed(2);
            let taxroundoff = this.state.taxrequired === false || this.state.taxrequired === "NA" ? 0 : this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE"
                ? (parseFloat(halftaxroundoff) + parseFloat(halftaxroundoff))
                : ((parseFloat(this.state.tax) * ((price - d) * parseFloat(this.state.quantity))) / 100).toFixed(2);
            let totalpriceroundoff = ((price - d) * parseFloat(this.state.quantity)).toFixed(2);

            let cchalftaxroundoff = [false, "NA"].includes(this.state.taxrequired) ? 0 : ((parseFloat(this.state.tax / 2) * ((ccprice - ccd) * parseFloat(this.state.quantity))) / 100).toFixed(2);
            let cctaxroundoff = [false, "NA"].includes(this.state.taxrequired) ? 0 : this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE"
                ? (parseFloat(cchalftaxroundoff) + parseFloat(cchalftaxroundoff))
                : ((parseFloat(this.state.tax) * ((ccprice - ccd) * parseFloat(this.state.quantity))) / 100).toFixed(2);
            let cctotalpriceroundoff = ((ccprice - ccd) * parseFloat(this.state.quantity)).toFixed(2);

            let list = {
                id: this.state.id,
                soitemid: this.state.id,
                itemid: this.state.itemid,
                name: this.state.itemname,
                hsn: this.state.hsn,
                categoryid: this.state.categoryid,
                quantity: parseFloat(this.state.quantity),
                baseprice: parseFloat(baseamount),
                ccbaseprice: parseFloat(ccamount),
                price: parseFloat(price),
                ccprice: parseFloat(ccprice),
                markup1: basemarkup,
                ccmarkup1: ccmarkup,
                markup: this.state.markup,
                salesenum: this.state.type,
                tax: this.state.taxrequired === false || this.state.taxrequired === "NA" ? 0 : this.state.tax,
                discount: isInvalid.includes(disc) ? 0 : parseFloat(disc),
                discountamount: d * parseFloat(this.state.quantity),
                ccdiscountamount: ccd * parseFloat(this.state.quantity),
                taxamount: parseFloat(taxroundoff),
                cctaxamount: parseFloat(cctaxroundoff),
                description: this.state.description,
                totalprice: parseFloat(totalpriceroundoff),
                cctotalprice: parseFloat(cctotalpriceroundoff),
                totalpricewtax: parseFloat(totalpriceroundoff) + parseFloat(taxroundoff),
                cctotalpricewtax: parseFloat(cctotalpriceroundoff) + parseFloat(cctaxroundoff),
                pending: 0,
                uom: this.state.uom,
                brand: this.state.brand,
                colour: this.state.colour,
                size: this.state.size,
                thickness: this.state.thickness,
                totalmtrroll: this.state.totalmtrroll,
                pricevariance: this.state.pricevariance,
                fifoprice: this.state.fifoprice,
                lifoprice: this.state.lifoprice,
                avgprice: this.state.avgprice,
                additionalchargestax: this.state.additionalchargestax,
                additionalcharges: this.state.additionalcharges,
                totaladditionalcharges: this.state.totaladditionalcharges,
                additionalchargestaxamount: this.state.additionalchargestaxamount,
                natureofcharge: this.state.natureofcharge,
            };

            // Capture whether this is an update BEFORE pushing to datalist
            const isProductUpdate = this.state.itemeditIndex !== null;

            if (isProductUpdate) {
                // Replace the item at the edit index instead of pushing
                // Note: The original code simply pushes; we need to handle edit differently.
                // The original logic in onSubmit does not differentiate; it always pushes.
                // To support edit, we should replace the item at the stored index.
                // But currently datalist is built from scratch? Actually datalist is a global variable.
                // We'll implement edit by replacing in datalist.

                // First, get current accepteditems (which should be in sync with datalist)
                const currentItems = [...this.state.accepteditems];
                // Replace at the stored index
                currentItems[this.state.itemeditIndex] = list;
                datalist = currentItems;
            } else {
                datalist.push(list);
            }

            let checklist = datalist.filter(e => e.categoryid !== this.state.categoryid);
            if (this.state.autojre && checklist.length > 0) {
                toast(`As different ledger are added journal entry cannot be auto inserted, please do the manual entry.`, "warning")
                // Swal.fire({
                //     title: '',
                //     text: "As different ledger are added journal entry cannot be auto inserted, please do the manual entry.",
                //     icon: "warning",
                //     confirmButtonColor: "#152f5f",
                // });
            }

            this.setState(
                {
                    accepteditems: datalist,
                    itemeditIndex: null, // reset edit index
                    autojre: this.state.autojre && checklist.length === 0 ? true : false,
                    quantity: "",
                    totalpricewtax: "",
                    show: 0
                },
                () => {
                    this.recomputeTotals();
                    toast(`Product ${isProductUpdate ? 'updated' : 'added'} to the List.`, "success")
                    // Swal.fire({
                    //     icon: 'success',
                    //     title: 'Success',
                    //     text: `Product ${isProductUpdate ? 'updated' : 'added'} to the List.`,
                    //     timer: 1500,
                    //     showConfirmButton: false
                    // });
                }
            );
        }
    }

    editItemFromList = (item, index) => {
        const isMultiCurrency = this.state.currency !== this.state.basecurrency;
        const priceForInput =
            !isMultiCurrency
                ? item.price
                : item.ccprice ?? (this.state.curconversionrate ? item.price / this.state.curconversionrate : item.price);
        const markupForInput =
            !isMultiCurrency
                ? item.markup1
                : item.ccmarkup1 ?? (this.state.curconversionrate ? item.markup1 / this.state.curconversionrate : item.markup1);

        this.setState(
            {
                itemeditIndex: index,
                id: item.id,
                itemid: item.itemid,
                itemname: item.name,
                hsn: item.hsn,
                categoryid: item.categoryid,
                type: item.salesenum,
                uom: item.uom,
                brand: item.brand,
                colour: item.colour,
                size: item.size,
                thickness: item.thickness,
                totalmtrroll: item.totalmtrroll,
                quantity: item.quantity,
                discount: item.discount,
                pricevariance: item.pricevariance,
                tax: item.tax,
                description: item.description,
                price: priceForInput,
                markup1: markupForInput,
                totalpricewtax: "",
            },
            () => {
                // Scroll to product section with offset for fixed header
                if (this.productSectionRef?.current) {
                    const element = this.productSectionRef.current;
                    const headerOffset = 100; // Adjust this value to match your header height
                    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        );
    };

    removeItemFromList = (index) => {
        const removed = this.state.accepteditems?.[index];
        if (!removed) return;

        datalist = this.state.accepteditems.filter((_, i) => i !== index);
        this.setState({
            accepteditems: datalist,
        }, this.recomputeTotals);
    };

    removeServiceFromList = (index) => {
        const removed = this.state.serviceList?.[index];
        if (!removed) return;

        datalist = this.state.serviceList.filter((_, i) => i !== index);
        this.setState({
            serviceList: datalist,
        }, this.recomputeTotals);
    }

    editServiceFromList = (s, index) => {
        this.setState(
            {
                serviceeditIndex: index,
                filterserv: this.state.serviceitemList,
                serviceid: s.serviceid,
                editservie: true,
                service: s.service,
                servicedescription: s.servicedescription ? s.servicedescription : s.description,
                servicetax: s.servicetax,
                servicecost: parseFloat(s.servicecost),
                ccservicecost: s.ccservicecost,
                servicecode: s.servicecode,
                quantity: parseFloat(s.quantity),
                servicetotal: parseFloat(s.servicetotal),
                servicecatid: s.servicecatid,
                servicetax: s.servicetax,
                serviceigst: s.servicetax,
                servicecategory: s.servicecategory,
                markup: s.markup,
                ccmarkup: s.ccmarkup,
                servicemarkup: s.markup1,
                ccservicemarkup: s.ccmarkup1,
                ccservicetotal: s.ccservicetotal,
                servicediscount: s.servicediscount,
                servicediscountamount: s.servicediscountamount,
                ccservicediscountamount: s.ccservicediscountamount,
                servicetaxamount: s.servicetaxamount,
                ccservicetaxamount: s.ccservicetaxamount,
                servicetotalwtax: s.servicetotalwtax,
                ccservicetotalwtax: s.ccservicetotalwtax,
            },
            () => {
                // Scroll to service section with offset for fixed header
                if (this.serviceSectionRef?.current) {
                    const element = this.serviceSectionRef.current;
                    const headerOffset = 100; // Adjust this value to match your header height
                    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        );
    };

    handleTaxtypeChange = (value, values) => {
        this.setState({ taxtype: values })
    }
    handleGsttypeChange = (value, values) => {
        this.setState({ gsttype: values })
    }

    handleCustomInvoiceDateChange = (date) => {
        const currentCustom = dayjs(this.state.customcreatedAt || new Date());
        const nextCustomDate = dayjs(date)
            .hour(currentCustom.hour())
            .minute(currentCustom.minute())
            .second(currentCustom.second());

        const nextCustomMoment = moment(nextCustomDate.toDate());
        const currentDue = this.state.duedate ? moment(this.state.duedate) : moment(new Date());

        const nextDue = nextCustomMoment.clone().add(this.state.creditperiod, 'days')
            .hour(currentDue.hour())
            .minute(currentDue.minute())
            .second(currentDue.second());

        this.setState({
            customcreatedAt: nextCustomDate.toDate(),
            duedate: nextDue
        });

        SalesServices.GetLatestInvoiceNumberOfFinancialYear(dayjs(date).format("YYYY"), dayjs(date).format("MM"), currentTenant).then(res => {
            if (res.data) {
                this.setState({
                    finacialLatestInvoiceNumber: res.data.invNumber === 0 ? null : res.data.nextInvoiceId,
                    invNumber: res.data.invNumber
                })
            }
        })
    }

    handleCustomInvoiceTimeChange = (e) => {
        console.log(e.target.value)
        const [hours, minutes] = e.target.value.split(':');
        const newDate = dayjs(this.state.customcreatedAt || new Date()).hour(parseInt(hours)).minute(parseInt(minutes));
        this.setState({
            customcreatedAt: newDate.toDate(),
            duedate: moment(newDate.toDate()).add(this.state.creditperiod, "days")
        });
    }


    handleCurrency = (value, values) => {
        if (value !== '') {
            this.setState({ currencyid: values.id, currency: values.currency, curconversionrate: 1 })
            if (values.currency !== this.state.basecurrency) {
                this.setState({ convertionreq: true })
            } else {
                this.setState({ convertionreq: false })
            }
        }
    }

    handleMultiCurrencyToggle = (checked) => {
        this.setState({ multiCurrency: checked });
        if (!checked) {
            this.setState({
                currency: this.state.basecurrency,
                currencyid: this.state.currencylist.find(e => e.currency === this.state.basecurrency)?.id,
                curconversionrate: 1,
                convertionreq: false
            }, this.recomputeTotals);
        }
    }


    handleRecurringEndDateChange = (date) => {
        const currentCustom = dayjs(
            this.state.recurringenddate || new Date()
        );
        const nextCustomDate = dayjs(date)
            .hour(currentCustom.hour())
            .minute(currentCustom.minute())
            .second(currentCustom.second());

        const nextCustomMoment = moment(
            nextCustomDate.toDate()
        );

        this.setState({
            recurringenddate: nextCustomDate.toDate(),
        });
    }
    handleInvoiceRecurringPeriodChange = (e) => {
        this.setState({ recurringperiod: e.target.value })
    }

    handleInvoiceRecurringConfirmationChange = (e) => {
        this.setState({ recurringconfirm: e.target.value })
    }

    handleRecurringEndTimeChange = (e) => {
        // const [hours, minutes] =
        //   e.target.value.split(":");
        // const newDate = dayjs(
        //   this.state.recurringenddate || new Date()
        // )
        //   .hour(parseInt(hours))
        //   .minute(parseInt(minutes));
        // this.setState({
        //     recurringenddate: newDate.toDate()
        // });

        const [hours, minutes] = e.target.value.split(':');
        const newDate = dayjs(this.state.recurringenddate || new Date()).hour(parseInt(hours)).minute(parseInt(minutes));
        this.setState({
            recurringenddate: newDate.toDate(),
        });
    }


    clearCurrentProduct = () => {
        this.setState({
            itemeditIndex: null,
            itemid: "",
            itemname: "",
            quantity: "",
            price: "",
            markup1: 0,
            discount: 0,
            hsn: "",
            uom: "",
            tax: 0,
            description: "",
            categoryid: "",
            category: "",
            brand: "",
            colour: "",
            size: "",
            thickness: "",
            totalmtrroll: "",
            pricevariance: 0,
            totalpricewtax: "",
            fifoprice: 0,
            lifoprice: 0,
            avgprice: 0,
            stock: 0
        });
    }

    clearCurrentService = () => {
        this.setState({
            serviceeditIndex: null,
            service: "",
            serviceid: "",
            servicecode: "",
            servicecost: "",
            ccservicecost: "",
            servicemarkup: 0,
            ccservicemarkup: 0,
            servicediscount: 0,
            quantity: 1,
            servicedescription: "",
            servicecategory: "",
            servicecatid: "",
            servicetax: 0,
            servicetotal: 0,
            ccservicetotal: 0,
            servicetotalwtax: 0,
            ccservicetotalwtax: 0
        });
    }

    handlesubmit = (values) => {
        // Existing address validation (unchanged)
        if (
            (this.state.name === "" ||
                this.state.phoneno === "" ||
                this.state.pincode === "" ||
                this.state.pincode === undefined ||
                this.state.pincode === null ||
                this.state.state === "" ||
                this.state.city === "" ||
                this.state.houseno === "" ||
                this.state.houseno.length > 250 ||
                this.state.areaname === "" ||
                this.state.areaname.length > 100 ||
                this.state.country === "" ||
                this.state.disname === "" ||
                this.state.disphoneno === "" ||
                this.state.dispincode === "" ||
                this.state.dispincode === undefined ||
                this.state.dispincode === null ||
                this.state.disstate === "" ||
                this.state.discity === "" ||
                this.state.dishouseno === "" ||
                this.state.dishouseno.length > 250 ||
                this.state.disareaname === "" ||
                this.state.disareaname.length > 100 ||
                this.state.discountry === "" ||
                ((this.state.vehiclenum === "" ||
                    this.state.distance === "" ||
                    this.state.distance === null ||
                    this.state.distance === undefined) &&
                    this.state.samedaydelivery)) &&
            this.state.pagename === "New Invoice"
        ) {
            this.setState({ err: true });
        } else {
            // --- NEW VALIDATION: Ensure required items/services are added based on sotype ---
            if (this.state.sotype === 0 && this.state.accepteditems.length === 0) {
                // Swal.fire({
                //     title: "Validation Error",
                //     text: "Please add at least one product.",
                //     icon: "error",
                //     confirmButtonColor: "#152f5f",
                // });
                toast("Please add at least one product.", "error")
                return;
            }
            if (this.state.sotype === 1 && this.state.serviceList.length === 0) {
                // Swal.fire({
                //     title: "Validation Error",
                //     text: "Please add at least one service.",
                //     icon: "error",
                //     confirmButtonColor: "#152f5f",
                // });
                toast("Please add at least one service.", "error")
                return;
            }
            if (this.state.sotype === 2) {
                if (this.state.accepteditems.length === 0 || this.state.serviceList.length === 0) {
                    // Swal.fire({
                    //     title: "Validation Error",
                    //     text: "For Products & Services, you must add at least one product and one service.",
                    //     icon: "error",
                    //     confirmButtonColor: "#152f5f",
                    // });
                    toast("For Products & Services, you must add at least one product and one service.", "error")
                    return;
                }
            }
            // --- END NEW VALIDATION ---

            Swal.fire({
                title:
                    this.state.pagename === "New Proforma Invoice"
                        ? "Save & send Proforma Invoice for approval?"
                        : this.state.samedaydelivery && this.state.einvoice
                            ? "Save & send Invoice for approval along with Eway-bill details?"
                            : "Save & send Invoice for approval?",
                text: "Are you sure?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Yes",
                confirmButtonColor: "#152f5f",
                cancelButtonText: "No",
                reverseButtons: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.setState({ loader: true });
                    try {
                        let servicedata = [];
                        if (this.state.invtype === "Direct Invoice") {
                            if ((this.state.sotype === 1 || this.state.sotype === 2) && this.state.serviceList.length > 0) {
                                this.state.serviceList.map((s) =>
                                    servicedata.push({
                                        id: s.id,
                                        serviceid: s.serviceid,
                                        service: s.service,
                                        servicedescription: s.servicedescription,
                                        servicetax: s.servicetax,
                                        servicecost: parseFloat(s.servicecost),
                                        ccservicecost: s.ccservicecost,
                                        servicecode: s.servicecode,
                                        quantity: parseFloat(s.quantity),
                                        servicetotal: parseFloat(s.servicetotal),
                                        servicecatid: s.servicecatid,
                                        servicecategory: s.servicecategory,
                                        markup: s.markup,
                                        ccmarkup: s.ccmarkup,
                                        markup1: s.markup1,
                                        ccmarkup1: s.ccmarkup1,
                                        ccservicetotal: s.ccservicetotal,
                                        servicediscount: s.servicediscount,
                                        servicediscountamount: s.servicediscountamount,
                                        ccservicediscountamount: s.ccservicediscountamount,
                                        servicetaxamount: s.servicetaxamount,
                                        ccservicetaxamount: s.ccservicetaxamount,
                                        servicetotalwtax: s.servicetotalwtax,
                                        ccservicetotalwtax: s.ccservicetotalwtax,
                                    })
                                );
                            }
                        } else {
                            if (this.state.serviceList.length > 0) {
                                this.state.serviceList.filter(e => e.status === true).map((s) =>
                                    servicedata.push({
                                        id: s.id,
                                        serviceid: s.serviceid,
                                        service: s.service,
                                        servicedescription: s.servicedescription,
                                        servicetax: s.servicetax,
                                        servicecost: parseFloat(s.servicecost),
                                        ccservicecost: s.ccservicecost,
                                        servicecode: s.servicecode,
                                        quantity: parseFloat(s.quantity),
                                        servicetotal: parseFloat(s.servicetotal),
                                        servicecatid: s.servicecatid,
                                        servicecategory: s.servicecategory,
                                        markup: s.markup,
                                        ccmarkup: s.ccmarkup,
                                        markup1: s.markup1,
                                        ccmarkup1: s.ccmarkup1,
                                        ccservicetotal: s.ccservicetotal,
                                        servicediscount: s.servicediscount,
                                        servicediscountamount: s.servicediscountamount,
                                        ccservicediscountamount: s.ccservicediscountamount,
                                        servicetaxamount: s.servicetaxamount,
                                        ccservicetaxamount: s.ccservicetaxamount,
                                        servicetotalwtax: s.servicetotalwtax,
                                        ccservicetotalwtax: s.ccservicetotalwtax,
                                    })
                                );
                            }
                        }
                        let data = {
                            saleorderid: this.state.isclone ? null : this.state.saleorderid,
                            whid: this.state.whid,
                            deptid: this.state.deptid,
                            custid: this.state.custid,
                            customer: this.state.customer,
                            agent: isInvalid.includes(this.state.agentid) ? null : this.state.agentid,
                            invid: this.state.isclone ? -1 : this.state.invid,
                            invtype: this.state.isclone ? "Direct" : this.state.invtype === "Order Invoice" ? "Order" : "Direct",
                            itemlist: this.state.accepteditems,
                            milestone: this.state.completed === "" || this.state.completed.length === 0 ? null : this.state.completed,
                            serviceid: this.state.serviceid,
                            createdby: userid,
                            poid: this.state.poid,
                            addservice: this.state.addservice ? true : this.state.sotype === 2 && servicedata.length > 0 ? true : false,
                            creditperiod: this.state.creditperiod,
                            // --- CHANGED: Look up currencyid dynamically from currencylist ---
                            currencyid: (() => {
                                const found = this.state.currencylist.find(c => c.currency === this.state.currency);
                                return found ? found.id : null;
                            })(),
                            currency: this.state.currency,
                            services: servicedata,
                            curconversionrate: parseFloat(this.state.curconversionrate),
                            tcsreq: this.state.tcsreq,
                            tenantid: currentTenant,
                            tcs: this.state.tcs === undefined ? 0 : parseFloat(this.state.tcs),
                            tcsamount: this.state.tcsamount === undefined ? 0 : parseFloat(this.state.tcsamount),
                            tcsableamount: parseFloat(this.state.tcsableamount),
                            name: this.state.name,
                            phoneno: this.state.phoneno,
                            pincode: this.state.pincode,
                            state: this.state.state,
                            statecode: this.state.statecode,
                            city: this.state.city,
                            houseno: this.state.houseno,
                            areaname: this.state.areaname,
                            country: this.state.country,
                            adjustdebit: this.state.adjustdebit,
                            adjustopen: this.state.adjustopen,
                            disname: this.state.disname,
                            disphoneno: this.state.disphoneno,
                            dispincode: this.state.dispincode,
                            disstate: this.state.disstate,
                            disstatecode: this.state.disstatecode,
                            discity: this.state.discity,
                            dishouseno: this.state.dishouseno,
                            disareaname: this.state.disareaname,
                            discountry: this.state.discountry,
                            iscomposite: this.state.iscomposite,
                            taxtype: this.state.taxrequired === false ? "NA" : this.state.taxtype,
                            gsttype: this.state.gsttype,
                            sotype: this.state.sotype,
                            batnchidlist: this.state.batchidlist,
                            insurancereq: this.state.insurancereq,
                            insurance: this.state.insurancereq ? parseFloat(this.state.insurance) : 0,
                            insuranceamount: this.state.insurancereq ? parseFloat(this.state.insuranceamount) * parseFloat(this.state.curconversionrate) : 0,
                            ccinsuranceamount: this.state.insurancereq ? parseFloat(this.state.insuranceamount) : 0,
                            insurancetax: this.state.insurancereq ? parseFloat(this.state.insurancetax) : 0,
                            totalinsuranceamount: this.state.insurancereq ? parseFloat(this.state.totalinsuranceamount) * parseFloat(this.state.curconversionrate) : 0,
                            cctotalinsuranceamount: this.state.insurancereq ? parseFloat(this.state.totalinsuranceamount) : 0,
                            einvoicerequired: this.state.einvoice,
                            additionalcharges: this.state.additionalchargeslist,
                            totaladdtitionalcharges: parseFloat(this.state.invoiceadditionalcharges),
                            cctotaladdtitionalcharges: parseFloat(this.state.ccinvoiceadditionalcharges),
                            totaladdtitionalchargestax: parseFloat(this.state.invoiceadditionalchargestax),
                            cctotaladdtitionalchargestax: parseFloat(this.state.ccinvoiceadditionalchargestax),
                            samedaydelivery: (this.state.samedaydelivery || false).toString(),
                            vehiclenum: this.state.vehiclenum,
                            transporterid: this.state.samedaydelivery ? this.state.transporterid : null,
                            distance: isInvalid.includes(this.state.distance) || this.state.samedaydelivery === false ? 0 : parseInt(this.state.distance),
                            transid: this.state.samedaydelivery ? this.state.transporterid : null,
                            transname: this.state.samedaydelivery ? this.state.transname : null,
                            vehicletype: this.state.vehicletype ? this.state.vehicletype : null,
                            supplytype: this.state.samedaydelivery ? this.state.supplytype : null,
                            transportationmode: this.state.samedaydelivery ? this.state.transportationmode : 0,
                            transactiontype: this.state.samedaydelivery ? this.state.transactiontype : null,
                            autojre: this.state.additionalchargeslist.length > 0 ? false : this.state.autojre,
                            valueroundoff: this.state.valueroundoff,
                            invoiceremarks: this.state.invoiceremarks,
                            sddate: this.state.SDdate,
                            date: this.state.SDdate ? this.state.customcreatedAt : null,
                            duedate: this.state.duedate,
                            recurring: this.state.recurring,
                            recurringenddate: this.state.recurringenddate,
                            recurringperiod: this.state.recurringperiod,
                            recurringconfirm: this.state.recurringconfirm,
                            invNumber: this.state.SDdate && this.state.finacialLatestInvoiceNumber === null ? this.state.invNumber === 0 ? 1 : this.state.invNumber : 0
                        };

                        const handleApiError = (e) => {
                            this.setState({ loader: false });
                            let errorText = "An error occurred while saving the invoice. Please try again.";
                            if (e?.response?.data) {
                                if (typeof e.response.data === "string") {
                                    errorText = e.response.data;
                                } else if (e.response.data.body) {
                                    try {
                                        errorText = typeof e.response.data.body === "string"
                                            ? JSON.parse(e.response.data.body)
                                            : e.response.data.body;
                                    } catch (_) {
                                        errorText = e.response.data.body;
                                    }
                                } else if (e.response.data.error) {
                                    errorText = e.response.data.error;
                                } else if (e.response.data.message) {
                                    errorText = e.response.data.message;
                                }
                            } else if (e?.message) {
                                errorText = e.message;
                            }

                            if (e?.response?.data?.error === "Unauthorized" || e?.response?.status === 401) {
                                alert("Your Session is Lost: Please login Back to resume");
                                this.props.navigate(`/`);
                            } else {
                                Swal.fire({
                                    title: typeof errorText === "object" ? JSON.stringify(errorText) : errorText,
                                    text: "",
                                    icon: "error",
                                    confirmButtonText: "Ok",
                                    confirmButtonColor: "#152f5f",
                                });
                            }
                        };

                        if (this.state.pagename === "New Proforma Invoice") {
                            SalesServices.GenerateProformaInvoice(data)
                                .then((res) =>
                                    this.props.navigate("/viewsalesinvoice", {
                                        state: { id: res.data, pagename: "Proforma Invoice Details", temp: false, type: "Proforma Invoice", goback: false },
                                    })
                                )
                                .catch(handleApiError);
                        } else {
                            if (this.state.invid === -1 || this.state.isclone) {
                                SalesServices.GenerateInvoice(data)
                                    .then((res) =>
                                        this.props.navigate("/viewsalesinvoice", {
                                            state: { id: res.data, pagename: "Tax Invoice Details", temp: true, type: "Tax Invoice", goback: false },
                                        })
                                    )
                                    .catch(handleApiError);
                            } else {
                                SalesServices.UpdateInvoice(data)
                                    .then((res) =>
                                        this.props.navigate("/viewsalesinvoice", {
                                            state: { id: res.data, pagename: "Tax Invoice Details", temp: true, type: "Tax Invoice", goback: false },
                                        })
                                    )
                                    .catch(handleApiError);
                            }
                        }
                    } catch (prepErr) {
                        console.error("Error preparing invoice data:", prepErr);
                        this.setState({ loader: false });
                        toast("Failed to prepare invoice data for submission.", "error");
                    }
                }
            });
        }
    };

    handleSelect = () => {
        this.setState({ quantitywindow: true });
    };

    handleQuantityChange = (e, i) => {
        let q;
        let data = this.state.itemquantitylist;
        if (e === "" || e === undefined || parseFloat(e) < 0) {
            q = 0;
        }
        else {
            q = parseFloat(e);
        }
        if (q > data.find((e, index) => index === i).currentstock) {
            data.find((e, index) => index === i).enteredquantity = data.find(
                (e, index) => index === i
            ).currentstock;
        } else {
            data.find((e, index) => index === i).enteredquantity = q;
        }
        let qa = data.reduce((a, b) => a + b.enteredquantity, 0);

        this.setState({ quantity: qa, itemquantitylist: data });
    };

    handleSaveQuantity = () => {
        if (this.state.pendingquantity < this.state.quantity) {
        } else {
            let data = this.state.itemquantitylist;
            let am = data.filter((a) => a.enteredquantity !== 0);
            if (this.state.batchidlist.length !== 0) {
                let bid = this.state.batchidlist.map((a) => a.batchid);
                am.map((a) =>
                    bid.includes(a.batchid)
                        ? (this.state.batchidlist.find(
                            (b) => b.batchid === a.batchid
                        ).quantity =
                            this.state.batchidlist.find((b) => b.batchid === a.batchid)
                                .quantity - a.enteredquantity)
                        : this.state.batchidlist.push({
                            batchid: a.batchid,
                            quantity: a.enteredquantity,
                            stockid: a.stockid,
                            tenantid: currentTenant,
                            whid: this.state.sodata.whid,
                            itemid: this.state.itemid,
                        })
                );
            } else {
                am.map((a) =>
                    this.state.batchidlist.push({
                        batchid: a.batchid,
                        quantity: a.enteredquantity,
                        stockid: a.stockid,
                        tenantid: currentTenant,
                        whid: this.state.sodata.whid,
                        itemid: this.state.itemid,
                    })
                );
            }
            this.setState({ quantitywindow: false, itemquantitylist: data });
        }
    };

    refreshData() {
        datalist = []
        const id = this.props.location.state === undefined
            ? this.history.props.push("/saleorder")
            : this.props.location.state.id;
        const isclone = this.props.location?.state?.clone;

        if (id !== -1) {
            (isclone ? SalesServices.GetInvoice(id) : SalesServices.GetTempInvoice(id)).then((res) => {
                let rawItems = res.data.invoiceitemlist ? res.data.invoiceitemlist : [];
                if (isclone) {
                    datalist = rawItems.map((item) => ({
                        ...item,
                        id: item.itemid || item.id,
                        itemid: item.itemid || item.id,
                        batchid: item.batchid || 0,
                        pending: 0,
                        quantity: parseFloat(item.quantity) || 0,
                        price: parseFloat(item.price) || 0,
                        baseprice: parseFloat(item.baseprice ?? item.price) || 0,
                        ccbaseprice: parseFloat(item.ccbaseprice ?? item.ccprice ?? item.price) || 0,
                        ccprice: parseFloat(item.ccprice ?? item.price) || 0,
                        tax: parseFloat(item.tax) || 0,
                        taxamount: parseFloat(item.taxamount) || 0,
                        cctaxamount: parseFloat(item.cctaxamount ?? item.taxamount) || 0,
                        totalprice: parseFloat(item.totalprice) || 0,
                        cctotalprice: parseFloat(item.cctotalprice ?? item.totalprice) || 0,
                        totalpricewtax: parseFloat(item.totalpricewtax) || 0,
                        cctotalpricewtax: parseFloat(item.cctotalpricewtax ?? item.totalpricewtax) || 0,
                        discount: parseFloat(item.discount) || 0,
                        discountamount: parseFloat(item.discountamount) || 0,
                        ccdiscountamount: parseFloat(item.ccdiscountamount ?? item.discountamount) || 0,
                        markup: parseFloat(item.markup) || 0,
                        markup1: parseFloat(item.markup1) || 0,
                        ccmarkup: parseFloat(item.ccmarkup ?? item.markup) || 0,
                        ccmarkup1: parseFloat(item.ccmarkup1 ?? item.markup1) || 0,
                        pricevariance: parseFloat(item.pricevariance) || 0,
                        additionalcharges: parseFloat(item.additionalcharges) || 0,
                        additionalchargestax: parseFloat(item.additionalchargestax) || 0,
                        additionalchargestaxamount: parseFloat(item.additionalchargestaxamount) || 0,
                        totaladditionalcharges: parseFloat(item.totaladditionalcharges) || 0,
                    }));
                } else {
                    datalist = rawItems;
                }

                let rawServices = res.data.servicelist ? res.data.servicelist : res.data.invoiceservicelist ? res.data.invoiceservicelist.map(e => { return { ...e, servicemarkup: e.markup1, ccservicemarkup: e.ccmarkup1 } }) : [];
                let normalizedServices = rawServices;
                if (isclone) {
                    normalizedServices = rawServices.map((s) => ({
                        ...s,
                        status: true,
                        quantity: parseFloat(s.quantity) || 0,
                        servicecost: parseFloat(s.servicecost) || 0,
                        ccservicecost: parseFloat(s.ccservicecost ?? s.servicecost) || 0,
                        servicetax: parseFloat(s.servicetax) || 0,
                        servicetaxamount: parseFloat(s.servicetaxamount) || 0,
                        ccservicetaxamount: parseFloat(s.ccservicetaxamount ?? s.servicetaxamount) || 0,
                        servicetotal: parseFloat(s.servicetotal) || 0,
                        ccservicetotal: parseFloat(s.ccservicetotal ?? s.servicetotal) || 0,
                        servicetotalwtax: parseFloat(s.servicetotalwtax) || 0,
                        ccservicetotalwtax: parseFloat(s.ccservicetotalwtax ?? s.servicetotalwtax) || 0,
                        markup: parseFloat(s.markup) || 0,
                        markup1: parseFloat(s.markup1) || 0,
                        servicemarkup: parseFloat(s.servicemarkup ?? s.markup1) || 0,
                        ccmarkup: parseFloat(s.ccmarkup ?? s.markup) || 0,
                        ccmarkup1: parseFloat(s.ccmarkup1 ?? s.markup1) || 0,
                        ccservicemarkup: parseFloat(s.ccservicemarkup ?? s.ccmarkup1) || 0,
                        servicediscount: parseFloat(s.servicediscount) || 0,
                        servicediscountamount: parseFloat(s.servicediscountamount) || 0,
                        ccservicediscountamount: parseFloat(s.ccservicediscountamount ?? s.servicediscountamount) || 0,
                    }));
                }

                this.setState({
                    isclone: isclone,
                    invid: isclone ? -1 : res.data.invid,
                    saleorderid: isclone ? null : res.data.customsoid,
                    sotype: res.data.sotype === "Services" ? 1 : res.data.sotype === "Products" ? 0 : 2,
                    invtype: isclone ? "Direct Invoice" : res.data.invtype === "Order" ? "Order Invoice" : res.data.invtype === "Direct" ? "Direct Invoice" : "Non-Inventory Invoice",
                    accepteditems: datalist,
                    serviceList: normalizedServices,
                    completed: res.data.milestone ? res.data.milestone : [],
                    whid: res.data.whid,
                    warehouse: res.data.warehouse,
                    deptid: res.data.deptid,
                    department: res.data.department,
                    serviceid: res.data.serviceid,
                    poid: res.data.poid,
                    addservice: res.data.addservice,
                    creditperiod: res.data.creditperiod,
                    currencyid: res.data.currencyid,
                    currency: res.data.currency,
                    convertionreq: res.data.currency === currency ? false : true,
                    multiCurrency: res.data.currency !== currency,
                    curconversionrate: parseFloat(res.data.curconversionrate),
                    tcsreq: res.data.tcsreq,
                    tcs: parseFloat(res.data.tcs),
                    tcsamount: parseFloat(res.data.tcsamount),
                    tcsableamount: parseFloat(res.data.tcsableamount),
                    invtotalamountwtax: res.data.totalinvoicewtax,
                    grandtotal: res.data.totalinvoicewtax,
                    totalinvoice: res.data.totalinvoice,
                    // Shipping address (from invoice)
                    name: res.data.dname,
                    phoneno: res.data.dphoneno,
                    pincode: res.data.dpincode,
                    state: res.data.dstate,
                    statecode: res.data.dstatecode,
                    city: res.data.dcity,
                    houseno: res.data.dhouseno,
                    areaname: res.data.dareaname,
                    country: res.data.dcountry,
                    billname: res.data.dname,
                    billphoneno: res.data.dphoneno,
                    billpincode: res.data.dpincode,
                    billstate: res.data.dstate,
                    billstatecode: res.data.dstatecode,
                    billcity: res.data.dcity,
                    billhouseno: res.data.dhouseno,
                    billareaname: res.data.dareaname,
                    billcountry: res.data.dcountry,
                    // Tax & type (from invoice)
                    taxtype: res.data.taxtype,
                    gsttype: res.data.gsttype,
                    // Dispatch address (from invoice)
                    disname: res.data.disname,
                    disphoneno: res.data.disphoneno,
                    dispincode: res.data.dispincode,
                    disstate: res.data.disstate,
                    disstatecode: res.data.disstatecode,
                    discity: res.data.discity,
                    dishouseno: res.data.dishouseno,
                    disareaname: res.data.disareaname,
                    discountry: res.data.discountry,
                    // Other invoice fields
                    adjustdebit: res.data.debitadjusted === null || res.data.debitadjusted === 0 ? false : true,
                    adjustopen: res.data.openadjusted === null || res.data.openadjusted === 0 ? false : true,
                    iscomposite: res.data.iscomposite,
                    insurancereq: res.data.insurancereq,
                    insurance: parseFloat(res.data.insurance),
                    insuranceamount: parseFloat(res.data.insuranceamount),
                    insurancetax: parseFloat(res.data.insurancetax),
                    totalinsuranceamount: parseFloat(res.data.totalinsurance),
                    einvoice: res.data.einvoicerequired,
                    additionalchargeslist: res.data.additionalchares,
                    invoiceadditionalcharges: parseFloat(res.data.totaladditionalchares),
                    invoiceadditionalchargestax: res.data.additionalchares.reduce(
                        (a, b) => (a = a + b.additionalchargestaxamount),
                        0
                    ),
                    samedaydelivery: res.data.samedaydelivery === "TRUE" ? true : false,
                    vehiclenum: res.data.vehiclenum,
                    transportername: res.data.transportername,
                    transporterid: res.data.transporterid,
                    distance: parseInt(res.data.distance),
                    transid: res.data.transporterid,
                    transname: res.data.transname,
                    vehicletype: res.data.vehicletype,
                    supplytype: res.data.supplytype,
                    transportationmode: res.data.transportationmode,
                    transactiontype: res.data.transactiontype,
                    invoiceremarks: res.data.invoiceremarks,
                    grandservicetotal: res.data.grandservicetotal,
                    totaltaxamount: res.data.totaltaxamount,
                    totaliv: res.data.totaliv,
                    grandtotal: res.data.grandtotalproducttotal,
                }, this.recomputeTotals);

                // If linked to a sale order, load that data (only when not cloning)
                if (res.data.customsoid && !isclone) {
                    SalesServices.GetDataforInvoice(res.data.customsoid).then((response) => {
                        this.setState({
                            sodata: response.data,
                            serviceList: response.data.servicelist,
                            saleorderitems: response.data.saleorderitems,
                            serviceid:
                                response.data.sotype === 1
                                    ? response.data.servicelist.find((e) => e).serviceid
                                    : "",
                            milestones:
                                response.data.sotype === 1
                                    ? response.data.servicelist.find((e) => e).milestones
                                    : [],
                            contracttype:
                                response.data.sotype === 1
                                    ? response.data.servicelist.find((e) => e).contracttype
                                    : "",
                            totaltaxamount: response.data.totaltaxamount,
                            totaliv: response.data.totaliv,
                            grandtotal: response.data.grandtotalproducttotal,
                            grandservicetotal: response.data.grandservicetotal,
                            sotype: response.data.sotype,
                            creditperiod:
                                response.data.creditperiod === null ||
                                    response.data.creditperiod === undefined
                                    ? 0
                                    : response.data.creditperiod,
                        }, this.recomputeTotals)
                    });
                }

                // Fetch customer to get billing address, financial balances, and the customer name
                CustomerService.retriveCustomer(res.data.custid).then((custRes) => {
                    const customerObj = custRes.data;
                    // Ensure this customer is in the custom list (for Autocomplete)
                    const existing = this.state.custom.find(c => c.id === customerObj.id);
                    let updatedCustom = this.state.custom;
                    if (!existing) {
                        updatedCustom = [...this.state.custom, customerObj];
                    }
                    this.setState({
                        custom: updatedCustom,
                        // Customer name for display (important for validation and UI)
                        customer: customerObj.companyname,
                        custid: customerObj.id,
                        // Billing address (from customer)
                        name: customerObj.companyname,
                        phoneno: customerObj.contactnumber,
                        pincode: customerObj.zip,
                        state: customerObj.statename,
                        city: customerObj.cityname,
                        houseno: customerObj.address,
                        areaname: customerObj.address2,
                        country: customerObj.countryname,
                        statecode: customerObj.statecode,

                        billname: customerObj.companyname,
                        billphoneno: customerObj.contactnumber,
                        billpincode: customerObj.zip,
                        billstate: customerObj.statename,
                        billcity: customerObj.cityname,
                        billhouseno: customerObj.address,
                        billareaname: customerObj.address2,
                        billcountry: customerObj.countryname,
                        billstatecode: customerObj.statecode,

                        // Financial balances
                        debitamount: customerObj.debitamount,
                        openingbalance: customerObj.openingbalance,
                        adjustdebit: customerObj.debitamount > 0 ? true : false,
                        // Do NOT update currency, taxtype, gsttype, einvoice – they come from the invoice
                    });
                });
            });
        }

        // ========== LOAD MASTER DATA (keep unchanged) ==========
        CategoryServices.getCategory(currentTenant).then((response) =>
            this.setState({
                CategoryList: response.data.filter((e) => e.categorytype === "Product"),
                ServiceCategoryList: response.data.filter(
                    (e) => e.categorytype === "Service"
                ),
            })
        );

        TaxServices.getTaxes(currentTenant).then(response => this.setState({ taxesList: response.data.sort((a, b) => a.tax - b.tax) }))

        InventoryService.GetWHdata(currentTenant).then((response) => {
            this.setState({ whdata: response.data });
        });

        InventoryService.GetItems(currentTenant).then((response) =>
            this.setState({
                itemList: response.data,
                closingStock:
                    response.data.length === 0
                        ? 0
                        : response.data.find((e) => e.closingstock !== null).closingstock,
            })
        );

        InventoryService.getServices(currentTenant).then((res) => {
            this.setState({ serviceitemList: res.data });
        });

        WarehouseServices.getWarehouses(currentTenant).then((response) =>
            this.setState(
                {
                    WarehouseList: response.data,
                },
                () => {
                    if (this.state.WarehouseList.length === 1) {
                        this.setState({
                            warehouse: this.state.WarehouseList[0].name,
                            whid: this.state.WarehouseList[0].id,
                        });
                        DepartmentServices.deptbywarehouse(this.state.WarehouseList[0].id).then((response) => {
                            this.setState({
                                DepartmentList: response.data
                            })
                            if (response.data.length === 1) {
                                this.setState({
                                    department: response.data[0].name,
                                    deptid: response.data[0].id
                                })
                            }
                        });
                    } else if (dataaccess === "Organization" || dataaccess === "User") {
                        this.setState({
                            warehouse: this.state.WarehouseList.find((e) => e.id === userwhid)
                                .name,
                            whid: this.state.WarehouseList.find((e) => e.id === userwhid).id,
                            WarehouseList: this.state.WarehouseList.filter(
                                (e) => e.id === userwhid
                            ),
                        });
                        DepartmentServices.deptbywarehouse(this.state.WarehouseList.find(e => e.id === userwhid).id).then((response) => {
                            this.setState({
                                DepartmentList: response.data
                            })
                            if (response.data.length === 1) {
                                this.setState({
                                    department: response.data[0].name,
                                    deptid: response.data[0].id
                                })
                            }
                        });
                    }
                }
            )
        );

        SalesServices.GetAllCurrency().then((response) => {
            this.setState({ currencylist: response.data });
        });

        SalesServices.retriveAllCustomers(currentTenant)
            .then((res) => {
                this.setState({
                    custom: res.data.filter((e) =>
                        this.state.usercustomers.length === 0
                            ? e
                            : this.state.usercustomers.includes(e.companyname)
                    ),
                });
            })
            .catch((e) => {
                if (e.response.data.error === "Unauthorized") {
                    alert("Your Session is Lost: Please login Back to resume");
                    this.props.navigate(`/`);
                }
            });

        SettingsServices.GetSettings(currentTenant).then((response) => {
            this.setState({
                settings: response.data,
                soeditprice: response.data.soeditprice,
                salescalreq: response.data.salescalreq,
                pouploadm: response.data.pouploadm,
                dnrequired: response.data.dnreq,
                autojre: response.data.salesautojre === "YES" ? true : false,
                backdateinvoicestatus: response.data.backdateinvoicestatus === "YES" ? true : false,
            });
        });

        MasterService.getParameters(currentTenant).then((res) => {
            this.setState({
                parameters: res.data,
                sizelist: res.data.size,
                colourlist: res.data.colour,
                thicknesslist: res.data.thickness,
                brandslist: res.data.brands,
            });
        });

        // REMOVED: MasterService.GetCurrencyOfTenant from here – now in componentDidMount

        MasterService.getCountries()
            .then((response) =>
                this.setState({
                    CountryData: response.data,
                })
            )
            .catch((e) => {
                if (e.response.data.error === "Unauthorized") {
                    alert("Your Session is Lost: Please login Back to resume");
                    this.props.navigate(`/`);
                }
            });

        SettingsServices.geteinvoicecredentials(currentTenant).then((response) => {
            this.setState({
                einvoice: response.data.status === "ACTIVE" ? true : false,
            });
        });

        TransporterServices.getTransporters(currentTenant).then((response) =>
            this.setState({ transporterslist: response.data })
        );

        this.setState({
            disname: clientname,
            disphoneno: contactnumber,
            dispincode: czip,
            disstate: cstate,
            disstatecode: cstatecode,
            discity: ccity,
            dishouseno: address,
            disareaname: address2,
            discountry: ccountry,
        });

        if (
            this.props.location.state?.soid !== undefined &&
            this.props.location.state?.soid !== null &&
            this.props.location.state?.soid !== ""
        ) {
            let id = this.props.location.state.soid;
            datalist = [];
            if (id) {
                SalesServices.GetDataforInvoice(id).then((response) => {
                    this.setState({
                        customer: response.data.customer,
                        custid: response.data.custid,
                        saleorderid: id,
                        invtype: "Order Invoice",
                        tcsableamount: 0,
                        totaladditionalcharges: 0,
                        invoiceadditionalcharges: 0,
                        invoiceadditionalchargestax: 0,
                        sodata: response.data,
                        agent: response.data.agent,
                        agentid: response.data.agentid,
                        whid: response.data.whid,
                        deptid: response.data.deptid,
                        currency: response.data.currency,
                        curconversionrate: response.data.curconversionrate,
                        gsttype: response.data.gsttype,
                        taxtype: response.data.taxtype,
                        serviceList: response.data.servicelist,
                        saleorderitems: response.data.saleorderitems,
                        serviceid:
                            response.data.sotype === 1
                                ? response.data.servicelist.find((e) => e).serviceid
                                : "",
                        milestones:
                            response.data.sotype === 1
                                ? response.data.servicelist.find((e) => e).milestones
                                : [],
                        contracttype:
                            response.data.sotype === 1
                                ? response.data.servicelist.find((e) => e).contracttype
                                : "",
                        totaltaxamount: response.data.totaltaxamount,
                        totaliv: response.data.totaliv,
                        grandtotal: response.data.grandtotalproducttotal,
                        grandservicetotal: response.data.grandservicetotal,
                        sotype: response.data.sotype,
                        creditperiod:
                            response.data.creditperiod === null ||
                                response.data.creditperiod === undefined
                                ? 0
                                : response.data.creditperiod,
                        accepteditems:
                            this.state.pagename === "New Proforma Invoice" ||
                                response.data.sotype === 2
                                ? response.data.saleorderitems
                                : [],
                        completed:
                            response.data.sotype === 1 &&
                                this.state.pagename === "New Proforma Invoice"
                                ? response.data.servicelist.find((e) => e).milestones[0]
                                : "",
                        addservice: response.data.sotype === 2 ? true : false,
                        pricevariance: response.data.pricevariance,
                    }, this.recomputeTotals);

                    CustomerService.retriveCustomer(response.data.custid).then((res) => {
                        const customerObj = res.data;
                        const existing = this.state.custom.find(c => c.id === customerObj.id);
                        let updatedCustom = this.state.custom;
                        if (!existing) {
                            updatedCustom = [...this.state.custom, customerObj];
                        }
                        this.setState({
                            custom: updatedCustom,
                            custid: customerObj.id,
                            customer: customerObj.companyname,
                            debitamount: customerObj.debitamount,
                            openingbalance: customerObj.openingbalance,
                            adjustopen: false,
                            adjustdebit: customerObj.debitamount > 0 ? true : false,

                            billname: customerObj.companyname,
                            billphoneno: customerObj.contactnumber,
                            billpincode: customerObj.zip,
                            billstate: customerObj.statename,
                            billcity: customerObj.cityname,
                            billhouseno: customerObj.address,
                            billareaname: customerObj.address2,
                            billcountry: customerObj.countryname,
                            billstatecode: customerObj.statecode,

                            name: customerObj.companyname,
                            phoneno: customerObj.contactnumber,
                            pincode: customerObj.zip,
                            state: customerObj.statename,
                            city: customerObj.cityname,
                            houseno: customerObj.address,
                            areaname: customerObj.address2,
                            country: customerObj.countryname,
                            statecode: customerObj.statecode,


                            // Do NOT override currency, addresses, etc.
                        });

                        // Populate saleorderdata so the Autocomplete can show the selected SO
                        let datadao = {
                            tenantid: currentTenant,
                            startdate: financialyearstart,
                            enddate: financialyearend,
                            userid: userid,
                            dataaccess: dataaccess,
                            whid: userwhid,
                            id: customerObj.id,
                            poupload: this.state.pouploadm === "YES" ? true : false,
                        };

                        if (this.state.pagename === "New Proforma Invoice") {
                            SalesServices.GetSObycustidforProformaInvoice(datadao).then((res) =>
                                this.setState({ saleorderdata: res.data })
                            );
                        } else {
                            SalesServices.getSoByCustidForInvoice(datadao).then((res) =>
                                this.setState({ saleorderdata: res.data })
                            );
                        }
                    });
                });
            }
        }
    }

    componentDidMount() {
        if (userid === undefined) {
            window.confirm("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
        }
        UsercustomerService.GetUserCustomersbyUser(userid).then((res) =>
            this.setState({
                usercustomers:
                    res.data === "" || res.data === undefined
                        ? []
                        : res.data.customers.split(","),
            })
        );

        // Fetch tenant base currency (only for display, does NOT affect invoice currency)
        MasterService.GetCurrencyOfTenant(currentTenant).then((response) => {
            this.setState({
                basecurrency: response.data.currency,
                // Do NOT set currency, currencyid, or curconversionrate here
            });
        });

        this.refreshData();
    }

    validate(values) {
        let errors = {};
        var num = /^[0-9]/;

        if (this.state.customer === "") {
            errors.customer = "Please Select Customer";
        }

        if (this.state.invtype === "Order Invoice" && this.state.saleorderid === "") {
            errors.saleorder = "Please Select Sale Order";
        }


        else if (this.state.invtype === "Direct Invoice") {
            if (this.state.quantity === "" ||
                this.state.quantity === undefined ||
                this.state.quantity === 0 ||
                parseFloat(this.state.quantity) <= 0 ||
                !num.test(parseFloat(this.state.quantity))) {
                errors.quantity = "Quantity is required";
            }
        }

        if (this.state.invtype === "Order Invoice" &&
            parseFloat(this.state.quantity) > this.state.pendingquantity
        ) {
            errors.quantity = `Available quantity is ${this.state.pendingquantity}`;
        }

        return errors;
    }

    render() {
        const styles = {
            loadingOverlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
            },
            spinner: {
                width: '40px',
                height: '40px',
                border: '4px solid #e2e8f0',
                borderTop: '4px solid #4d4d4d',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
            },
            btnOutline: {
                backgroundColor: '#ffffff',
                color: '#4d4d4d',
                border: '1px solid #4d4d4d',
            },
            btnPrimary: {
                backgroundColor: '#4d4d4d',
                color: '#ffffff',
            },
            detailGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
                gap: '20px',
                marginTop: '15px',
                marginBottom: '20px'
            },
            detailSection: {
                backgroundColor: '#f8fafc',
                borderRadius: '12px',
                padding: '20px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
            },
            sectionTitleSummary: {
                fontSize: '1rem',
                fontWeight: '600',
                color: '#1e293b',
                marginBottom: '16px',
                borderBottom: '1px solid #e2e8f0',
                paddingBottom: '10px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            },
            detailRow: {
                display: 'flex',
                justifyContent: 'space-between',
                padding: '8px 0',
                borderBottom: '1px solid #f1f5f9'
            },
            detailLabel: {
                color: '#64748b',
                fontSize: '0.85rem',
                fontWeight: '500'
            },
            detailValue: {
                color: '#1e293b',
                fontWeight: '600',
                fontSize: '0.85rem',
                textAlign: 'right'
            },
        };

        let {
            custom,
            customer,
            custid,
            saleorderdata,
            itemid,
            itemname,
            quantity,
            orderedquantity,
            grandtotal,
            status,
            saleorderitems,
            poid,
            DnIDList,
            currencylist,
            taxtypelist,
            gsttypelist,
            currencyid,
            curconversionrate,
            tcs,
            tcsreq,
            tcsamount,
            pendingquantity,
            creditperiod,
            additionalchargeslist,
            additionalcharges,
            additionalchargestax,
            totaladditionalcharges,
            additionalchargestaxamount,
            natureofcharge,
            vehiclenum,
            distance,
            transporterid,

            WarehouseList,
            DepartmentList,
            CategoryList,
            filteritemlist,
            sizelist,
            colourlist,
            brandslist,
            filterserv,
            serviceitemList,
            serviceList,
            service,
            serviceid,
            ServiceCategoryList,
            servicecategory,
            servicecatid,
            servicetax,
            servicecode,
            servicecost,
            servicecostconv,
            servicecgst,
            servicesgst,
            serviceigst,
            servicegst,
            servicevat,
            servicecostwttax,
            servicecostwttaxconv,
            servicetaxamount,
            servicedescription,
            servicetotal,
            grandservicetotal,
            serviceerr,
            markup1,
            markup,
            invoiceremarks
        } = this.state;


        // Compute product count per category
        const productCategoryCount = {};
        if (this.state.itemList) {
            this.state.itemList.forEach(item => {
                const catId = item.catid;
                if (catId) {
                    productCategoryCount[catId] = (productCategoryCount[catId] || 0) + 1;
                }
            });
        }

        // Compute service count per category
        const serviceCategoryCount = {};
        if (this.state.serviceitemList) {
            this.state.serviceitemList.forEach(service => {
                const catId = service.catid;
                if (catId) {
                    serviceCategoryCount[catId] = (serviceCategoryCount[catId] || 0) + 1;
                }
            });
        }


        const { hovered, subtotal, taxTotal, additionalChargesTotal, insuranceTotal, tcsTotal, tdsTotal, basecurrency } = this.state;

        return (
            <div>
                <Header />
                <Menu />
                <div className="content-wrapper">
                    {this.state.loader && (
                        <div style={styles.loadingOverlay}>
                            <div style={styles.spinner}></div>
                        </div>
                    )}

                    <Backdrop
                        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={this.state.loader}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>

                    <div className="UI-container">
                        <div className="UI-card">
                            <div className="UI-header">
                                <Breadcrumb breadcrumbs={[{ name: "Home", path: "/sales" }, { name: this.state.pagename === "New Proforma Invoice" ? "Proforma Invoices" : "Sales Invoices", path: "/salesinvoice" }, { name: this.state.pagename, path: null }]} />
                                {/* <nav className="UI-breadcrumb">
                                    <Link
                                        to="/sales"
                                        className={`UI-breadcrumb-item ${hovered === 'home' ? 'UI-breadcrumb-item-hover' : ''}`}
                                        style={{
                                            transform: hovered === 'home' ? 'scale(1.1)' : 'scale(1)',
                                            transition: 'color 0.2s ease, transform 0.2s ease',
                                        }}
                                        onMouseEnter={() => this.setState({ hovered: 'home' })}
                                        onMouseLeave={() => this.setState({ hovered: null })}
                                    >
                                        Home
                                    </Link>
                                    <span>/</span>
                                    <Link
                                        to={{ pathname: "/salesinvoice" }}
                                        state={{
                                            message: "",
                                            type: this.state.pagename === "New Proforma Invoice" ? "Proforma Invoice" : "Tax Invoice",
                                        }}
                                        className={`UI-breadcrumb-item ${hovered === 'invoice' ? 'UI-breadcrumb-item-hover' : ''}`}
                                        style={{
                                            transform: hovered === 'invoice' ? 'scale(1.1)' : 'scale(1)',
                                            transition: 'color 0.2s ease, transform 0.2s ease',
                                        }}
                                        onMouseEnter={() => this.setState({ hovered: 'invoice' })}
                                        onMouseLeave={() => this.setState({ hovered: null })}
                                    >
                                        Invoice
                                    </Link>
                                    <span>/</span>
                                    <span className="UI-breadcrumb-active">{this.state.pagename}</span>
                                </nav> */}

                                <div className="UI-header-content">
                                    <div>
                                        <h1 className="UI-title">{this.state.pagename}</h1>
                                        <p className="UI-subtitle">
                                            {this.state.pagename === "New Proforma Invoice"
                                                ? "Create a new proforma invoice"
                                                : "Create or edit a tax invoice"}
                                        </p>
                                    </div>
                                    <div className="UI-header-actions">
                                        <Link
                                            to={{ pathname: "/salesinvoice" }}
                                            state={{
                                                message: "",
                                                type: this.state.pagename === "New Proforma Invoice" ? "Proforma Invoice" : "Tax Invoice",
                                            }}
                                            className={`UI-btn UI-btn-outline ${hovered === 'back' ? 'UI-btn-outline-hover' : ''}`}
                                            style={{
                                                ...styles.btnOutline,
                                                transform: hovered === 'back' ? 'scale(1.02)' : 'scale(1)',
                                                textDecoration: 'none',
                                            }}
                                            onMouseEnter={() => this.setState({ hovered: 'back' })}
                                            onMouseLeave={() => this.setState({ hovered: null })}
                                        >
                                            ← Back
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="UI-form-container">
                                {(this.state.pagename === "New Proforma Invoice" ||
                                    this.state.accepteditems.length > 0 || this.state.serviceList.length > 0) ? (
                                    ""
                                ) : (
                                    <div className="UI-form-section">
                                        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                                            {/* <div style={{ display: "flex", gap: "10px" }}>
                                                <TabButton active={this.state.invtype === "Direct Invoice" || this.state.invtype === "Non-Inventory Invoice"} onClick={() => {this.setState({ invtype: "Direct Invoice" });this.handleSaleOrder(null, null);}}>Direct Invoice</TabButton>
                                                <TabButton active={this.state.invtype === "Order Invoice"} onClick={() => this.setState({ invtype: "Order Invoice" })}>SO Invoice</TabButton>
                                            </div> */}

                                            <TabSwitch value={this.state.invtype} onChange={(value) => { this.setState({ invtype: value }); value === "Direct Invoice" && this.handleSaleOrder(null, null); }} activeTabClass={theme === "modern" ? "tw-bg-gradient-to-r tw-from-blue-600 tw-to-indigo-600 tw-text-white tw-py-1" : "!tw-bg-[#4d4d4d] tw-text-white tw-py-1"} options={[
                                                { label: "Direct Invoice", value: "Direct Invoice" },
                                                { label: "Order Invoice", value: "Order Invoice" }
                                            ]} />

                                            {(this.state.invtype === "Direct Invoice" || this.state.invtype === "Non-Inventory Invoice") && (
                                                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "16px" }}>
                                                    <RectangularTabButton label="With Inventory" checked={this.state.invtype === "Direct Invoice"} onClick={() => { this.setState({ invtype: "Direct Invoice" }); this.handleSaleOrder(null, null); }} description={"Choose Product or Service from inventory"} />
                                                    <RectangularTabButton label="Without Inventory (Direct Invoice)" checked={this.state.invtype === "Non-Inventory Invoice"} onClick={() => { this.setState({ invtype: "Non-Inventory Invoice" }); this.handleSaleOrder(null, null); }} description={"Enter Product or service information manually"} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {this.state.invtype === "Non-Inventory Invoice" ? (
                                    <NonInvInvoice />
                                ) : (
                                    <Formik
                                        initialValues={{
                                            custom,
                                            customer,
                                            custid,
                                            saleorderdata,
                                            itemid,
                                            itemname,
                                            quantity,
                                            orderedquantity,
                                            grandtotal,
                                            status,
                                            saleorderitems,
                                            poid,
                                            DnIDList,
                                            currencylist,
                                            currencyid,
                                            curconversionrate,
                                            tcs,
                                            tcsreq,
                                            tcsamount,
                                            pendingquantity,
                                            creditperiod,
                                            additionalchargeslist,
                                            additionalcharges,
                                            additionalchargestax,
                                            totaladditionalcharges,
                                            additionalchargestaxamount,
                                            natureofcharge,
                                            vehiclenum,
                                            distance,
                                            transporterid,
                                            WarehouseList,
                                            DepartmentList,
                                            CategoryList,
                                            filteritemlist,
                                            sizelist,
                                            colourlist,
                                            brandslist,
                                            filterserv,
                                            serviceitemList,
                                            serviceList,
                                            service,
                                            serviceid,
                                            ServiceCategoryList,
                                            servicecategory,
                                            servicecatid,
                                            servicetax,
                                            servicecode,
                                            servicecost,
                                            servicecostconv,
                                            servicecgst,
                                            servicesgst,
                                            serviceigst,
                                            servicegst,
                                            servicevat,
                                            servicecostwttax,
                                            servicecostwttaxconv,
                                            servicetaxamount,
                                            servicedescription,
                                            servicetotal,
                                            grandservicetotal,
                                            serviceerr,
                                            markup1,
                                            markup,
                                            invoiceremarks
                                        }}
                                        validateOnChange={false}
                                        validate={this.validate}
                                        onSubmit={this.onSubmit}
                                        enableReinitialize={true}
                                    >
                                        {({ setFieldValue, values, errors }) => (
                                            <Form className="UI-form">
                                                {/* SECTION: Customer & Invoice Information */}
                                                <div className="UI-form-section tw-border tw-border-dotted tw-mb-3 tw-pb-2 mx-0">
                                                    <h3 className="UI-section-title" style={{ backgroundColor: '#f4f4f4', padding: '12px' }}>
                                                        Customer and invoice information
                                                    </h3>

                                                    {/* Row 1: Primary Selection & Dates */}
                                                    <div className="UI-form-grid tw-px-2" style={{ gridTemplateColumns: 'repeat(4, 1fr)', marginBottom: '10px' }}>
                                                        <AutoCompeteField id="customer" name="customer" type="text" options={custom} valueKey={"id"} labelKey={"companyname"} value={this.state.custid} label={`Customer`} required placeholder="Select Customer Name" onChange={this.handleCustomer} error={errors?.customer} />

                                                        {/* <div className="UI-form-group">
                                                            <label className="UI-label">Customer *</label>
                                                            <Autocomplete
                                                                id="subaccount"
                                                                name="customer"
                                                                options={custom}
                                                                getOptionLabel={(option) => option.companyname}
                                                                value={custom.find(e => e.id === this.state.custid) || null}
                                                                onChange={this.handleCustomer}
                                                                disabled={this.state.invid !== -1}
                                                                renderInput={(params) => (
                                                                    <div ref={params.InputProps.ref}>
                                                                        <input
                                                                            type="text"
                                                                            {...params.inputProps}
                                                                            className="UI-input"
                                                                            placeholder="Select customer"
                                                                        />
                                                                    </div>
                                                                )}
                                                            />
                                                        </div> */}

                                                        {this.state.invtype !== "Direct Invoice" && (<div className="UI-form-group"><AutoCompeteField id="saleorder" name="saleorder" type="text" options={saleorderdata} valueKey={null} labelKey={null} value={this.state.saleorderid} label={`Sales Order`} placeholder="Select Sales Order" onChange={this.handleSaleOrder} disabled={this.state.pagename === "Edit Invoice"} required error={errors?.saleorderid} /></div>)}

                                                        <div className="UI-form-group">
                                                            <AutoCompeteField id="warehouse" name="warehouse" type="text" options={WarehouseList} valueKey={"name"} labelKey={"name"} value={this.state.warehouse} label={`Org Unit`} placeholder="Select Org Unit" onChange={this.handleWarehouse} disabled={this.state.grandtotal > 0 || this.state.pagename === "Edit Invoice"} required error={errors?.warehouse} />

                                                            {/* <label className="UI-label">Org Unit</label>
                                                                            <Autocomplete
                                                                                options={WarehouseList}
                                                                                getOptionLabel={(option) => option.name}
                                                                                value={WarehouseList.find(e => e.name === this.state.warehouse) || null}
                                                                                disabled={this.state.accepteditems.length > 0 || this.state.serviceList.length > 0}
                                                                                onChange={this.handleWarehouse}
                                                                                renderInput={(params) => (
                                                                                    <div ref={params.InputProps.ref}>
                                                                                        <input
                                                                                            type="text"
                                                                                            {...params.inputProps}
                                                                                            className="UI-input"
                                                                                            placeholder="Select org unit"
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                            /> */}
                                                        </div>

                                                        <div className="UI-form-group">
                                                            <TextfieldComponent
                                                                label={"Credit Period (Days)"}
                                                                type="number"
                                                                className="UI-input"
                                                                value={this.state.creditperiod}
                                                                onChange={(e) => {
                                                                    const days = isInvalid.includes(e.target.value) ? 0 : parseInt(e.target.value);
                                                                    const baseDate = this.state.SDdate && this.state.customcreatedAt
                                                                        ? moment(this.state.customcreatedAt)
                                                                        : moment(new Date());

                                                                    const currentDue = this.state.duedate ? moment(this.state.duedate) : moment(new Date());
                                                                    const nextDue = baseDate.add(days, 'days')
                                                                        .hour(currentDue.hour())
                                                                        .minute(currentDue.minute())
                                                                        .second(currentDue.second());

                                                                    this.setState({
                                                                        creditperiod: days,
                                                                        duedate: nextDue
                                                                    });
                                                                }}
                                                                min="0"
                                                            />
                                                        </div>

                                                        <div className="UI-form-group">
                                                            <label className="UI-label">Due Date</label>
                                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DatePicker
                                                                        showTodayButton
                                                                        value={this.state.duedate ? dayjs(this.state.duedate) : null}
                                                                        open={this.state.openDuePicker}
                                                                        onOpen={() => this.setState({ openDuePicker: true })}
                                                                        onClose={() => this.setState({ openDuePicker: false })}
                                                                        minDate={
                                                                            this.state.SDdate && this.state.customcreatedAt
                                                                                ? dayjs(this.state.customcreatedAt)
                                                                                : dayjs()
                                                                        }
                                                                        onChange={(date) => {
                                                                            const currentDue = dayjs(this.state.duedate || new Date());
                                                                            const nextDueDate = dayjs(date)
                                                                                .hour(currentDue.hour())
                                                                                .minute(currentDue.minute())
                                                                                .second(currentDue.second());

                                                                            const nextDueMoment = moment(nextDueDate.toDate());
                                                                            const baseDate = this.state.SDdate && this.state.customcreatedAt
                                                                                ? moment(this.state.customcreatedAt)
                                                                                : moment(new Date());

                                                                            // Calculate days difference ignoring time for credit period
                                                                            const diffDays = nextDueMoment.clone().startOf('day').diff(baseDate.clone().startOf('day'), 'days');

                                                                            this.setState({
                                                                                duedate: nextDueMoment,
                                                                                creditperiod: diffDays >= 0 ? diffDays : 0
                                                                            });
                                                                        }}
                                                                        renderInput={(params) => (
                                                                            <div
                                                                                style={{ position: "relative", flex: 1, cursor: "pointer" }}
                                                                                onClick={() => this.setState({ openDuePicker: true })}
                                                                            >
                                                                                <input
                                                                                    {...params.inputProps}
                                                                                    ref={params.inputRef}
                                                                                    className="UI-input"
                                                                                    placeholder="Date"
                                                                                    style={{ width: "100%", paddingRight: "40px", cursor: "pointer" }}
                                                                                    readOnly
                                                                                />
                                                                                <div
                                                                                    style={{
                                                                                        position: "absolute",
                                                                                        right: "10px",
                                                                                        top: "50%",
                                                                                        transform: "translateY(-50%)",
                                                                                        display: "flex",
                                                                                        alignItems: "center"
                                                                                    }}
                                                                                >
                                                                                    {params.InputProps.endAdornment}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    />
                                                                </LocalizationProvider>
                                                                <input
                                                                    type="time"
                                                                    className="UI-input"
                                                                    style={{ width: "110px" }}
                                                                    value={this.state.duedate ? dayjs(this.state.duedate).format("HH:mm") : "00:00"}
                                                                    onChange={(e) => {
                                                                        const [hours, minutes] = e.target.value.split(':');
                                                                        const newDate = dayjs(this.state.duedate || new Date()).hour(parseInt(hours)).minute(parseInt(minutes));
                                                                        this.setState({ duedate: moment(newDate.toDate()) });
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className=" col-md-12 m-1 p-0">
                                                        <div className="tw-flex tw-gap-2.5 tw-mb-4 tw-flex-wrap tw-px-1">
                                                            <RoundedTabButton label={"With Tax"} checked={this.state.taxrequired} onClick={() => this.setState(prev => ({ taxrequired: !prev.taxrequired }))} />
                                                            <RoundedTabButton label={"Custome Invoice Date"} checked={this.state.SDdate} onClick={() => this.setState(prev => ({ SDdate: !prev.SDdate }))} />
                                                            <RoundedTabButton label={"Recurring Invoice"} checked={this.state.recurring} onClick={() => this.setState(prev => ({ recurring: !prev.recurring }))} />
                                                        </div>
                                                    </div>

                                                    {/* Row 2: Toggles and Conditional Fields */}
                                                    <div className="form-row UI-form-row-flexible tw-gap-2 px-2">
                                                        {/* Toggles Group - Explicit 25px gap as requested */}
                                                        {/* <div style={{ display: 'flex', gap: '25px', alignItems: 'flex-end', flexShrink: 0 }}>
                                                            <div className="UI-form-group" style={{ minWidth: 'fit-content', flexShrink: 1 }}>
                                                                <FormControlLabel
                                                                    labelPlacement="start"
                                                                    className="os-switch-label"
                                                                    style={{ gap: '4px' }}
                                                                    control={
                                                                        <OSSwitch
                                                                            checked={this.state.taxrequired}
                                                                            onChange={(checked) => this.setState({ taxrequired: checked }, this.recomputeTotals)}
                                                                            disabled={(this.state.accepteditems && this.state.accepteditems.length > 0) || (this.state.serviceList && this.state.serviceList.length > 0)}
                                                                        />
                                                                    }
                                                                    label="With Tax"
                                                                />
                                                            </div>

                                                            <div className="UI-form-group" style={{ minWidth: 'fit-content', flexShrink: 1 }}>
                                                                <FormControlLabel
                                                                    labelPlacement="start"
                                                                    style={{ gap: '4px' }}
                                                                    className="os-switch-label"
                                                                    control={
                                                                        <OSSwitch
                                                                            checked={this.state.SDdate}
                                                                            onChange={() => this.setState({ SDdate: !this.state.SDdate })}
                                                                        />
                                                                    }
                                                                    label="Custom Date"
                                                                />
                                                            </div>
                                                        </div> */}

                                                        {/* Conditional Fields - Will use the parent 12px gap */}
                                                        {/* Conditional Fields */}
                                                        {this.state.taxrequired === true && <div className={ccountry === "India" && this.state.taxtype === "GST" ? `tw-flex col-md-3` : `col-md-2`}>
                                                            <div className={ccountry === "India" && this.state.taxtype === "GST" ? `UI-form-group col-md-6` : "UI-form-group col-md-12"}>
                                                                <AutoCompeteField label={"Tax Type"} options={this.state.taxtypelist} labelKey={null} valueKey={null} onChange={this.handleTaxtypeChange} value={this.state.taxtype}
                                                                    disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes(this.state.grandservicetotal) || this.state.orderfrom === 1 || !isInvalid.includes(this.state.saleorderid)} />
                                                            </div>
                                                            {ccountry === "India" && this.state.taxtype === "GST" &&
                                                                <div className="UI-form-group col-md-6">
                                                                    <AutoCompeteField label={"GST Type"} options={this.state.gsttypelist} labelKey={null} valueKey={null} onChange={this.handleGsttypeChange} value={this.state.gsttype}
                                                                        disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes(this.state.grandservicetotal) || this.state.orderfrom === 1 || !isInvalid.includes(this.state.saleorderid)} />
                                                                </div>
                                                            }
                                                        </div>
                                                        }

                                                        {this.state.SDdate && (<>
                                                            <div className="UI-form-group col-md-3">
                                                                <DatePickerField disableFuture={true} disablePast={false} minDate={transactionFrom ? dayjs(transactionFrom) : dayjs("1900-01-01")} label={"Custom Invoice Date"} value={this.state.customcreatedAt} onDateChange={this.handleCustomInvoiceDateChange} timePicker={true} onTimeChange={this.handleCustomInvoiceTimeChange} />
                                                                {/* <label className="UI-label">Custom Invoice Date</label>
                                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                        <DatePicker
                                                                            disableFuture
                                                                            showTodayButton
                                                                            open={this.state.openCustomPicker}
                                                                            onOpen={() => this.setState({ openCustomPicker: true })}
                                                                            onClose={() => this.setState({ openCustomPicker: false })}
                                                                            minDate={(() => {
                                                                                let minDate;
                                                                                if (typeof transactionFrom !== "undefined" && transactionFrom) {
                                                                                    minDate = dayjs(transactionFrom);
                                                                                } else if (this.state.sodata?.createdAt) {
                                                                                    minDate = dayjs(this.state.sodata.createdAt);
                                                                                } else {
                                                                                    minDate = dayjs("1900-01-01");
                                                                                }
                                                                                return minDate;
                                                                            })()}
                                                                            maxDate={dayjs()}
                                                                            value={this.state.customcreatedAt ? dayjs(this.state.customcreatedAt) : null}
                                                                            onChange={(date) => {
                                                                                const currentCustom = dayjs(this.state.customcreatedAt || new Date());
                                                                                const nextCustomDate = dayjs(date)
                                                                                    .hour(currentCustom.hour())
                                                                                    .minute(currentCustom.minute())
                                                                                    .second(currentCustom.second());

                                                                                const nextCustomMoment = moment(nextCustomDate.toDate());
                                                                                const currentDue = this.state.duedate ? moment(this.state.duedate) : moment(new Date());

                                                                                const nextDue = nextCustomMoment.clone().add(this.state.creditperiod, 'days')
                                                                                    .hour(currentDue.hour())
                                                                                    .minute(currentDue.minute())
                                                                                    .second(currentDue.second());

                                                                                this.setState({
                                                                                    customcreatedAt: nextCustomDate.toDate(),
                                                                                    duedate: nextDue
                                                                                });
                                                                            }}
                                                                            renderInput={(params) => (
                                                                                <div
                                                                                    style={{ position: "relative", flex: 1, cursor: "pointer" }}
                                                                                    onClick={() => this.setState({ openCustomPicker: true })}
                                                                                >
                                                                                    <input
                                                                                        {...params.inputProps}
                                                                                        ref={params.inputRef}
                                                                                        className="UI-input"
                                                                                        placeholder="Date"
                                                                                        style={{ width: "100%", paddingRight: "40px", cursor: "pointer" }}
                                                                                        readOnly
                                                                                    />
                                                                                    <div
                                                                                        style={{
                                                                                            position: "absolute",
                                                                                            right: "10px",
                                                                                            top: "50%",
                                                                                            transform: "translateY(-50%)",
                                                                                            display: "flex",
                                                                                            alignItems: "center"
                                                                                        }}
                                                                                    >
                                                                                        {params.InputProps.endAdornment}
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        />
                                                                    </LocalizationProvider>
                                                                    <input
                                                                        type="time"
                                                                        className="UI-input"
                                                                        style={{ width: "110px", flexShrink: 1 }}
                                                                        value={this.state.customcreatedAt ? dayjs(this.state.customcreatedAt).format("HH:mm") : "00:00"}
                                                                        onChange={(e) => {
                                                                            const [hours, minutes] = e.target.value.split(':');
                                                                            const newDate = dayjs(this.state.customcreatedAt || new Date()).hour(parseInt(hours)).minute(parseInt(minutes));
                                                                            this.setState({
                                                                                customcreatedAt: newDate.toDate(),
                                                                                duedate: moment(newDate.toDate()).add(this.state.creditperiod, "days")
                                                                            });
                                                                        }}
                                                                    />
                                                                </div> */}
                                                            </div>
                                                            <div className="UI-form-group col-md-3">
                                                                {this.state.finacialLatestInvoiceNumber === null ? <TextfieldComponent value={this.state.invNumber} label={"Enter Financial Invoice Number"} onChange={(e) => this.setState({ invNumber: e.target.value })} /> : <TextfieldComponent value={this.state.finacialLatestInvoiceNumber} label={"Next Financial Invoice Id"} disabled />}
                                                            </div>
                                                        </>
                                                        )}

                                                        {/* {this.state.multiCurrency && ( */}
                                                        <div className={this.state.currency !== this.state.basecurrency ? "col-md-3" : "col-md-2"}>
                                                            <div style={{ display: 'grid', gridTemplateColumns: this.state.currency !== this.state.basecurrency && 'auto auto auto', alignItems: 'center', gap: '4px' }}>
                                                                {/* First column: Invoice Currency */}
                                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                    <label className="UI-label" >Invoice Currency</label>
                                                                    <Autocomplete
                                                                        id="currency"
                                                                        name="currency"
                                                                        options={currencylist}
                                                                        getOptionLabel={(option) => option.currency}
                                                                        value={this.state.currency ? currencylist.find(e => e.currency === this.state.currency) : null}
                                                                        onChange={this.handleCurrency}
                                                                        disabled={!isInvalid.includes(this.state.grandtotal) || !isInvalid.includes(this.state.grandservicetotal) || this.state.orderfrom === 1 || !isInvalid.includes(this.state.saleorderid)}
                                                                        renderInput={(params) => (
                                                                            <div ref={params.InputProps.ref} style={{ position: 'relative', width: '100%' }}>
                                                                                <input
                                                                                    type="text"
                                                                                    {...params.inputProps}
                                                                                    className="UI-input"
                                                                                    placeholder="Select currency"
                                                                                    value={this.state.currency}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        paddingRight: this.state.currency && this.state.currency !== this.state.basecurrency ? '30px' : undefined
                                                                                    }}
                                                                                />

                                                                                <span
                                                                                    style={{
                                                                                        position: 'absolute',
                                                                                        right: '10px',
                                                                                        top: '50%',
                                                                                        transform: 'translateY(-50%)',
                                                                                        pointerEvents: 'none',
                                                                                        fontSize: this.state.currency && this.state.currency !== this.state.basecurrency ? '13px' : "8px",
                                                                                        color: '#666'
                                                                                    }}
                                                                                >
                                                                                    {this.state.currency && this.state.currency !== this.state.basecurrency ? 1 : "▼"}
                                                                                </span>

                                                                            </div>
                                                                        )}
                                                                    />
                                                                </div>

                                                                {/* Equals sign column - only shown when currencies differ */}
                                                                {this.state.currency !== this.state.basecurrency && (
                                                                    <div style={{ alignSelf: 'center', marginTop: '20px', textAlign: "center" }}>
                                                                        <span style={{ fontSize: '16px', fontWeight: 500, lineHeight: 1 }}>=</span>
                                                                    </div>
                                                                )}

                                                                {/* Third column: Conversion Rate (only shown when currencies differ) */}
                                                                {this.state.currency !== this.state.basecurrency && (
                                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                        <label className="UI-label" >Conversion Rate</label>
                                                                        <div style={{ position: 'relative', }}>
                                                                            <input
                                                                                type="number"
                                                                                className="UI-input"
                                                                                value={this.state.curconversionrate}
                                                                                onChange={(e) => this.setState({ curconversionrate: e.target.value }, this.recomputeTotals)}
                                                                                disabled={
                                                                                    !isInvalid.includes(this.state.grandtotal) ||
                                                                                    !isInvalid.includes(this.state.grandservicetotal) ||
                                                                                    this.state.orderfrom === 1 ||
                                                                                    !isInvalid.includes(this.state.saleorderid)
                                                                                }
                                                                                style={{
                                                                                    width: '100%',
                                                                                    paddingRight: '55px'
                                                                                }}
                                                                            />
                                                                            <span
                                                                                style={{
                                                                                    position: 'absolute',
                                                                                    right: '12px',
                                                                                    top: '50%',
                                                                                    transform: 'translateY(-50%)',
                                                                                    pointerEvents: 'none',
                                                                                    fontSize: '13px',
                                                                                    color: '#666'
                                                                                }}
                                                                            >
                                                                                {this.state.basecurrency}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {/* )} */}

                                                        {this.state.recurring && <>
                                                            <div className="col-md-3">
                                                                <DatePickerField disablePast={true} minDate={transactionFrom ? dayjs(transactionFrom) : dayjs("1900-01-01")} label={"Recurring End Date"} value={this.state.recurringenddate} onDateChange={this.handleRecurringEndDateChange} timePicker={true} onTimeChange={this.handleRecurringEndTimeChange} />
                                                            </div>
                                                            <div className="col-md-2">
                                                                <SelectField label={"Recurring Period"} lableKey={null} lableValue={null} list={["Daily", "Weekly", "Monthly", "Quarterly", "HalfYearly", "Yearly"]} value={this.state.recurringperiod} onChange={this.handleInvoiceRecurringPeriodChange} />
                                                            </div>
                                                            <div className="col-md-3">
                                                                <SelectField label={"Recurring Invocie Confirmation"} lableKey={null} lableValue={null} list={["Auto", "Manual"]} value={this.state.recurringconfirm} onChange={this.handleInvoiceRecurringConfirmationChange} />
                                                            </div>
                                                            <div className="col-md-12 text-xs tw-text-gray-600"><span className="mr-1">ⓘ</span> {this.state.recurringconfirm === "Auto" ? `Tax invoices will be generated ${this.state.recurringperiod} (no approval required).` : `Temporary invoices will be generated ${this.state.recurringperiod}, approval will be required to generate a tax invoice.`}</div>
                                                        </>}

                                                        <div className="col-md-12">
                                                            <TextfieldComponent name="subject" label="Subject" value={this.state.subject} onChange={(e) => this.setState({ subject: e.target.value && e.target.value?.length > 200 ? this.state.subject : e.target.value })} />
                                                        </div>

                                                    </div>
                                                </div>

                                                {/* SECTION: Order Details (if SO selected) */}
                                                {this.state.saleorderid !== "" && this.state.saleorderid && this.state.sodata ? (
                                                    <>
                                                        <div className="UI-form-section" style={{ backgroundColor: '#fff', border: 'none', padding: '0' }}>
                                                            <h3 className="UI-section-title" style={{ backgroundColor: '#f4f4f4', padding: '12px', marginBottom: '20px' }}>
                                                                <i className="fas fa-info-circle" style={{ marginRight: '8px' }}></i> Sale Order Summary
                                                            </h3>

                                                            <div style={styles.detailGrid}>
                                                                {/* Card 1: Basic Order Information */}
                                                                <div style={styles.detailSection}>
                                                                    <h4 style={styles.sectionTitleSummary}>
                                                                        <i className="fas fa-file-invoice" style={{ color: '#4d4d4d' }}></i> Basic Order Information
                                                                    </h4>

                                                                    <div style={styles.detailRow}>
                                                                        <span style={styles.detailLabel}>Order ID</span>
                                                                        <span style={styles.detailValue}>{this.state.sodata.customsoid}</span>
                                                                    </div>

                                                                    <div style={styles.detailRow}>
                                                                        <span style={styles.detailLabel}>Customer</span>
                                                                        <span style={styles.detailValue}>{this.state.sodata.customer}</span>
                                                                    </div>

                                                                    <div style={styles.detailRow}>
                                                                        <span style={styles.detailLabel}>Created By</span>
                                                                        <span style={styles.detailValue}>{this.state.sodata.createdby}</span>
                                                                    </div>

                                                                    {this.state.sodata.agent && (
                                                                        <div style={styles.detailRow}>
                                                                            <span style={styles.detailLabel}>Agent</span>
                                                                            <span style={styles.detailValue}>{this.state.sodata.agent}</span>
                                                                        </div>
                                                                    )}

                                                                    {this.state.sodata.poid && (
                                                                        <div style={styles.detailRow}>
                                                                            <span style={styles.detailLabel}>PO Ref Id/no</span>
                                                                            <span style={styles.detailValue}>{this.state.sodata.poid}</span>
                                                                        </div>
                                                                    )}

                                                                    {this.state.sodata.pofile && (
                                                                        <div style={styles.detailRow}>
                                                                            <span style={styles.detailLabel}>PO File</span>
                                                                            <span style={styles.detailValue}>
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={() => this.handledownload(this.state.sodata.pofile)}
                                                                                    className="UI-link-button"
                                                                                    style={{
                                                                                        fontSize: '0.85rem',
                                                                                        fontWeight: '600',
                                                                                        color: '#2563eb',
                                                                                        textDecoration: 'underline'
                                                                                    }}
                                                                                >
                                                                                    <i className="fas fa-download" style={{ marginRight: '4px' }}></i>
                                                                                    {this.state.sodata.pofile}
                                                                                </button>
                                                                            </span>
                                                                        </div>

                                                                    )}
                                                                    <div style={styles.detailRow}>
                                                                        <span style={styles.detailLabel}>Credit Period</span>
                                                                        <span style={styles.detailValue}>{this.state.sodata.creditperiod || 0} Days</span>
                                                                    </div>

                                                                    <div style={styles.detailRow}>
                                                                        <span style={styles.detailLabel}>Org Unit</span>
                                                                        <span style={styles.detailValue}>{this.state.sodata.warehouse || "N/A"}</span>
                                                                    </div>

                                                                    <div style={styles.detailRow}>
                                                                        <span style={styles.detailLabel}>Tax Type</span>
                                                                        <span style={styles.detailValue}>
                                                                            {this.state.sodata.taxtype}
                                                                            {this.state.sodata.taxtype === "GST" && ` (${this.state.sodata.gsttype})`}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                {/* Card 2: Financial & Credit Details */}
                                                                <div style={styles.detailSection}>
                                                                    <h4 style={styles.sectionTitleSummary}>
                                                                        <i className="fas fa-chart-line" style={{ color: '#4d4d4d' }}></i> Financial & Credit Details
                                                                    </h4>

                                                                    <div style={styles.detailRow}>
                                                                        <span style={styles.detailLabel}>Total Amount</span>
                                                                        <span style={{ ...styles.detailValue, color: '#2563eb', fontSize: '1rem' }}>
                                                                            <NumericFormat
                                                                                displayType="text"
                                                                                value={this.state.sodata.sototalwtax}
                                                                                decimalScale={2}
                                                                                fixedDecimalScale
                                                                                thousandSeparator
                                                                                thousandsGroupStyle={thousandsdisplay}
                                                                                prefix={currency}
                                                                            />
                                                                        </span>
                                                                    </div>

                                                                    {this.state.saleorderitems.length > 0 && (
                                                                        <div style={styles.detailRow}>
                                                                            <span style={styles.detailLabel}>Consignment Amount</span>
                                                                            <span style={{ ...styles.detailValue, fontWeight: '700' }}>
                                                                                <NumericFormat
                                                                                    displayType="text"
                                                                                    value={this.state.sodata.sototalwtax - this.state.sodata.advanceamountpaid}
                                                                                    decimalScale={2}
                                                                                    fixedDecimalScale
                                                                                    thousandSeparator
                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                    prefix={currency}
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    )}

                                                                    {this.state.sodata.advancepaymentreq === "True" && (
                                                                        <>
                                                                            <div style={styles.detailRow}>
                                                                                <span style={styles.detailLabel}>Advance Req.</span>
                                                                                <span style={styles.detailValue}>
                                                                                    <NumericFormat
                                                                                        displayType="text"
                                                                                        value={this.state.sodata.advanceamountreq}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale
                                                                                        thousandSeparator
                                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                                        prefix={currency}
                                                                                    />
                                                                                </span>
                                                                            </div>
                                                                            <div style={styles.detailRow}>
                                                                                <span style={styles.detailLabel}>Advance Received</span>
                                                                                <span style={{ ...styles.detailValue, color: '#16a34a' }}>
                                                                                    <NumericFormat
                                                                                        displayType="text"
                                                                                        value={this.state.sodata.advanceamountpaid}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale
                                                                                        thousandSeparator
                                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                                        prefix={currency}
                                                                                    />
                                                                                </span>
                                                                            </div>
                                                                        </>
                                                                    )}


                                                                    <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px dashed #e2e8f0' }}>


                                                                        <div style={styles.detailRow}>
                                                                            <span style={styles.detailLabel}>Credit Value</span>
                                                                            <span style={styles.detailValue}>
                                                                                <NumericFormat
                                                                                    displayType="text"
                                                                                    value={this.state.sodata.creditvalue || 0}
                                                                                    decimalScale={2}
                                                                                    fixedDecimalScale
                                                                                    thousandSeparator
                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                    prefix={currency}
                                                                                />
                                                                            </span>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Ordered Items / Products Table (if applicable) */}
                                                        {this.state.sotype === 0 || this.state.sotype === 2 ? (
                                                            <>
                                                                {this.state.sotype === 0 &&
                                                                    this.state.pagename !== "New Proforma Invoice" &&
                                                                    this.state.invid === -1 && (
                                                                        <div className="UI-table-container">
                                                                            <h4 className="UI-section-title">Ordered Items / Products</h4>
                                                                            <table className="UI-table">
                                                                                <thead className="UI-table-header">
                                                                                    <tr>
                                                                                        <th className="UI-th"></th>
                                                                                        <th className="UI-th"></th>
                                                                                        {this.state.saleorderitems.filter(e => e.soidforadjust).length > 0 && (
                                                                                            <th className="UI-th">Adjusted from SO</th>
                                                                                        )}
                                                                                        <th className="UI-th">Item Name</th>
                                                                                        {this.state.sodata.taxtype !== "NA" && <th className="UI-th">HSN</th>}
                                                                                        <th className="UI-th">Price({currency})</th>
                                                                                        {currency !== this.state.sodata.currency && (
                                                                                            <>
                                                                                                <th className="UI-th">Price({this.state.sodata.currency})</th>
                                                                                                <th className="UI-th">Price Variance (%)</th>
                                                                                            </>
                                                                                        )}
                                                                                        <th className="UI-th">Type</th>
                                                                                        <th className="UI-th">Quantity</th>
                                                                                        <th className="UI-th">Pending Qty</th>
                                                                                        <th className="UI-th">UOM</th>
                                                                                        <th className="UI-th">Discount({currency})</th>
                                                                                        {currency !== this.state.sodata.currency && (
                                                                                            <th className="UI-th">Discount({this.state.sodata.currency})</th>
                                                                                        )}
                                                                                        <th className="UI-th">Total({currency})</th>
                                                                                        {currency !== this.state.sodata.currency && (
                                                                                            <th className="UI-th">Total({this.state.sodata.currency})</th>
                                                                                        )}
                                                                                        {this.state.sodata.taxtype !== "NA" && (
                                                                                            <>
                                                                                                {this.state.sodata.taxtype === "GST" && ccountry === "India" && this.state.sodata.gsttype === "INTRASTATE" ? (
                                                                                                    <>
                                                                                                        <th className="UI-th">CGST({currency})</th>
                                                                                                        <th className="UI-th">SGST({currency})</th>
                                                                                                        {currency !== this.state.sodata.currency && (
                                                                                                            <>
                                                                                                                <th className="UI-th">CGST({this.state.sodata.currency})</th>
                                                                                                                <th className="UI-th">SGST({this.state.sodata.currency})</th>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        <th className="UI-th">
                                                                                                            {this.state.sodata.taxtype === "GST" ? "IGST" : this.state.sodata.taxtype}({currency})
                                                                                                        </th>
                                                                                                        {currency !== this.state.sodata.currency && (
                                                                                                            <th className="UI-th">
                                                                                                                {this.state.sodata.taxtype === "GST" ? "IGST" : this.state.sodata.taxtype}({this.state.sodata.currency})
                                                                                                            </th>
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                                <th className="UI-th">Total Price({currency})</th>
                                                                                                {currency !== this.state.sodata.currency && (
                                                                                                    <th className="UI-th">Total Price({this.state.sodata.currency})</th>
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {this.state.saleorderitems.map((row, index) => (
                                                                                        <React.Fragment key={index}>
                                                                                            <tr className="UI-table-row">
                                                                                                <td className="UI-td">
                                                                                                    {!this.state.accepteditems.map(data => data.id).includes(row.id) && (
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            onClick={() => this.handleAccept(row.id)}
                                                                                                            className="UI-btn UI-btn-primary UI-btn-small"
                                                                                                        >
                                                                                                            Add
                                                                                                        </button>
                                                                                                    )}
                                                                                                </td>
                                                                                                <td className="UI-td">
                                                                                                    <IconButton
                                                                                                        size="small"
                                                                                                        onClick={() => this.setState({ open: !this.state.open })}
                                                                                                    >
                                                                                                        {this.state.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                                                                    </IconButton>
                                                                                                </td>
                                                                                                {this.state.saleorderitems.filter(e => e.soidforadjust).length > 0 && (
                                                                                                    <td className="UI-td">{row.soidforadjust}</td>
                                                                                                )}
                                                                                                <td className="UI-td">{row.name}</td>
                                                                                                {this.state.sodata.taxtype !== "NA" && <td className="UI-td">{row.hsn}</td>}
                                                                                                <td className="UI-td UI-amount">
                                                                                                    <NumericFormat displayType="text" value={row.price} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                                </td>
                                                                                                {currency !== this.state.sodata.currency && (
                                                                                                    <>
                                                                                                        <td className="UI-td UI-amount">
                                                                                                            <NumericFormat displayType="text" value={row.ccprice || (row.price * this.state.sodata.curconversionrate)} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                                        </td>
                                                                                                        <td className="UI-td">{row.pricevariance}</td>
                                                                                                    </>
                                                                                                )}
                                                                                                <td className="UI-td">{row.salesenum}</td>
                                                                                                <td className="UI-td">{row.quantity}</td>
                                                                                                <td className="UI-td">{row.pending}</td>
                                                                                                <td className="UI-td">{row.uom}</td>
                                                                                                <td className="UI-td UI-amount">
                                                                                                    <NumericFormat displayType="text" value={row.discountamount} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({row.discount}%)
                                                                                                </td>
                                                                                                {currency !== this.state.sodata.currency && (
                                                                                                    <td className="UI-td UI-amount">
                                                                                                        <NumericFormat displayType="text" value={row.ccdiscountamount || (row.discountamount * this.state.sodata.curconversionrate)} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({row.discount}%)
                                                                                                    </td>
                                                                                                )}
                                                                                                <td className="UI-td UI-amount">
                                                                                                    <NumericFormat displayType="text" value={row.totalprice} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                                </td>
                                                                                                {currency !== this.state.sodata.currency && (
                                                                                                    <td className="UI-td UI-amount">
                                                                                                        <NumericFormat displayType="text" value={row.cctotalprice || (row.totalprice * this.state.sodata.curconversionrate)} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                                    </td>
                                                                                                )}
                                                                                                {this.state.sodata.taxtype !== "NA" && (
                                                                                                    <>
                                                                                                        {this.state.sodata.taxtype === "GST" && ccountry === "India" && this.state.sodata.gsttype === "INTRASTATE" ? (
                                                                                                            <>
                                                                                                                <td className="UI-td UI-amount">
                                                                                                                    <NumericFormat displayType="text" value={row.taxamount / 2} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({row.tax / 2}%)
                                                                                                                </td>
                                                                                                                <td className="UI-td UI-amount">
                                                                                                                    <NumericFormat displayType="text" value={row.taxamount / 2} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({row.tax / 2}%)
                                                                                                                </td>
                                                                                                                {currency !== this.state.sodata.currency && (
                                                                                                                    <>
                                                                                                                        <td className="UI-td UI-amount">
                                                                                                                            <NumericFormat displayType="text" value={(row.cctaxamount ? row.cctaxamount / 2 : (row.taxamount / 2) * this.state.sodata.curconversionrate)} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({row.tax / 2}%)
                                                                                                                        </td>
                                                                                                                        <td className="UI-td UI-amount">
                                                                                                                            <NumericFormat displayType="text" value={(row.cctaxamount ? row.cctaxamount / 2 : (row.taxamount / 2) * this.state.sodata.curconversionrate)} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({row.tax / 2}%)
                                                                                                                        </td>
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </>
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                <td className="UI-td UI-amount">
                                                                                                                    <NumericFormat displayType="text" value={row.taxamount} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({row.tax}%)
                                                                                                                </td>
                                                                                                                {currency !== this.state.sodata.currency && (
                                                                                                                    <td className="UI-td UI-amount">
                                                                                                                        <NumericFormat displayType="text" value={row.cctaxamount || (row.taxamount * this.state.sodata.curconversionrate)} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({row.tax}%)
                                                                                                                    </td>
                                                                                                                )}
                                                                                                            </>
                                                                                                        )}
                                                                                                        <td className="UI-td UI-amount">
                                                                                                            <NumericFormat displayType="text" value={row.totalpricewtax} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                                        </td>
                                                                                                        {currency !== this.state.sodata.currency && (
                                                                                                            <td className="UI-td UI-amount">
                                                                                                                <NumericFormat displayType="text" value={row.cctotalpricewtax || (row.totalpricewtax * this.state.sodata.curconversionrate)} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                                            </td>
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </tr>
                                                                                            <tr className="UI-table-row-detail">
                                                                                                <td colSpan={12} style={{ padding: 0 }}>
                                                                                                    <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                                                                                                        <Box margin={1}>
                                                                                                            <table className="UI-table UI-table-small">
                                                                                                                <thead>
                                                                                                                    <tr>
                                                                                                                        <th className="UI-th">Brand</th>
                                                                                                                        <th className="UI-th">Colour</th>
                                                                                                                        <th className="UI-th">Size</th>
                                                                                                                        <th className="UI-th">Thickness</th>
                                                                                                                        <th className="UI-th">TotalMtrRoll</th>
                                                                                                                        <th className="UI-th">Description</th>
                                                                                                                    </tr>
                                                                                                                </thead>
                                                                                                                <tbody>
                                                                                                                    <tr>
                                                                                                                        <td className="UI-td">{row.brand}</td>
                                                                                                                        <td className="UI-td">{row.colour}</td>
                                                                                                                        <td className="UI-td">{row.size}</td>
                                                                                                                        <td className="UI-td">{row.thickness}</td>
                                                                                                                        <td className="UI-td">{row.totalmtrroll}</td>
                                                                                                                        <td className="UI-td">{row.description}</td>
                                                                                                                    </tr>
                                                                                                                </tbody>
                                                                                                            </table>
                                                                                                        </Box>
                                                                                                    </Collapse>
                                                                                                </td>
                                                                                            </tr>
                                                                                        </React.Fragment>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    )}

                                                                {this.state.serviceList && this.state.serviceList.length > 0 && this.state.addservice === true && (
                                                                    <div className="UI-table-container">
                                                                        <h4 className="UI-section-title">Services</h4>
                                                                        <table className="UI-table">
                                                                            <thead className="UI-table-header">
                                                                                <tr>
                                                                                    <th className="UI-th">Sl. No.</th>
                                                                                    <th className="UI-th">Service</th>
                                                                                    <th className="UI-th">SAC Code</th>
                                                                                    <th className="UI-th">Price</th>
                                                                                    <th className="UI-th">Qty</th>
                                                                                    <th className="UI-th">Discount (INR)</th>
                                                                                    <th className="UI-th">Markup</th>
                                                                                    {this.state.taxtype !== "NA" && (
                                                                                        <>
                                                                                            {this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE" ? (
                                                                                                <>
                                                                                                    <th className="UI-th">CGST</th>
                                                                                                    <th className="UI-th">SGST</th>
                                                                                                </>
                                                                                            ) : (
                                                                                                <th className="UI-th">{this.state.taxtype}</th>
                                                                                            )}
                                                                                        </>
                                                                                    )}
                                                                                    <th className="UI-th">Total Amount</th>
                                                                                    {/* {this.state.serviceList[0]?.contracttype === "Recurring" && ( */}
                                                                                    {/* <th className="UI-th">Recurring Type</th> */}
                                                                                    {/* )} */}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {this.state.serviceList.map((data, index) => (
                                                                                    <tr key={index}>
                                                                                        <td className="UI-td">{index + 1}</td>
                                                                                        <td className="UI-td">{data.service}</td>
                                                                                        <td className="UI-td">{data.servicecode}</td>
                                                                                        <td className="UI-td UI-amount">
                                                                                            <NumericFormat displayType="text" value={data.servicecost} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                        </td>
                                                                                        <td className="UI-td">{data.quantity}</td>
                                                                                        <td className="UI-td UI-amount">
                                                                                            <NumericFormat displayType="text" value={data.servicediscountamount} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                        </td>
                                                                                        <td className="UI-td UI-amount">
                                                                                            <NumericFormat displayType="text" value={data.markup1} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                        </td>
                                                                                        {this.state.taxtype !== "NA" && (
                                                                                            <>
                                                                                                {this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE" ? (
                                                                                                    <>
                                                                                                        <td className="UI-td UI-amount">
                                                                                                            <NumericFormat displayType="text" value={data.servicetaxamount / 2} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({data.servicetax / 2}%)
                                                                                                        </td>
                                                                                                        <td className="UI-td UI-amount">
                                                                                                            <NumericFormat displayType="text" value={data.servicetaxamount / 2} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({data.servicetax / 2}%)
                                                                                                        </td>
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <td className="UI-td UI-amount">
                                                                                                        <NumericFormat displayType="text" value={data.servicetaxamount} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({data.servicetax}%)
                                                                                                    </td>
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                        <td className="UI-td UI-amount">
                                                                                            <NumericFormat displayType="text" value={data.servicetotalwtax} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                        </td>
                                                                                        {/* {this.state.serviceList[0]?.contracttype === "Recurring" && ( */}
                                                                                        {/* <td className="UI-td">{data.recurringtype}</td> */}
                                                                                        {/* )} */}
                                                                                    </tr>
                                                                                ))}
                                                                                <tr>
                                                                                    {(() => {
                                                                                        let colSpan = 7; // Sl No, Service, SAC, Price, Qty, Disc INR, Markup
                                                                                        if (this.state.taxtype !== "NA") {
                                                                                            if (this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE") {
                                                                                                colSpan += 2;
                                                                                            } else {
                                                                                                colSpan += 1;
                                                                                            }
                                                                                        }
                                                                                        return <td colSpan={colSpan} className="UI-td UI-total-label" style={{ textAlign: 'right' }}>Total:</td>;
                                                                                    })()}
                                                                                    <td className="UI-td UI-amount">
                                                                                        <NumericFormat displayType="text" value={this.state.sodata.grandservicetotal} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                    </td>
                                                                                    {/* <td></td> */}
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            (this.state.sotype === 1 || this.state.sotype === 2) && (
                                                                <>
                                                                    <div className="UI-table-container">
                                                                        <h4 className="UI-section-title">Order Services</h4>
                                                                        <table className="UI-table">
                                                                            <thead className="UI-table-header">
                                                                                <tr>
                                                                                    <th className="UI-th">Service</th>
                                                                                    <th className="UI-th">SAC Code</th>
                                                                                    <th className="UI-th">Price</th>
                                                                                    {this.state.sodata.currency !== currency && (
                                                                                        <th className="UI-th">Price({this.state.sodata.currency})</th>
                                                                                    )}
                                                                                    <th className="UI-th">Quantity</th>
                                                                                    <th className="UI-th">Discount (INR)</th>
                                                                                    <th className="UI-th">Markup</th>
                                                                                    {this.state.sodata.taxtype !== "NA" && (
                                                                                        <>
                                                                                            {this.state.sodata.taxtype === "GST" && ccountry === "India" && this.state.sodata.gsttype === "INTRASTATE" ? (
                                                                                                <>
                                                                                                    <th className="UI-th">CGST</th>
                                                                                                    <th className="UI-th">SGST</th>
                                                                                                </>
                                                                                            ) : (
                                                                                                <th className="UI-th">{this.state.sodata.taxtype}</th>
                                                                                            )}
                                                                                        </>
                                                                                    )}
                                                                                    <th className="UI-th">Total Amount</th>
                                                                                    {this.state.sodata.currency !== currency && (
                                                                                        <th className="UI-th">Total Amount({this.state.sodata.currency})</th>
                                                                                    )}
                                                                                    {this.state.serviceList.some(e => e?.contracttype === "Recurring") && (
                                                                                        <th className="UI-th">Recurring Type</th>
                                                                                    )}
                                                                                    <th>Action</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {this.state.serviceList.filter(e => e.invoicestatus === "Pending").map((data, index) => (
                                                                                    <tr key={index}>
                                                                                        <td className="UI-td">{data.service}</td>
                                                                                        <td className="UI-td">{data.servicecode}</td>
                                                                                        <td className="UI-td UI-amount">
                                                                                            <NumericFormat displayType="text" value={data.serviceprice || data.servicecost} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                        </td>
                                                                                        {this.state.sodata.currency !== currency && (
                                                                                            <td className="UI-td UI-amount">
                                                                                                <NumericFormat displayType="text" value={data.ccservicecost || ((data.serviceprice || data.servicecost) * this.state.sodata.curconversionrate)} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                            </td>
                                                                                        )}
                                                                                        <td className="UI-td">{data.quantity}</td>
                                                                                        <td className="UI-td UI-amount">
                                                                                            <NumericFormat displayType="text" value={data.servicediscountamount} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                        </td>
                                                                                        <td className="UI-td UI-amount">
                                                                                            <NumericFormat displayType="text" value={data.markup1} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                        </td>
                                                                                        {this.state.sodata.taxtype !== "NA" && (
                                                                                            <>
                                                                                                {this.state.sodata.taxtype === "GST" && ccountry === "India" && this.state.sodata.gsttype === "INTRASTATE" ? (
                                                                                                    <>
                                                                                                        <td className="UI-td UI-amount">
                                                                                                            <NumericFormat displayType="text" value={data.servicetaxamount / 2} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({data.servicetax / 2}%)
                                                                                                        </td>
                                                                                                        <td className="UI-td UI-amount">
                                                                                                            <NumericFormat displayType="text" value={data.servicetaxamount / 2} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({data.servicetax / 2}%)
                                                                                                        </td>
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <td className="UI-td UI-amount">
                                                                                                        <NumericFormat displayType="text" value={data.servicetaxamount} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} /> ({data.servicetax}%)
                                                                                                    </td>
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                        <td className="UI-td UI-amount">
                                                                                            <NumericFormat displayType="text" value={data.servicetotalwtax} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                        </td>
                                                                                        {this.state.sodata.currency !== currency && (
                                                                                            <td className="UI-td UI-amount">
                                                                                                <NumericFormat displayType="text" value={data.ccservicetotalwtax || (data.servicetotalwtax * this.state.sodata.curconversionrate)} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                            </td>
                                                                                        )}
                                                                                        {this.state.serviceList.some(e => e?.contracttype === "Recurring") && (
                                                                                            <td className="UI-td">{data.recurringtype}</td>
                                                                                        )}
                                                                                        <td>
                                                                                            {data.status ? <button type="button" className="UI-btn UI-btn-outline hover:tw-text-red-500 hover:tw-border-red-500" onClick={(() => {
                                                                                                this.state.serviceList[index].status = false
                                                                                                this.setState({ serviceList: [...this.state.serviceList] }, () => this.recomputeTotals())
                                                                                            })}>Remove from Invoice</button> : <button type="button" className="UI-btn UI-btn-primary" onClick={(() => {
                                                                                                this.state.serviceList[index].status = true
                                                                                                this.setState({ serviceList: [...this.state.serviceList] }, () => this.recomputeTotals())
                                                                                            })}>Add to Invoice</button>}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                                <tr>
                                                                                    {(() => {
                                                                                        let colSpan = 3; // Service, SAC, Price
                                                                                        if (this.state.sodata.currency !== currency) colSpan += 1; // Price(Inv)
                                                                                        colSpan += 3; // Quantity, Discount INR, Markup
                                                                                        if (this.state.sodata.taxtype !== "NA") {
                                                                                            if (this.state.sodata.taxtype === "GST" && ccountry === "India" && this.state.sodata.gsttype === "INTRASTATE") {
                                                                                                colSpan += 2;
                                                                                            } else {
                                                                                                colSpan += 1;
                                                                                            }
                                                                                        }
                                                                                        if (this.state.sodata.currency !== currency) colSpan += 1; // Total Amount (Base)
                                                                                        return <td colSpan={colSpan} className="UI-td UI-total-label" style={{ textAlign: 'right' }}>Total:</td>;
                                                                                    })()}
                                                                                    <td className="UI-td UI-amount" style={{ fontWeight: 'bold' }}>
                                                                                        <NumericFormat displayType="text" value={this.state.sodata.currency !== currency ? this.state.sodata.ccgrandservicetotal : this.state.sodata.grandservicetotal} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                    </td>
                                                                                    {this.state.serviceList.some(e => e?.contracttype === "Recurring") && (
                                                                                        <td className="UI-td"></td>
                                                                                    )}
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                    {this.state.milestones && this.state.milestones.length > 0 && this.state.serviceList[0]?.contracttype !== "Recurring" && this.state.pagename !== "New Proforma Invoice" && (
                                                                        <div className="UI-table-container">
                                                                            <h4 className="UI-section-title">Milestones</h4>
                                                                            <table className="UI-table">
                                                                                <thead className="UI-table-header">
                                                                                    <tr>
                                                                                        <th className="UI-th">Name</th>
                                                                                        <th className="UI-th">Expected Date</th>
                                                                                        <th className="UI-th">Percentage</th>
                                                                                        <th className="UI-th">Amount</th>
                                                                                        {this.state.sodata.currency !== currency && (
                                                                                            <th className="UI-th">Amount({this.state.sodata.currency})</th>
                                                                                        )}
                                                                                        <th className="UI-th">Status</th>
                                                                                        <th className="UI-th">Actions</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {this.state.milestones.map((data, index) => (
                                                                                        <tr key={index}>
                                                                                            <td className="UI-td">{data.name}</td>
                                                                                            <td className="UI-td">{data.expecteddate ? moment(data.expecteddate).format("DD-MM-YYYY") : "NA"}</td>
                                                                                            <td className="UI-td">{data.percentage}</td>
                                                                                            <td className="UI-td UI-amount">
                                                                                                <NumericFormat displayType="text" value={data.totalpricewtax} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                            </td>
                                                                                            {this.state.sodata.currency !== currency && (
                                                                                                <td className="UI-td UI-amount">
                                                                                                    <NumericFormat displayType="text" value={data.cctotalpricewtax} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                                </td>
                                                                                            )}
                                                                                            <td className="UI-td">{data.servicestatus}</td>
                                                                                            <td className="UI-td">
                                                                                                {this.state.completed === "" && (
                                                                                                    <span className="UI-link" onClick={() => this.handlemilestonestatus(index)}>
                                                                                                        Pending <i className="fa fa-check text-green" />
                                                                                                    </span>
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    )}

                                                                    {this.state.completed && (
                                                                        <div className="UI-table-container">
                                                                            <h4 className="UI-section-title">Completed Milestones</h4>
                                                                            <table className="UI-table">
                                                                                <thead className="UI-table-header">
                                                                                    <tr>
                                                                                        <th className="UI-th">Name</th>
                                                                                        <th className="UI-th">Expected Date</th>
                                                                                        <th className="UI-th">Percentage</th>
                                                                                        <th className="UI-th">Amount</th>
                                                                                        {this.state.sodata.currency !== currency && (
                                                                                            <th className="UI-th">Amount({this.state.sodata.currency})</th>
                                                                                        )}
                                                                                        {this.state.pagename !== "New Proforma Invoice" && (
                                                                                            <th className="UI-th">Status</th>
                                                                                        )}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td className="UI-td">{this.state.completed.name}</td>
                                                                                        <td className="UI-td">{moment(this.state.completed.expecteddate).format("DD-MM-YYYY")}</td>
                                                                                        <td className="UI-td">{this.state.completed.percentage}</td>
                                                                                        <td className="UI-td UI-amount">
                                                                                            <NumericFormat displayType="text" value={this.state.completed.totalpricewtax} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                        </td>
                                                                                        {this.state.sodata.currency !== currency && (
                                                                                            <td className="UI-td UI-amount">
                                                                                                <NumericFormat displayType="text" value={this.state.completed.cctotalpricewtax} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                                                            </td>
                                                                                        )}
                                                                                        {this.state.pagename !== "New Proforma Invoice" && (
                                                                                            <td className="UI-td">{this.state.completed.servicestatus}</td>
                                                                                        )}
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )
                                                        )}

                                                        {this.state.show === 1 && (
                                                            <div className="UI-form-section">
                                                                <h4 className="UI-section-title">Add Item/Product to invoice</h4>
                                                                <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
                                                                    <div className="UI-form-group">
                                                                        <label className="UI-label">Item Name</label>
                                                                        <div className="UI-static-value">{this.state.itemname}</div>
                                                                    </div>
                                                                    <div className="UI-form-group">
                                                                        <label className="UI-label">Remaining Quantity</label>
                                                                        <div className="UI-static-value">{this.state.pendingquantity - this.state.quantity}</div>
                                                                    </div>
                                                                    <div className="UI-form-group">
                                                                        <label className="UI-label">Inventory Stock</label>
                                                                        <div className="UI-static-value">{this.state.itemstock}</div>
                                                                    </div>
                                                                </div>

                                                                {this.state.einvoice && this.state.accepteditems.length !== 0 && (
                                                                    <div className="UI-form-group">
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={this.state.iscomposite}
                                                                                    onChange={() => this.setState({ iscomposite: !this.state.iscomposite })}
                                                                                    color="primary"
                                                                                />
                                                                            }
                                                                            label="Is Composite Item"
                                                                        />
                                                                        {this.state.iscomposite && (
                                                                            <div className="UI-helper-text" style={{ color: '#dc2626' }}>
                                                                                Note: Reverse GST will be applicable on this invoice
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}

                                                                <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
                                                                    {this.state.pagename === "New Proforma Invoice" ? (
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Quantity</label>
                                                                            <input
                                                                                type="number"
                                                                                className="UI-input"
                                                                                value={this.state.quantity}
                                                                                onChange={(e) => this.setState({ quantity: e.target.value })}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            <div className="UI-form-group">
                                                                                <label className="UI-label">Quantity</label>
                                                                                <input
                                                                                    type="number"
                                                                                    className="UI-input"
                                                                                    value={this.state.quantity}
                                                                                    onChange={(e) => this.setState({ quantity: e.target.value })}
                                                                                // onClick={this.handleSelect}
                                                                                />
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </div>

                                                                <div className="UI-btn-actions">
                                                                    <button type="submit" className="UI-btn UI-btn-primary">
                                                                        Add Item
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    this.state.invtype === "Direct Invoice" && (
                                                        <>
                                                            {/* SECTION: Product / Service Tabs */}
                                                            {(this.state.settings.salesservice === "NO" && this.state.settings.salespands === "NO") ||
                                                                this.state.accepteditems.length > 0 ||
                                                                this.state.serviceList.length > 0 ? (
                                                                ""
                                                            ) : (
                                                                <div className="UI-form-section">
                                                                    {/* <h3 className="UI-section-title" style={{ backgroundColor: '#f4f4f4', padding: '12px' }}>
                                                                        Add invoice information
                                                                    </h3> */}
                                                                    <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                                                                        {this.state.settings.salesservice !== "NO" && (
                                                                            <RectangularTabButton label="Only Products" checked={this.state.sotype === 0} onClick={() => this.setState({ sotype: 0 })} icon={BoxIcon} />
                                                                        )}
                                                                        {this.state.settings.salesservice === "YES" && (
                                                                            <RectangularTabButton label="Only Services" checked={this.state.sotype === 1} onClick={() => this.setState({ sotype: 1 })} icon={WrenchIcon} />
                                                                        )}
                                                                        {this.state.settings.salespands === "YES" && (
                                                                            <RectangularTabButton label="Products & Services" checked={this.state.sotype === 2} onClick={() => this.setState({ sotype: 2 })} icon={BoxesIcon} />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* SECTION: Product Details */}
                                                            {(this.state.sotype === 0 || this.state.sotype === 2) && (
                                                                <div ref={this.productSectionRef} className="UI-form-section tw-border tw-border-dotted tw-mb-3 tw-pb-2 mx-0 px-2">
                                                                    <h3 className="UI-section-title" style={{ backgroundColor: '#f4f4f4', padding: '12px' }}>
                                                                        Product Details
                                                                    </h3>
                                                                    <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4)' }}>

                                                                        <div className="UI-form-group">
                                                                            <AutoCompeteField id="department" name="department" type="text" options={DepartmentList} valueKey={"name"} labelKey={"name"} value={this.state.department} label={`Department`} placeholder="Select Department" onChange={this.handleDepartment} disabled={DepartmentList.length === 1 || this.state.accepteditems.length > 0 || this.state.serviceList.length > 0} error={errors?.["department"]} />
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Category</label>
                                                                            <Autocomplete
                                                                                options={CategoryList}
                                                                                getOptionLabel={(option) => option.category}
                                                                                onChange={this.handleCategory}
                                                                                renderOption={(props, option) => {
                                                                                    const count = productCategoryCount[option.id] || 0;
                                                                                    return (
                                                                                        <li {...props} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                                            <span>{option.category}</span>
                                                                                            <span
                                                                                                style={{
                                                                                                    color: count === 0 ? "#dc2626" : "#5f8f3f", // red for zero, gray otherwise
                                                                                                    fontSize: "0.8rem",
                                                                                                    whiteSpace: "nowrap",
                                                                                                    marginLeft: "8px",
                                                                                                }}
                                                                                            >
                                                                                                {count}
                                                                                            </span>
                                                                                        </li>
                                                                                    );
                                                                                }}
                                                                                renderInput={(params) => (
                                                                                    <div ref={params.InputProps.ref}>
                                                                                        <input
                                                                                            type="text"
                                                                                            {...params.inputProps}
                                                                                            className="UI-input"
                                                                                            placeholder="Select category"
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                            />
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <AutoCompeteField id="itemname" name="itemname" type="text" options={filteritemlist} valueKey={"name"} labelKey={"name"} value={this.state.itemname} label={`Item/Product`} placeholder="Select Item/Product" onChange={this.handleitem} required error={errors?.["itemname"]} />
                                                                        </div>

                                                                        {this.state.itemname && this.state.itemname !== "" && (
                                                                            <>
                                                                                <div className="UI-form-group">
                                                                                    <div style={{ position: 'relative' }}>
                                                                                        <TextfieldComponent
                                                                                            id="price"
                                                                                            name="price"
                                                                                            type="number"
                                                                                            label={`Price`}
                                                                                            className="UI-input"
                                                                                            value={this.state.price}
                                                                                            onChange={(e) => this.setState({ price: e.target.value < 0 ? 0 : e.target.value, totalpricewtax: "" })}
                                                                                            prefix={this.state.currency}
                                                                                            required
                                                                                            error={errors?.price}
                                                                                        />
                                                                                    </div>
                                                                                </div>

                                                                                {this.state.settings.allowextramakup === "YES" && (
                                                                                    <div className="UI-form-group">
                                                                                        <div style={{ position: 'relative' }}>
                                                                                            <TextfieldComponent
                                                                                                type="number"
                                                                                                label={`Markup per ${this.state.uom ? this.state.uom : "UNIT"}`}
                                                                                                className="UI-input"
                                                                                                value={isInvalid.includes(this.state.markup1) ? 0 : this.state.markup1}
                                                                                                onChange={(e) => this.setState({ markup1: e.target.value })}
                                                                                                prefix={this.state.currency}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                )}

                                                                                {this.state.salescalreq === "YES" && this.state.settings.soeditprice === "YES" && (
                                                                                    <div className="UI-form-group">
                                                                                        <SelectField label={"Type"} lableKey={"label"} lableValue={"value"} list={[{ value: "Average", label: `Average (${this.state.basecurrency} ${this.state.avgprice}) ${this.state.currency !== this.state.basecurrency ? `(${this.state.currency} ${(this.state.avgprice / this.state.curconversionrate).toFixed(3)})` : ""}` }, { value: "FIFO", label: `FIFO (${this.state.basecurrency} ${this.state.fifoprice}) ${this.state.currency !== this.state.basecurrency ? `(${this.state.currency} ${(this.state.fifoprice / this.state.curconversionrate).toFixed(3)})` : ""}` }, { value: "LIFO", label: `LIFO (${this.state.basecurrency} ${this.state.lifoprice}) ${this.state.currency !== this.state.basecurrency ? `(${this.state.currency} ${(this.state.lifoprice / this.state.curconversionrate).toFixed(3)})` : ""}` }]} value={this.state.type} onChange={this.handleTypeChange} />
                                                                                    </div>
                                                                                )}

                                                                                <div className="UI-form-group">
                                                                                    <TextfieldComponent label={`Quantity (Available: ${this.state.stock || 0})`} value={this.state.quantity} onChange={(e) => this.setState({ quantity: e.target.value, totalpricewtax: "" })} prefix={this.state.uom} required error={errors?.quantity} />
                                                                                </div>

                                                                                <div className="UI-form-group">
                                                                                    <TextfieldComponent
                                                                                        type="number"
                                                                                        label={"Sub Total"}
                                                                                        value={(isInvalid.includes(this.state.price) || isInvalid.includes(this.state.quantity) ? 0 : ((parseFloat(this.state.price) + (isInvalid.includes(this.state.markup1) ? 0 : parseFloat(this.state.markup1))) * parseFloat(this.state.quantity))).toFixed(2)}
                                                                                        disabled
                                                                                        prefix={this.state.currency}
                                                                                    />
                                                                                </div>

                                                                                <div className="UI-form-group">
                                                                                    {/* <label className="UI-label">Discount (%)</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="UI-input"
                                                                                        value={this.state.discount}
                                                                                        onChange={(e) => this.setState({ discount: e.target.value })}
                                                                                        onFocus={this.ondiscountfocus}
                                                                                        min="0"
                                                                                    /> */}
                                                                                    <TextFeildWithSelect label={`Discount per ${this.state.uom ? this.state.uom : "UNIT"}`} value={this.state.discounttype === "%" ? this.state.discount : this.state.discountamount} onChange={this.handleDiscountChange} list={["%", this.state.currency]} selectvalue={this.state.discounttype} onSelectChange={this.handleSelectDiscountType} />
                                                                                </div>

                                                                                <div className="UI-form-group">
                                                                                    <TextfieldComponent
                                                                                        type="number"
                                                                                        label={"Total Price"}
                                                                                        value={(
                                                                                            isInvalid.includes(this.state.price) ||
                                                                                                isInvalid.includes(this.state.quantity)
                                                                                                ? 0
                                                                                                : ((parseFloat(this.state.price) + (isInvalid.includes(this.state.markup1) ? 0 : parseFloat(this.state.markup1))) * parseFloat(this.state.quantity)) -
                                                                                                ((isInvalid.includes(this.state.discount)
                                                                                                    ? (isInvalid.includes(this.state.discountamount) ? 0 : this.state.discountamount)
                                                                                                    : (((parseFloat(this.state.price) + (isInvalid.includes(this.state.markup1) ? 0 : parseFloat(this.state.markup1))) * parseFloat(this.state.quantity)) * (parseFloat(this.state.discount) / 100))))
                                                                                        ).toFixed(2)}
                                                                                        disabled
                                                                                        prefix={this.state.currency}
                                                                                    />
                                                                                </div>

                                                                                {this.state.currency !== this.state.basecurrency && (
                                                                                    <div className="UI-form-group">
                                                                                        <TextfieldComponent
                                                                                            label={"Price Variance"}
                                                                                            type="number"
                                                                                            className="UI-input"
                                                                                            value={this.state.pricevariance}
                                                                                            onChange={(e) => this.setState({
                                                                                                pricevariance: e.target.value, totalpricewtax: "", availabelcredit:
                                                                                                    this.state.creditvalue
                                                                                            })}
                                                                                            onFocus={this.onpricevariancefocus}
                                                                                            prefix={"%"}
                                                                                        />
                                                                                    </div>
                                                                                )}

                                                                                {this.state.taxrequired === true && (
                                                                                    <>
                                                                                        <div className="UI-form-group">
                                                                                            <TextfieldComponent
                                                                                                label={this.state.taxtype === "VAT" ? "Item Code" : "HSN Code"}
                                                                                                type="text"
                                                                                                className="UI-input UI-input-disabled"
                                                                                                value={this.state.hsn}
                                                                                                disabled
                                                                                            />
                                                                                        </div>

                                                                                        <fieldset className="UI-form-group">
                                                                                            <SelectField id="tax" label={`Select Tax(%)`} list={[{ tax: "", description: "" }, ...this.state.taxesList.map((e => { return { ...e, description: e.tax } }))]} lableKey={"description"} lableValue={"tax"} name="tax" value={this.state.tax} onChange={(e) => this.setState({ tax: e.target.value, cgst: e.target.value / 2, sgst: e.target.value / 2, igst: e.target.value, vat: e.target.value })} />
                                                                                        </fieldset>

                                                                                        {this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE" ? (
                                                                                            <>
                                                                                                <div className="UI-form-group tw-flex tw-gap-1">
                                                                                                    <TextfieldComponent
                                                                                                        label={"CGST"}
                                                                                                        type="number"
                                                                                                        className="UI-input UI-input-disabled"
                                                                                                        value={this.state.cgst}
                                                                                                        disabled
                                                                                                        prefix={"%"}
                                                                                                    />
                                                                                                    <TextfieldComponent
                                                                                                        label={"SGST"}
                                                                                                        type="number"
                                                                                                        className="UI-input UI-input-disabled"
                                                                                                        value={this.state.sgst}
                                                                                                        disabled
                                                                                                        prefix={"%"}
                                                                                                    />
                                                                                                </div>
                                                                                            </>
                                                                                        ) : (
                                                                                            <div className="UI-form-group">
                                                                                                <TextfieldComponent
                                                                                                    label={this.state.taxtype === "GST" && ccountry === "India" ? "IGST" : this.state.taxtype}
                                                                                                    type="number"
                                                                                                    className="UI-input UI-input-disabled"
                                                                                                    value={this.state.tax}
                                                                                                    disabled
                                                                                                    prefix={"%"}
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                )}

                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">UOM</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="UI-input UI-input-disabled"
                                                                                        value={this.state.uom}
                                                                                        disabled
                                                                                    />
                                                                                </div>

                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Brand</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="UI-input UI-input-disabled"
                                                                                        value={this.state.brand}
                                                                                        disabled
                                                                                    />
                                                                                </div>

                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Model</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="UI-input UI-input-disabled"
                                                                                        value={this.state.model}
                                                                                        disabled
                                                                                    />
                                                                                </div>

                                                                                {this.state.additionalparams === 1 && (
                                                                                    <>
                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">Size</label>
                                                                                            <Autocomplete
                                                                                                options={sizelist}
                                                                                                getOptionLabel={(option) => option}
                                                                                                onChange={this.handleSize}
                                                                                                renderInput={(params) => (
                                                                                                    <div ref={params.InputProps.ref}>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            {...params.inputProps}
                                                                                                            className="UI-input"
                                                                                                            placeholder="Select size"
                                                                                                        />
                                                                                                    </div>
                                                                                                )}
                                                                                            />
                                                                                        </div>

                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">Colour</label>
                                                                                            <Autocomplete
                                                                                                options={colourlist}
                                                                                                getOptionLabel={(option) => option}
                                                                                                onChange={this.handleColour}
                                                                                                renderInput={(params) => (
                                                                                                    <div ref={params.InputProps.ref}>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            {...params.inputProps}
                                                                                                            className="UI-input"
                                                                                                            placeholder="Select colour"
                                                                                                        />
                                                                                                    </div>
                                                                                                )}
                                                                                            />
                                                                                        </div>

                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">Thickness</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                className="UI-input"
                                                                                                value={this.state.thickness}
                                                                                                onChange={(e) => this.setState({ thickness: e.target.value })}
                                                                                            />
                                                                                        </div>

                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">TotalMtrRoll</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                className="UI-input"
                                                                                                value={this.state.totalmtrroll}
                                                                                                onChange={(e) => this.setState({ totalmtrroll: e.target.value })}
                                                                                            />
                                                                                        </div>
                                                                                    </>
                                                                                )}

                                                                                <div className="UI-form-group" style={{ gridColumn: '1 / -1' }}>
                                                                                    <label className="UI-label">Description/Specifications</label>
                                                                                    <textarea
                                                                                        className="UI-textarea"
                                                                                        value={this.state.description}
                                                                                        onChange={(e) => this.setState({ description: e.target.value })}
                                                                                        maxLength="100"
                                                                                        rows="2"
                                                                                    />
                                                                                    <div className="UI-helper-text text-right">
                                                                                        {(this.state.description?.length || 0)}/100
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>

                                                                    {this.state.einvoice && this.state.taxtype === "GST" && (
                                                                        <div className="UI-form-group">
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={this.state.iscomposite}
                                                                                        onChange={() => this.setState({ iscomposite: !this.state.iscomposite })}
                                                                                        color="primary"
                                                                                    />
                                                                                }
                                                                                label="Is Composite Item"
                                                                            />
                                                                            {this.state.iscomposite && (
                                                                                <div className="UI-helper-text" style={{ color: '#dc2626' }}>
                                                                                    Note: Reverse GST will be applicable on this invoice
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    <div className="UI-btn-actions">
                                                                        <button type="button" className="UI-btn UI-btn-primary" onClick={this.onSubmit}>
                                                                            {this.state.itemeditIndex !== null ? 'Update Product' : 'Add Product'}
                                                                        </button>
                                                                        <button type="button" className="UI-btn UI-btn-outline" onClick={this.clearCurrentProduct}>
                                                                            Clear
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* SECTION: Service Details */}
                                                            {this.state.sotype !== 0 && (
                                                                <div ref={this.serviceSectionRef} className="UI-form-section tw-border tw-border-dotted tw-mb-3 tw-pb-2 mx-0 p-2">
                                                                    <h3 className="UI-section-title" style={{ backgroundColor: '#f4f4f4', padding: '12px' }}>
                                                                        Service Details
                                                                    </h3>
                                                                    <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                                                                        {!this.state.editservie && (
                                                                            <div className="UI-form-group">
                                                                                <label className="UI-label">Service Category</label>
                                                                                <Autocomplete
                                                                                    options={ServiceCategoryList}
                                                                                    getOptionLabel={(option) => option.category}
                                                                                    value={ServiceCategoryList?.find(e => e.category === this.state.servicecategory) || null}
                                                                                    onChange={this.handleServicecategory}
                                                                                    renderOption={(props, option) => {
                                                                                        const count = serviceCategoryCount[option.id] || 0;
                                                                                        return (
                                                                                            <li {...props} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                                                <span>{option.category}</span>
                                                                                                <span
                                                                                                    style={{
                                                                                                        color: count === 0 ? "#dc2626" : "#5f8f3f ",
                                                                                                        fontSize: "0.8rem",
                                                                                                        whiteSpace: "nowrap",
                                                                                                        marginLeft: "8px",
                                                                                                    }}
                                                                                                >
                                                                                                    {count}
                                                                                                </span>
                                                                                            </li>
                                                                                        );
                                                                                    }}
                                                                                    renderInput={(params) => (
                                                                                        <div ref={params.InputProps.ref}>
                                                                                            <input
                                                                                                type="text"
                                                                                                {...params.inputProps}
                                                                                                className="UI-input"
                                                                                                placeholder="Select service category"
                                                                                            />
                                                                                        </div>
                                                                                    )}
                                                                                />
                                                                            </div>
                                                                        )}

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Service</label>
                                                                            <Autocomplete
                                                                                options={filterserv}
                                                                                getOptionLabel={(option) => option.service}
                                                                                value={filterserv?.find(e => e.service === this.state.service) || null}
                                                                                onChange={this.handleService}
                                                                                renderInput={(params) => (
                                                                                    <div ref={params.InputProps.ref}>
                                                                                        <input
                                                                                            type="text"
                                                                                            {...params.inputProps}
                                                                                            className="UI-input"
                                                                                            placeholder="Select service"
                                                                                        />
                                                                                    </div>
                                                                                )}
                                                                            />
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <TextfieldComponent
                                                                                type="text"
                                                                                label="Service Code"
                                                                                value={this.state.servicecode}
                                                                                disabled
                                                                            />
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <div style={{ position: 'relative' }}>
                                                                                <TextfieldComponent
                                                                                    type="number"
                                                                                    label="Amount"
                                                                                    value={this.state.servicecost}
                                                                                    onChange={(e) => this.setState({ servicecost: e.target.value })}
                                                                                    prefix={this.state.currency}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="UI-form-group">
                                                                            <TextfieldComponent
                                                                                type="number"
                                                                                label="Quantity"
                                                                                value={this.state.quantity}
                                                                                onChange={(e) => {
                                                                                    this.handleServiceAmountChange(this.state.servicecost, e.target.value);
                                                                                    this.setState({ quantity: e.target.value });
                                                                                }}
                                                                                prefix={this.state.uom}
                                                                            />
                                                                        </div>
                                                                        <div className="UI-form-group">
                                                                            <div>
                                                                                <TextfieldComponent
                                                                                    type="number"
                                                                                    label={"Markup per Unit"}
                                                                                    value={this.state.servicemarkup}
                                                                                    onChange={(e) => this.setState({ servicemarkup: e.target.value })}
                                                                                    prefix={this.state.currency}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <TextFeildWithSelect label={`Discount per ${this.state.uom ? this.state.uom : "UNIT"}`} value={this.state.discounttype === "%" ? this.state.servicediscount : this.state.servicediscountamount} onChange={this.handleServiceDiscountChange} list={["%", this.state.currency]} selectvalue={this.state.discounttype} onSelectChange={this.handleSelectDiscountType} />
                                                                        </div>

                                                                        <div className="UI-form-group" style={{ gridColumn: '4 / 5' }}>
                                                                            <TextfieldComponent
                                                                                type="number"
                                                                                label="Total Amount"
                                                                                value={(
                                                                                    ((parseFloat(isInvalid.includes(this.state.servicecost) ? 0 : this.state.servicecost) +
                                                                                        parseFloat(isInvalid.includes(this.state.servicemarkup) ? 0 : this.state.servicemarkup)) -
                                                                                        (this.state.discounttype === "%" ?
                                                                                            ((parseFloat(isInvalid.includes(this.state.servicecost) ? 0 : this.state.servicecost) +
                                                                                                parseFloat(isInvalid.includes(this.state.servicemarkup) ? 0 : this.state.servicemarkup)) *
                                                                                                (parseFloat(isInvalid.includes(this.state.servicediscount) ? 0 : this.state.servicediscount) / 100))
                                                                                            : parseFloat(isInvalid.includes(this.state.servicediscountamount) ? 0 : this.state.servicediscountamount))) * parseFloat(isInvalid.includes(this.state.quantity) ? 0 : this.state.quantity)
                                                                                )}
                                                                                disabled
                                                                            />
                                                                        </div>

                                                                        {this.state.taxrequired === true && (
                                                                            <>
                                                                                <fieldset className="UI-form-group">
                                                                                    <SelectField id="tax" label={`Select Tax(%)`} list={[{ tax: "", description: "" }, ...this.state.taxesList.map((e => { return { ...e, description: e.tax } }))]} lableKey={"description"} lableValue={"tax"} name="tax" value={this.state.servicetax} onChange={(e) => this.setState({ servicetax: e.target.value })} />
                                                                                </fieldset>
                                                                                {this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE" ? (
                                                                                    <div className="UI-form-group">
                                                                                        <div className="UI-form-group tw-flex tw-gap-1" style={{ gridColumn: '1 / 2' }}>
                                                                                            <TextfieldComponent
                                                                                                type="number"
                                                                                                label={"CGST (%)"}
                                                                                                value={isInvalid.includes(this.state.servicetax) ? 0 : (this.state.servicetax / 2)}
                                                                                                disabled
                                                                                            />
                                                                                            <TextfieldComponent
                                                                                                type="number"
                                                                                                label={"SGST (%)"}
                                                                                                value={isInvalid.includes(this.state.servicetax) ? 0 : (this.state.servicetax / 2)}
                                                                                                disabled
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                ) : (
                                                                                    <div className="UI-form-group">
                                                                                        <TextfieldComponent
                                                                                            type="number"
                                                                                            label={`${this.state.taxtype === "GST" && ccountry === "India" ? "IGST" : this.state.taxtype} (%)`}
                                                                                            value={isInvalid.includes(this.state.servicetax) ? 0 : this.state.servicetax}
                                                                                            disabled
                                                                                        />
                                                                                    </div>
                                                                                )}

                                                                                <div className="UI-form-group" style={{ gridColumn: '4 / 5' }}>
                                                                                    <TextfieldComponent
                                                                                        type="number"
                                                                                        className="UI-input"
                                                                                        label="Total Amount Inc Tax"
                                                                                        value={(
                                                                                            ((parseFloat(isInvalid.includes(this.state.servicecost) ? 0 : this.state.servicecost) +
                                                                                                parseFloat(isInvalid.includes(this.state.servicemarkup) ? 0 : this.state.servicemarkup) -
                                                                                                (this.state.discounttype === "%" ? ((parseFloat(isInvalid.includes(this.state.servicecost) ? 0 : this.state.servicecost) +
                                                                                                    parseFloat(isInvalid.includes(this.state.servicemarkup) ? 0 : this.state.servicemarkup)) *
                                                                                                    (parseFloat(isInvalid.includes(this.state.servicediscount) ? 0 : this.state.servicediscount) / 100)) :
                                                                                                    parseFloat(this.state.servicediscountamount))
                                                                                            ) * parseFloat(isInvalid.includes(this.state.quantity) ? 0 : this.state.quantity)) +
                                                                                            ((((parseFloat(isInvalid.includes(this.state.servicecost) ? 0 : this.state.servicecost) +
                                                                                                parseFloat(isInvalid.includes(this.state.servicemarkup) ? 0 : this.state.servicemarkup) -
                                                                                                (this.state.discounttype === "%" ? ((parseFloat(isInvalid.includes(this.state.servicecost) ? 0 : this.state.servicecost) +
                                                                                                    parseFloat(isInvalid.includes(this.state.servicemarkup) ? 0 : this.state.servicemarkup)) *
                                                                                                    (parseFloat(isInvalid.includes(this.state.servicediscount) ? 0 : this.state.servicediscount) / 100)) :
                                                                                                    parseFloat(this.state.servicediscountamount))
                                                                                            ) * parseFloat(isInvalid.includes(this.state.quantity) ? 0 : this.state.quantity)) * (this.state.servicetax / 100)))
                                                                                        )}
                                                                                        prefix={this.state.currency}
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        )}

                                                                        <div className="UI-form-group" style={{ gridColumn: '1 / -1' }}>
                                                                            <label className="UI-label">Description</label>
                                                                            <textarea
                                                                                className="UI-textarea"
                                                                                value={this.state.servicedescription}
                                                                                onChange={(e) => this.setState({ servicedescription: e.target.value })}
                                                                                maxLength="100"
                                                                                rows="2"
                                                                            />
                                                                            <div className="UI-helper-text text-right">
                                                                                {(this.state.servicedescription?.length || 0)}/100
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="UI-btn-actions">
                                                                        <button type="button" className="UI-btn UI-btn-primary" onClick={this.handleaddService}>
                                                                            {this.state.serviceeditIndex !== null ? 'Update Service' : 'Add Service'}
                                                                        </button>
                                                                        <button type="button" className="UI-btn UI-btn-outline" onClick={this.clearCurrentService}>
                                                                            Clear
                                                                        </button>
                                                                    </div>

                                                                    {this.state.serviceList.length > 0 && (
                                                                        <div className="UI-table-container">
                                                                            <div className="UI-table-header-toolbar">
                                                                                <h4 className="UI-section-title">Invoice Services</h4>
                                                                                {/* <FormControl variant="standard" className="UI-select-small">
            <InputLabel>Show Services By</InputLabel>
            <Select
              value={this.state.showPricesIn}
              onChange={(e) => this.setState({ showPricesIn: e.target.value })}
            >
              <MenuItem value={0}>Default</MenuItem>
              <MenuItem value={1}>Base Currency</MenuItem>
              <MenuItem value={2}>Invoice Currency</MenuItem>
            </Select>
          </FormControl> */}
                                                                            </div>
                                                                            <table className="UI-table">
                                                                                <thead className="UI-table-header">
                                                                                    <tr>
                                                                                        <th className="UI-th">Sl No.</th>
                                                                                        <th className="UI-th">Services</th>
                                                                                        <th className="UI-th">SCN</th>
                                                                                        <th className="UI-th">Price ({this.state.currency})</th>
                                                                                        <th className="UI-th">Qty</th>
                                                                                        <th className="UI-th">Discount ({this.state.currency})</th>
                                                                                        <th className="UI-th">Total Amount ({this.state.currency})</th>
                                                                                        {this.state.taxrequired === true && (
                                                                                            <>
                                                                                                {this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE" ? (
                                                                                                    <>
                                                                                                        <th className="UI-th">CGST</th>
                                                                                                        <th className="UI-th">SGST</th>
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <th className="UI-th">{this.state.taxtype}</th>
                                                                                                )}
                                                                                            </>
                                                                                        )}
                                                                                        <th className="UI-th">Net Amount ({this.state.currency})</th>
                                                                                        {this.state.currency !== this.state.basecurrency && (
                                                                                            <th className="UI-th">Net Amount ({this.state.basecurrency})</th>
                                                                                        )}
                                                                                        <th className="UI-th">Action</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {this.state.serviceList.map((data, index) => (
                                                                                        <tr key={index}>
                                                                                            <td className="UI-td">
                                                                                                <span>{String(index + 1).padStart(2, '0')}</span>
                                                                                            </td>
                                                                                            <td className="UI-td">{data.service}</td>
                                                                                            <td className="UI-td">{data.servicecode}</td>
                                                                                            <td className="UI-td UI-amount">
                                                                                                <NumericFormat
                                                                                                    displayType="text"
                                                                                                    value={data.ccservicecost + (data.ccmarkup1 || 0)}
                                                                                                    decimalScale={2}
                                                                                                    fixedDecimalScale
                                                                                                    thousandSeparator
                                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                                />
                                                                                            </td>
                                                                                            <td className="UI-td">{data.quantity}</td>
                                                                                            <td className="UI-td UI-amount">
                                                                                                <NumericFormat
                                                                                                    displayType="text"
                                                                                                    value={data.ccservicediscountamount}
                                                                                                    decimalScale={2}
                                                                                                    fixedDecimalScale
                                                                                                    thousandSeparator
                                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                                /> ({data.servicediscount}%)
                                                                                            </td>
                                                                                            <td className="UI-td UI-amount">
                                                                                                <NumericFormat
                                                                                                    displayType="text"
                                                                                                    value={data.ccservicetotal}
                                                                                                    decimalScale={2}
                                                                                                    fixedDecimalScale
                                                                                                    thousandSeparator
                                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                                />
                                                                                            </td>
                                                                                            {this.state.taxrequired === true && (
                                                                                                <>
                                                                                                    {this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE" ? (
                                                                                                        <>
                                                                                                            <td className="UI-td UI-amount">
                                                                                                                <NumericFormat
                                                                                                                    displayType="text"
                                                                                                                    value={data.cchalfservicetaxamount}
                                                                                                                    decimalScale={2}
                                                                                                                    fixedDecimalScale
                                                                                                                    thousandSeparator
                                                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                                                /> ({data.servicetax / 2}%)
                                                                                                            </td>
                                                                                                            <td className="UI-td UI-amount">
                                                                                                                <NumericFormat
                                                                                                                    displayType="text"
                                                                                                                    value={data.cchalfservicetaxamount}
                                                                                                                    decimalScale={2}
                                                                                                                    fixedDecimalScale
                                                                                                                    thousandSeparator
                                                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                                                /> ({data.servicetax / 2}%)
                                                                                                            </td>
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        <td className="UI-td UI-amount">
                                                                                                            <NumericFormat
                                                                                                                displayType="text"
                                                                                                                value={data.ccservicetaxamount}
                                                                                                                decimalScale={2}
                                                                                                                fixedDecimalScale
                                                                                                                thousandSeparator
                                                                                                                thousandsGroupStyle={thousandsdisplay}
                                                                                                            /> ({data.servicetax}%)
                                                                                                        </td>
                                                                                                    )}
                                                                                                </>
                                                                                            )}
                                                                                            <td className="UI-td UI-amount">
                                                                                                <NumericFormat
                                                                                                    displayType="text"
                                                                                                    value={data.ccservicetotalwtax}
                                                                                                    decimalScale={2}
                                                                                                    fixedDecimalScale
                                                                                                    thousandSeparator
                                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                                />
                                                                                            </td>
                                                                                            {this.state.currency !== this.state.basecurrency && (
                                                                                                <td className="UI-td UI-amount">
                                                                                                    <NumericFormat
                                                                                                        displayType="text"
                                                                                                        value={data.servicetotalwtax}
                                                                                                        decimalScale={2}
                                                                                                        fixedDecimalScale
                                                                                                        thousandSeparator
                                                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                                                    />
                                                                                                </td>
                                                                                            )}
                                                                                            <td className="UI-td">
                                                                                                {((this.state.invtype === "Direct Invoice" && this.state.pagename === "Edit Invoice") || (this.state.pagename !== "Edit Invoice")) && (
                                                                                                    <div className="UI-action-buttons" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            onClick={() => this.editServiceFromList(data, index)}
                                                                                                            style={{ border: "none", background: "transparent", padding: 0, cursor: "pointer" }}
                                                                                                            aria-label="Edit service"
                                                                                                            onMouseEnter={() => this.setState({ isActionHovered: `editService-${index}` })}
                                                                                                            onMouseLeave={() => this.setState({ isActionHovered: null })}
                                                                                                        >
                                                                                                            <Tooltip
                                                                                                                title="Edit"
                                                                                                                arrow
                                                                                                                slotProps={{ popper: { sx: { pointerEvents: 'none' } } }}
                                                                                                            >
                                                                                                                <img
                                                                                                                    src={EditIcon}
                                                                                                                    alt="Edit"
                                                                                                                    className={`UI-edit-icon ${this.state.isActionHovered === `editService-${index}` ? 'UI-edit-icon-hover' : ''}`}
                                                                                                                />
                                                                                                            </Tooltip>
                                                                                                        </button>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            onClick={() => this.removeServiceFromList(index)}
                                                                                                            style={{ border: "none", background: "transparent", padding: 0, cursor: "pointer" }}
                                                                                                            aria-label="Delete service"
                                                                                                            onMouseEnter={() => this.setState({ isActionHovered: `deleteService-${index}` })}
                                                                                                            onMouseLeave={() => this.setState({ isActionHovered: null })}
                                                                                                        >
                                                                                                            <Tooltip
                                                                                                                title="Delete"
                                                                                                                arrow
                                                                                                                slotProps={{ popper: { sx: { pointerEvents: 'none' } } }}
                                                                                                            >
                                                                                                                <img
                                                                                                                    src={DeleteIcon}
                                                                                                                    alt="Delete"
                                                                                                                    className={`UI-delete-icon ${this.state.isActionHovered === `deleteService-${index}` ? 'UI-delete-icon-hover' : ''}`}
                                                                                                                />
                                                                                                            </Tooltip>
                                                                                                        </button>
                                                                                                    </div>
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                    {this.state.serviceList.length > 0 && (
                                                                                        <tr>
                                                                                            {(() => {
                                                                                                // Sl No., Services, SCN, Price, Qty, Discount, Markup, Total Amount
                                                                                                let colSpan = 8;
                                                                                                if (this.state.taxrequired) {
                                                                                                    if (this.state.taxtype === "GST" && ccountry === "India" && this.state.gsttype === "INTRASTATE") {
                                                                                                        colSpan += 2; // CGST + SGST
                                                                                                    } else {
                                                                                                        colSpan += 1; // Standard Tax
                                                                                                    }
                                                                                                }
                                                                                                // In Multicurrency mode, the first Net Amount column is "Invoice Currency"
                                                                                                // and the second is "Base Currency". We want the total under the last Net Amount column.
                                                                                                if (this.state.currency && this.state.currency !== this.state.basecurrency) {
                                                                                                    colSpan += 1; // Span across Net Amount (Inv)
                                                                                                }
                                                                                                return <td colSpan={colSpan} className="UI-td UI-total-label" style={{ textAlign: 'right' }}>Total:</td>;
                                                                                            })()}
                                                                                            <td className="UI-td UI-amount" style={{ fontWeight: 'bold' }}>
                                                                                                <NumericFormat
                                                                                                    displayType="text"
                                                                                                    value={this.state.currency !== this.state.basecurrency ? this.state.ccgrandservicetotal : this.state.grandservicetotal}
                                                                                                    decimalScale={2}
                                                                                                    fixedDecimalScale
                                                                                                    thousandSeparator
                                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                                />
                                                                                            </td>
                                                                                            <td className="UI-td"></td> {/* Action */}
                                                                                        </tr>
                                                                                    )}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </>
                                                    )
                                                )}

                                                {/* SECTION: Invoice Items / Products Table */}
                                                {this.state.accepteditems.length > 0 && (
                                                    <div className="UI-table-container">
                                                        <div className="UI-table-header-toolbar">
                                                            <h4 className="UI-section-title">Invoice Items / Products</h4>
                                                        </div>
                                                        <table className="UI-table">
                                                            <thead className="UI-table-header">
                                                                <tr>
                                                                    <th className="UI-th">Sl No.</th>
                                                                    <th className="UI-th">Products</th>
                                                                    {this.state.taxtype !== "NA" && <th className="UI-th">HSN</th>}
                                                                    <th className="UI-th">Price ({this.state.currency || this.state.basecurrency})</th>
                                                                    <th className="UI-th">Qty</th>
                                                                    <th className="UI-th">UOM</th>
                                                                    <th className="UI-th">Discount ({this.state.currency || this.state.basecurrency})</th>
                                                                    {/* <th className="UI-th">Markup ({this.state.currency || this.state.basecurrency})</th> */}
                                                                    <th className="UI-th">Total Amount ({this.state.currency || this.state.basecurrency})</th>
                                                                    {!this.state.taxrequired || this.state.taxtype === "NA" ? null : (
                                                                        <>
                                                                            {this.state.taxtype === "GST" && this.state.gsttype === "INTRASTATE" ? (
                                                                                <>
                                                                                    <th className="UI-th">CGST</th>
                                                                                    <th className="UI-th">SGST</th>
                                                                                </>
                                                                            ) : (
                                                                                <th className="UI-th">{this.state.taxtype}</th>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    <th className="UI-th">Net Amount ({this.state.currency || this.state.basecurrency})</th>
                                                                    {this.state.currency && this.state.currency !== this.state.basecurrency && (
                                                                        <th className="UI-th">Net Amount ({this.state.basecurrency})</th>
                                                                    )}
                                                                    {this.state.invtype === "Direct Invoice" && <th className="UI-th">Action</th>}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.accepteditems.map((row, index) => (
                                                                    <React.Fragment key={index}>
                                                                        <tr className="UI-table-row">
                                                                            <td className="UI-td">
                                                                                <span>{String(index + 1).padStart(2, '0')}</span>
                                                                            </td>
                                                                            <td className="UI-td">{row.name}</td>
                                                                            {this.state.taxtype !== "NA" && <td className="UI-td">{row.hsn}</td>}
                                                                            <td className="UI-td UI-amount">
                                                                                <NumericFormat
                                                                                    displayType="text"
                                                                                    value={this.state.currency && this.state.currency !== this.state.basecurrency ? row.ccprice : row.price}
                                                                                    decimalScale={2}
                                                                                    fixedDecimalScale
                                                                                    thousandSeparator
                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                />
                                                                            </td>
                                                                            <td className="UI-td">{row.quantity}</td>
                                                                            <td className="UI-td">{row.uom}</td>
                                                                            <td className="UI-td UI-amount">
                                                                                <NumericFormat
                                                                                    displayType="text"
                                                                                    value={this.state.currency && this.state.currency !== this.state.basecurrency ? row.ccdiscountamount : row.discountamount}
                                                                                    decimalScale={2}
                                                                                    fixedDecimalScale
                                                                                    thousandSeparator
                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                /> ({row.discount}%)
                                                                            </td>
                                                                            {/* <td className="UI-td UI-amount">
                                                                                <NumericFormat
                                                                                    displayType="text"
                                                                                    value={this.state.currency && this.state.currency !== this.state.basecurrency ? row.ccmarkup1 : row.markup1}
                                                                                    decimalScale={2}
                                                                                    fixedDecimalScale
                                                                                    thousandSeparator
                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                />
                                                                            </td> */}
                                                                            <td className="UI-td UI-amount">
                                                                                <NumericFormat
                                                                                    displayType="text"
                                                                                    value={this.state.currency && this.state.currency !== this.state.basecurrency ? row.cctotalprice : row.totalprice}
                                                                                    decimalScale={2}
                                                                                    fixedDecimalScale
                                                                                    thousandSeparator
                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                />
                                                                            </td>
                                                                            {!this.state.taxrequired || this.state.taxtype === "NA" ? null : (
                                                                                <>
                                                                                    {this.state.taxtype === "GST" && this.state.gsttype === "INTRASTATE" ? (
                                                                                        <>
                                                                                            <td className="UI-td UI-amount">
                                                                                                <NumericFormat
                                                                                                    displayType="text"
                                                                                                    value={(this.state.currency && this.state.currency !== this.state.basecurrency ? row.cctaxamount : row.taxamount) / 2}
                                                                                                    decimalScale={2}
                                                                                                    fixedDecimalScale
                                                                                                    thousandSeparator
                                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                                /> ({row.tax / 2}%)
                                                                                            </td>
                                                                                            <td className="UI-td UI-amount">
                                                                                                <NumericFormat
                                                                                                    displayType="text"
                                                                                                    value={(this.state.currency && this.state.currency !== this.state.basecurrency ? row.cctaxamount : row.taxamount) / 2}
                                                                                                    decimalScale={2}
                                                                                                    fixedDecimalScale
                                                                                                    thousandSeparator
                                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                                /> ({row.tax / 2}%)
                                                                                            </td>
                                                                                        </>
                                                                                    ) : (
                                                                                        <td className="UI-td UI-amount">
                                                                                            <NumericFormat
                                                                                                displayType="text"
                                                                                                value={this.state.currency && this.state.currency !== this.state.basecurrency ? row.cctaxamount : row.taxamount}
                                                                                                decimalScale={2}
                                                                                                fixedDecimalScale
                                                                                                thousandSeparator
                                                                                                thousandsGroupStyle={thousandsdisplay}
                                                                                            /> ({row.tax}%)
                                                                                        </td>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                            <td className="UI-td UI-amount">
                                                                                <NumericFormat
                                                                                    displayType="text"
                                                                                    value={this.state.currency && this.state.currency !== this.state.basecurrency ? row.cctotalpricewtax : row.totalpricewtax}
                                                                                    decimalScale={2}
                                                                                    fixedDecimalScale
                                                                                    thousandSeparator
                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                />
                                                                            </td>
                                                                            {this.state.currency && this.state.currency !== this.state.basecurrency && (
                                                                                <td className="UI-td UI-amount">
                                                                                    <NumericFormat
                                                                                        displayType="text"
                                                                                        value={row.totalpricewtax}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale
                                                                                        thousandSeparator
                                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                                    />
                                                                                </td>
                                                                            )}
                                                                            {this.state.invtype === "Direct Invoice" && (
                                                                                <td className="UI-td">
                                                                                    {((this.state.invtype === "Direct Invoice" && this.state.pagename === "Edit Invoice") || (this.state.pagename !== "Edit Invoice")) && (
                                                                                        <div className="UI-action-buttons" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                                            <button
                                                                                                type="button"
                                                                                                onClick={() => this.editItemFromList(row, index)}
                                                                                                style={{ border: "none", background: "transparent", padding: 0, cursor: "pointer" }}
                                                                                                aria-label="Edit item"
                                                                                                onMouseEnter={() => this.setState({ isActionHovered: `editItem-${index}` })}
                                                                                                onMouseLeave={() => this.setState({ isActionHovered: null })}
                                                                                            >
                                                                                                <Tooltip
                                                                                                    title="Edit"
                                                                                                    arrow
                                                                                                    slotProps={{ popper: { sx: { pointerEvents: 'none' } } }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={EditIcon}
                                                                                                        alt="Edit"
                                                                                                        className={`UI-edit-icon ${this.state.isActionHovered === `editItem-${index}` ? 'UI-edit-icon-hover' : ''}`}
                                                                                                    />
                                                                                                </Tooltip>
                                                                                            </button>
                                                                                            <button
                                                                                                type="button"
                                                                                                onClick={() => this.removeItemFromList(index)}
                                                                                                style={{ border: "none", background: "transparent", padding: 0, cursor: "pointer" }}
                                                                                                aria-label="Delete item"
                                                                                                onMouseEnter={() => this.setState({ isActionHovered: `deleteItem-${index}` })}
                                                                                                onMouseLeave={() => this.setState({ isActionHovered: null })}
                                                                                            >
                                                                                                <Tooltip
                                                                                                    title="Delete"
                                                                                                    arrow
                                                                                                    slotProps={{ popper: { sx: { pointerEvents: 'none' } } }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={DeleteIcon}
                                                                                                        alt="Delete"
                                                                                                        className={`UI-delete-icon ${this.state.isActionHovered === `deleteItem-${index}` ? 'UI-delete-icon-hover' : ''}`}
                                                                                                    />
                                                                                                </Tooltip>
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                </td>
                                                                            )}
                                                                        </tr>
                                                                    </React.Fragment>
                                                                ))}
                                                                {this.state.accepteditems.length > 0 && (
                                                                    <tr>
                                                                        {(() => {
                                                                            // Sl No., Products, Price, Qty, UOM, Discount, Markup, Total Amount
                                                                            let colSpan = 7;
                                                                            if (this.state.taxtype !== "NA") colSpan += 1; // HSN
                                                                            if (this.state.taxrequired && this.state.taxtype !== "NA") {
                                                                                if (this.state.taxtype === "GST" && this.state.gsttype === "INTRASTATE") {
                                                                                    colSpan += 2;
                                                                                } else {
                                                                                    colSpan += 1;
                                                                                }
                                                                            }
                                                                            if (this.state.currency && this.state.currency !== this.state.basecurrency) {
                                                                                colSpan += 1; // Span across Net Amount (Inv)
                                                                            }
                                                                            return <td colSpan={colSpan} className="UI-td UI-total-label" style={{ textAlign: 'right' }}>Total:</td>;
                                                                        })()}
                                                                        <td className="UI-td UI-amount" style={{ fontWeight: 'bold' }}>
                                                                            <NumericFormat
                                                                                displayType="text"
                                                                                value={this.state.currency !== this.state.basecurrency ? this.state.ccgranditemstotal : this.state.granditemstotal}
                                                                                decimalScale={2}
                                                                                fixedDecimalScale
                                                                                thousandSeparator
                                                                                thousandsGroupStyle={thousandsdisplay}
                                                                            />
                                                                        </td>
                                                                        {this.state.invtype === "Direct Invoice" && <td className="UI-td"></td>}
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}

                                                {/* SECTION: Opening Balance / Debit Adjustment */}
                                                {this.state.pagename !== "New Proforma Invoice" && (this.state.openingbalance > 0 || this.state.debitamount > 0) && (
                                                    <div className="UI-form-section">
                                                        <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
                                                            {this.state.openingbalance > 0 && (
                                                                <div className="UI-form-group">
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                checked={this.state.adjustopen}
                                                                                onChange={() => this.setState({ adjustopen: !this.state.adjustopen })}
                                                                                color="primary"
                                                                            />
                                                                        }
                                                                        label={`Adjust From Opening Balance (${this.state.openingbalance})`}
                                                                    />
                                                                </div>
                                                            )}
                                                            {this.state.debitamount > 0 && (
                                                                <div className="UI-form-group">
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                checked={this.state.adjustdebit}
                                                                                onChange={() => this.setState({ adjustdebit: !this.state.adjustdebit })}
                                                                                color="primary"
                                                                            />
                                                                        }
                                                                        label={`Adjust From Credit Amount (${this.state.debitamount})`}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {(this.state.accepteditems.length > 0 || this.state.serviceList.length > 0) &&
                                                    this.state.pagename !== "New Proforma Invoice" && (
                                                        <div className="UI-form-section">
                                                            {/* Two‑column layout */}
                                                            <div style={{ display: 'flex', gap: '24px' }}>
                                                                {/* LEFT COLUMN – Checkboxes and sections */}
                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                    {/* Three checkboxes */}
                                                                    <div
                                                                        style={{
                                                                            display: 'flex',
                                                                            gap: '10px',
                                                                            marginBottom: '16px',
                                                                            flexWrap: 'wrap',
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '8px',
                                                                                cursor: 'pointer',
                                                                                padding: '8px 16px',
                                                                                borderRadius: '50px',
                                                                                border: this.state.additionalChargesEnabled ? '1px solid #3574de' : '1px solid #e2e8f0',
                                                                                backgroundColor: this.state.additionalChargesEnabled ? '#e4f0f7' : 'transparent',
                                                                            }}
                                                                            onClick={() => this.setState(prev => ({ additionalChargesEnabled: !prev.additionalChargesEnabled }))}
                                                                        >
                                                                            <SelectableRadio checked={this.state.additionalChargesEnabled} size="md" />
                                                                            <span className="UI-label">Additional Charges</span>
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '8px',
                                                                                cursor: 'pointer',
                                                                                padding: '8px 16px',
                                                                                borderRadius: '50px',
                                                                                border: this.state.insuranceEnabled ? '1px solid #3574de' : '1px solid #e2e8f0',
                                                                                backgroundColor: this.state.insuranceEnabled ? '#e4f0f7' : 'transparent',
                                                                            }}
                                                                            onClick={() => this.setState(prev => ({ insuranceEnabled: !prev.insuranceEnabled }))}
                                                                        >
                                                                            <SelectableRadio checked={this.state.insuranceEnabled} size="md" />
                                                                            <span className="UI-label">Add Insurance</span>
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                gap: '8px',
                                                                                cursor: 'pointer',
                                                                                padding: '8px 16px',
                                                                                borderRadius: '50px',
                                                                                border: this.state.tcsEnabled ? '1px solid #3574de' : '1px solid #e2e8f0',
                                                                                backgroundColor: this.state.tcsEnabled ? '#e4f0f7' : 'transparent',
                                                                            }}
                                                                            onClick={() => this.setState(prev => ({ tcsEnabled: !prev.tcsEnabled }))}
                                                                        >
                                                                            <SelectableRadio checked={this.state.tcsEnabled} size="md" />
                                                                            <span className="UI-label">{ccountry === 'India' ? 'Add TCS Or TDS' : 'Add TDS'}</span>
                                                                        </div>
                                                                    </div>

                                                                    {/* Additional Charges Section */}
                                                                    {this.state.additionalChargesEnabled && (
                                                                        <div style={{ backgroundColor: '#f9f9f9', padding: '16px', marginBottom: '16px', borderRadius: '4px' }}>
                                                                            <span style={{ marginBottom: '10px' }}>
                                                                                <h4 className="UI-section-title">Additional Charges</h4>
                                                                            </span>

                                                                            {/* Row 1: Nature + Amount */}
                                                                            <div className="UI-form-grid" style={{ gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Nature/Type of Charges *</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className={`UI-input ${this.state.natureofcharge === '' && this.state.adderr ? 'UI-input-error' : ''}`}
                                                                                        value={this.state.natureofcharge}
                                                                                        onChange={(e) => this.setState({ natureofcharge: e.target.value })}
                                                                                    />
                                                                                    {this.state.natureofcharge === '' && this.state.adderr && (
                                                                                        <div className="UI-error-text">Please enter nature of charge</div>
                                                                                    )}
                                                                                </div>

                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Additional Charges Amount *</label>
                                                                                    <div style={{ position: 'relative' }}>
                                                                                        <input
                                                                                            type="number"
                                                                                            className={`UI-input ${this.state.additionalcharges === '' && this.state.adderr ? 'UI-input-error' : ''}`}
                                                                                            value={this.state.additionalcharges}
                                                                                            onChange={(e) => {
                                                                                                const val = parseFloat(e.target.value) || 0;
                                                                                                this.setState({
                                                                                                    additionalcharges: val,
                                                                                                    totaladditionalcharges: ((val * this.state.additionalchargestax) / 100 + val).toFixed(3),
                                                                                                    additionalchargestaxamount: (val * this.state.additionalchargestax) / 100,
                                                                                                });
                                                                                            }}
                                                                                            style={{ width: '100%', paddingRight: '55px' }}
                                                                                        />
                                                                                        <span
                                                                                            style={{
                                                                                                position: 'absolute',
                                                                                                right: '12px',
                                                                                                top: '50%',
                                                                                                transform: 'translateY(-50%)',
                                                                                                pointerEvents: 'none',
                                                                                                fontSize: '13px',
                                                                                                color: '#666',
                                                                                            }}
                                                                                        >
                                                                                            {this.state.currency}
                                                                                        </span>
                                                                                    </div>
                                                                                    {this.state.additionalcharges === '' && this.state.adderr && (
                                                                                        <div className="UI-error-text">Please enter amount</div>
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                            {/* Row 2: Tax + Total */}
                                                                            <div className="UI-form-grid" style={{ gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Additional Charges Tax (%)</label>
                                                                                    <div style={{ position: 'relative' }}>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="UI-input"
                                                                                            value={this.state.additionalchargestax}
                                                                                            onChange={(e) => {
                                                                                                const tax = parseFloat(e.target.value) || 0;
                                                                                                this.setState({
                                                                                                    additionalchargestax: tax,
                                                                                                    additionalchargestaxamount: (this.state.additionalcharges * tax) / 100,
                                                                                                    totaladditionalcharges: ((this.state.additionalcharges * tax) / 100 + this.state.additionalcharges).toFixed(3),
                                                                                                });
                                                                                            }}
                                                                                            style={{ width: '100%', paddingRight: '55px' }}
                                                                                        />
                                                                                        <span
                                                                                            style={{
                                                                                                position: 'absolute',
                                                                                                right: '12px',
                                                                                                top: '50%',
                                                                                                transform: 'translateY(-50%)',
                                                                                                pointerEvents: 'none',
                                                                                                fontSize: '13px',
                                                                                                color: '#666',
                                                                                            }}
                                                                                        >
                                                                                            %
                                                                                        </span>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Total Additional Charge</label>
                                                                                    <div>
                                                                                        <div style={{ position: 'relative', marginBottom: '4px' }}>
                                                                                            <input
                                                                                                type="number"
                                                                                                className="UI-input"
                                                                                                value={this.state.totaladditionalcharges}
                                                                                                readOnly
                                                                                                style={{ width: '100%', paddingRight: '55px' }}
                                                                                            />
                                                                                            <span
                                                                                                style={{
                                                                                                    position: 'absolute',
                                                                                                    right: '12px',
                                                                                                    top: '50%',
                                                                                                    transform: 'translateY(-50%)',
                                                                                                    pointerEvents: 'none',
                                                                                                    fontSize: '13px',
                                                                                                    color: '#666',
                                                                                                }}
                                                                                            >
                                                                                                {this.state.currency}
                                                                                            </span>
                                                                                        </div>
                                                                                        {/* {this.state.currency !== this.state.basecurrency && (
                        <div style={{ position: 'relative' }}>
                          <input
                            type="number"
                            className="UI-input"
                            value={this.state.totaladditionalcharges * this.state.curconversionrate}
                            readOnly
                            style={{ width: '100%', paddingRight: '55px' }}
                          />
                          <span
                            style={{
                              position: 'absolute',
                              right: '12px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              pointerEvents: 'none',
                              fontSize: '13px',
                              color: '#666',
                            }}
                          >
                            {this.state.basecurrency}
                          </span>
                        </div>
                      )} */}
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            {/* Add button */}
                                                                            <div style={{ marginBottom: '16px' }}>
                                                                                <button type="button" className="UI-btn UI-btn-primary" onClick={this.AdditionalCharges}>
                                                                                    <i className="fas fa-plus"></i> Add
                                                                                </button>
                                                                            </div>

                                                                            {/* Table of added charges */}
                                                                            {this.state.additionalchargeslist.length > 0 && (
                                                                                <div className="UI-table-container">
                                                                                    <h4 className="UI-section-title">Added Additional Charges</h4>
                                                                                    <table className="UI-table">
                                                                                        <thead className="UI-table-header">
                                                                                            <tr>
                                                                                                <th className="UI-th">Nature</th>
                                                                                                <th className="UI-th">Amount ({this.state.currency})</th>
                                                                                                <th className="UI-th">Tax %</th>
                                                                                                <th className="UI-th">Tax Amt ({this.state.currency})</th>
                                                                                                <th className="UI-th">Total ({this.state.basecurrency})</th>
                                                                                                {this.state.currency !== this.state.basecurrency && (
                                                                                                    <th className="UI-th">Total ({this.state.currency})</th>
                                                                                                )}
                                                                                                <th className="UI-th"></th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {this.state.additionalchargeslist.map((item, idx) => (
                                                                                                <tr key={idx}>
                                                                                                    <td className="UI-td">{item.natureofcharge}</td>
                                                                                                    <td className="UI-td UI-amount">
                                                                                                        <NumericFormat
                                                                                                            displayType="text"
                                                                                                            value={item.ccadditionalcharges}
                                                                                                            decimalScale={2}
                                                                                                            fixedDecimalScale
                                                                                                            thousandSeparator
                                                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td className="UI-td">{item.additionalchargestax}%</td>
                                                                                                    <td className="UI-td UI-amount">
                                                                                                        <NumericFormat
                                                                                                            displayType="text"
                                                                                                            value={item.ccadditionalchargestaxamount}
                                                                                                            decimalScale={2}
                                                                                                            fixedDecimalScale
                                                                                                            thousandSeparator
                                                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                                                        />
                                                                                                    </td>
                                                                                                    <td className="UI-td UI-amount">
                                                                                                        <NumericFormat
                                                                                                            displayType="text"
                                                                                                            value={item.totaladditionalcharges}
                                                                                                            decimalScale={2}
                                                                                                            fixedDecimalScale
                                                                                                            thousandSeparator
                                                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                                                        />
                                                                                                    </td>
                                                                                                    {this.state.currency !== this.state.basecurrency && (
                                                                                                        <td className="UI-td UI-amount">
                                                                                                            <NumericFormat
                                                                                                                displayType="text"
                                                                                                                value={item.cctotaladditionalcharges}
                                                                                                                decimalScale={2}
                                                                                                                fixedDecimalScale
                                                                                                                thousandSeparator
                                                                                                                thousandsGroupStyle={thousandsdisplay}
                                                                                                            />
                                                                                                        </td>
                                                                                                    )}
                                                                                                    <td className="UI-td">
                                                                                                        <i
                                                                                                            className="fas fa-times text-danger cursorPointer"
                                                                                                            onClick={() => this.RemoveAdditionalCharges(idx)}
                                                                                                        />
                                                                                                    </td>
                                                                                                </tr>
                                                                                            ))}
                                                                                            {/* Totals row omitted as not requested */}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    {/* Insurance Section */}
                                                                    {this.state.insuranceEnabled && (
                                                                        <div style={{ backgroundColor: '#f9f9f9', padding: '16px', marginBottom: '16px', borderRadius: '4px' }}>
                                                                            <span style={{ marginBottom: '10px' }}>

                                                                                <h4 className="UI-section-title">Insurance</h4>
                                                                            </span>
                                                                            <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Insurance (%)</label>
                                                                                    <div style={{ position: 'relative' }}>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="UI-input"
                                                                                            value={this.state.insurance}
                                                                                            onChange={this.handleInsuranceChange}
                                                                                            style={{ width: '100%', paddingRight: '55px' }}
                                                                                        />
                                                                                        <span
                                                                                            style={{
                                                                                                position: 'absolute',
                                                                                                right: '12px',
                                                                                                top: '50%',
                                                                                                transform: 'translateY(-50%)',
                                                                                                pointerEvents: 'none',
                                                                                                fontSize: '13px',
                                                                                                color: '#666',
                                                                                            }}
                                                                                        >
                                                                                            %
                                                                                        </span>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Insurance Amount</label>
                                                                                    <div style={{ position: 'relative' }}>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="UI-input"
                                                                                            value={this.state.insuranceamount}
                                                                                            onChange={this.handleInsuranceAmount}
                                                                                            style={{ width: '100%', paddingRight: '55px' }}
                                                                                        />
                                                                                        <span
                                                                                            style={{
                                                                                                position: 'absolute',
                                                                                                right: '12px',
                                                                                                top: '50%',
                                                                                                transform: 'translateY(-50%)',
                                                                                                pointerEvents: 'none',
                                                                                                fontSize: '13px',
                                                                                                color: '#666',
                                                                                            }}
                                                                                        >
                                                                                            {this.state.currency}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Insurance Tax (%)</label>
                                                                                    <div style={{ position: 'relative' }}>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="UI-input"
                                                                                            value={this.state.insurancetax}
                                                                                            onChange={this.handleInsuranceTax}
                                                                                            style={{ width: '100%', paddingRight: '55px' }}
                                                                                        />
                                                                                        <span
                                                                                            style={{
                                                                                                position: 'absolute',
                                                                                                right: '12px',
                                                                                                top: '50%',
                                                                                                transform: 'translateY(-50%)',
                                                                                                pointerEvents: 'none',
                                                                                                fontSize: '13px',
                                                                                                color: '#666',
                                                                                            }}
                                                                                        >
                                                                                            %
                                                                                        </span>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Total Insurance</label>
                                                                                    <div style={{ position: 'relative' }}>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="UI-input"
                                                                                            value={this.state.totalinsuranceamount?.toFixed(2)}
                                                                                            readOnly
                                                                                            style={{ width: '100%', paddingRight: '55px' }}
                                                                                        />
                                                                                        <span
                                                                                            style={{
                                                                                                position: 'absolute',
                                                                                                right: '12px',
                                                                                                top: '50%',
                                                                                                transform: 'translateY(-50%)',
                                                                                                pointerEvents: 'none',
                                                                                                fontSize: '13px',
                                                                                                color: '#666',
                                                                                            }}
                                                                                        >
                                                                                            {this.state.currency}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {this.state.tcsEnabled && (
                                                                        <div style={{ backgroundColor: '#f9f9f9', padding: '16px', marginBottom: '16px', borderRadius: '4px' }}>
                                                                            {/* Toggle between TCS and TDS */}
                                                                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                                                                <span className="UI-section-title2 tw-mr-[10px]">TDS</span>
                                                                                <OSSwitch
                                                                                    checked={this.state.isTCSMode}
                                                                                    onChange={(checked) => this.setState({ isTCSMode: checked })}
                                                                                />
                                                                                <span className="UI-section-title2 tw-ml-[10px]">TCS</span>
                                                                            </div>

                                                                            {/* Fields – conditionally render TCS or TDS */}
                                                                            {this.state.isTCSMode ? (
                                                                                <>
                                                                                    <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">TCS on Amount</label>
                                                                                            <input
                                                                                                type="number"
                                                                                                className="UI-input"
                                                                                                value={Number(this.state.tcsableamount || 0).toFixed(2)}
                                                                                                onChange={(e) => {
                                                                                                    const val = parseFloat(e.target.value) || 0;
                                                                                                    this.setState({
                                                                                                        tcsableamount: val,
                                                                                                        tcsamount: val ? ((this.state.tcs * val) / 100).toFixed(2) : 0,
                                                                                                    }, this.recomputeTotals);
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">TCS (%)</label>
                                                                                            <div style={{ position: 'relative' }}>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="UI-input"
                                                                                                    value={this.state.tcs}
                                                                                                    onChange={this.handletcsChange}
                                                                                                    style={{ width: '100%', paddingRight: '55px' }}
                                                                                                />
                                                                                                <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', fontSize: '13px', color: '#666' }}>%</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">TCS Amount</label>
                                                                                            <input type="number" className="UI-input" value={this.state.tcsamount} readOnly />
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                // TDS fields
                                                                                <>
                                                                                    <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">TDS on Amount</label>
                                                                                            <input
                                                                                                type="number"
                                                                                                className="UI-input"
                                                                                                value={Number(this.state.tdsableamount || 0).toFixed(2)}
                                                                                                onChange={(e) => {
                                                                                                    const val = parseFloat(e.target.value) || 0;
                                                                                                    this.setState({
                                                                                                        tdsableamount: val,
                                                                                                        tdsamount: val ? ((this.state.tds * val) / 100).toFixed(2) : 0,
                                                                                                    }, this.recomputeTotals);
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">TDS (%)</label>
                                                                                            <div style={{ position: 'relative' }}>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="UI-input"
                                                                                                    value={this.state.tds}
                                                                                                    onChange={(e) => {
                                                                                                        const val = parseFloat(e.target.value) || 0;
                                                                                                        this.setState({ tds: val, tdsamount: ((this.state.tdsableamount || 0) * val) / 100 }, this.recomputeTotals);
                                                                                                    }}
                                                                                                    style={{ width: '100%', paddingRight: '55px' }}
                                                                                                />
                                                                                                <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none', fontSize: '13px', color: '#666' }}>%</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">TDS Amount</label>
                                                                                            <input type="number" className="UI-input" value={this.state.tdsamount} readOnly />
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                {/* RIGHT COLUMN – Subtotal Panel */}
                                                                <div
                                                                    style={{
                                                                        flex: 1,
                                                                        minWidth: 0,
                                                                        backgroundColor: '#f4f4f4',
                                                                        padding: '20px',
                                                                        borderRadius: '4px',
                                                                        alignSelf: 'flex-start',
                                                                        position: 'sticky',
                                                                        top: '20px',          // keeps it 20px from the top of the viewport while its parent is visible
                                                                        zIndex: 1,
                                                                    }}
                                                                >
                                                                    <h4 style={{ marginTop: 0, marginBottom: '16px' }}>Subtotal</h4>

                                                                    {/* Subtotal rows – using computed totals from state */}
                                                                    <div style={{ marginBottom: '12px' }}>
                                                                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                                                                            <span>Subtotal (Items/Services):</span>
                                                                            <span>
                                                                                <NumericFormat
                                                                                    displayType="text"
                                                                                    value={this.state.subtotal || 0}
                                                                                    decimalScale={2}
                                                                                    fixedDecimalScale
                                                                                    thousandSeparator
                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                />{' '}
                                                                                {this.state.currency}
                                                                            </span>
                                                                        </div>
                                                                        {this.state.currency !== this.state.basecurrency && (
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '0.9em', color: '#555' }}>
                                                                                <span>Subtotal ({this.state.basecurrency}):</span>
                                                                                <span>
                                                                                    <NumericFormat
                                                                                        displayType="text"
                                                                                        value={this.state.ccsubtotal || 0}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale
                                                                                        thousandSeparator
                                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                                    />{' '}
                                                                                    {this.state.basecurrency}
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {this.state.taxrequired && (
                                                                        <div style={{ marginBottom: '12px' }}>
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                                                                                <span>Tax Total:</span>
                                                                                <span>
                                                                                    <NumericFormat
                                                                                        displayType="text"
                                                                                        value={this.state.taxTotal || 0}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale
                                                                                        thousandSeparator
                                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                                    />{' '}
                                                                                    {this.state.currency}
                                                                                </span>
                                                                            </div>
                                                                            {this.state.currency !== this.state.basecurrency && (
                                                                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '0.9em', color: '#555' }}>
                                                                                    <span>Tax Total ({this.state.basecurrency}):</span>
                                                                                    <span>
                                                                                        <NumericFormat
                                                                                            displayType="text"
                                                                                            value={this.state.cctaxTotal || 0}
                                                                                            decimalScale={2}
                                                                                            fixedDecimalScale
                                                                                            thousandSeparator
                                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                                        />{' '}
                                                                                        {this.state.basecurrency}
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    {this.state.additionalChargesEnabled && this.state.additionalChargesTotal > 0 && (
                                                                        <div style={{ marginBottom: '12px' }}>
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                                                                                <span>Additional Charges:</span>
                                                                                <span>
                                                                                    <NumericFormat
                                                                                        displayType="text"
                                                                                        value={this.state.additionalChargesTotal}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale
                                                                                        thousandSeparator
                                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                                    />{' '}
                                                                                    {this.state.currency}
                                                                                </span>
                                                                            </div>
                                                                            {this.state.currency !== this.state.basecurrency && (
                                                                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '0.9em', color: '#555' }}>
                                                                                    <span>Additional Charges ({this.state.basecurrency}):</span>
                                                                                    <span>
                                                                                        <NumericFormat
                                                                                            displayType="text"
                                                                                            value={this.state.ccadditionalChargesTotal}
                                                                                            decimalScale={2}
                                                                                            fixedDecimalScale
                                                                                            thousandSeparator
                                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                                        />{' '}
                                                                                        {this.state.basecurrency}
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    {this.state.insuranceEnabled && this.state.insuranceTotal > 0 && (
                                                                        <div style={{ marginBottom: '12px' }}>
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                                                                                <span>Insurance Total:</span>
                                                                                <span>
                                                                                    <NumericFormat
                                                                                        displayType="text"
                                                                                        value={this.state.insuranceTotal}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale
                                                                                        thousandSeparator
                                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                                    />{' '}
                                                                                    {this.state.currency}
                                                                                </span>
                                                                            </div>
                                                                            {this.state.currency !== this.state.basecurrency && (
                                                                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '0.9em', color: '#555' }}>
                                                                                    <span>Insurance Total ({this.state.basecurrency}):</span>
                                                                                    <span>
                                                                                        <NumericFormat
                                                                                            displayType="text"
                                                                                            value={this.state.insuranceTotal * this.state.curconversionrate}
                                                                                            decimalScale={2}
                                                                                            fixedDecimalScale
                                                                                            thousandSeparator
                                                                                            thousandsGroupStyle={thousandsdisplay}
                                                                                        />{' '}
                                                                                        {this.state.basecurrency}
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    {this.state.tcsEnabled && (
                                                                        <div style={{ marginBottom: '12px' }}>
                                                                            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                                                                                <span>{this.state.isTCSMode ? 'TCS' : 'TDS'} Amount:</span>
                                                                                <span>
                                                                                    <NumericFormat
                                                                                        displayType="text"
                                                                                        value={this.state.isTCSMode ? this.state.tcsTotal : this.state.tdsTotal}
                                                                                        decimalScale={2}
                                                                                        fixedDecimalScale
                                                                                        thousandSeparator
                                                                                        thousandsGroupStyle={thousandsdisplay}
                                                                                    />{' '}
                                                                                    {this.state.currency}
                                                                                </span>
                                                                            </div>
                                                                            {/* Optionally show base currency equivalent if needed */}
                                                                        </div>
                                                                    )}

                                                                    <hr style={{ margin: '16px 0' }} />

                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '1.1em' }}>
                                                                        <span>Grand Total:</span>
                                                                        <span>
                                                                            <NumericFormat
                                                                                displayType="text"
                                                                                value={this.state.grandtotal}
                                                                                decimalScale={2}
                                                                                fixedDecimalScale
                                                                                thousandSeparator
                                                                                thousandsGroupStyle={thousandsdisplay}
                                                                            />{' '}
                                                                            {this.state.currency}
                                                                        </span>
                                                                    </div>
                                                                    {this.state.currency !== this.state.basecurrency && (
                                                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.9em', color: '#555', marginTop: '4px' }}>
                                                                            <span>Grand Total ({this.state.basecurrency}):</span>
                                                                            <span>
                                                                                <NumericFormat
                                                                                    displayType="text"
                                                                                    value={this.state.ccgrandtotal}
                                                                                    decimalScale={2}
                                                                                    fixedDecimalScale
                                                                                    thousandSeparator
                                                                                    thousandsGroupStyle={thousandsdisplay}
                                                                                />{' '}
                                                                                {this.state.basecurrency}
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                {/* SECTION: Delivery Address */}
                                                {(this.state.accepteditems.length > 0 || this.state.serviceList.length > 0) && this.state.pagename !== "New Proforma Invoice" && (
                                                    <div className="UI-form-section">
                                                        {/* Address type selector - four tabs */}
                                                        <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    cursor: 'pointer',
                                                                    padding: '8px 16px',
                                                                    borderRadius: '50px',
                                                                    border: this.state.addressType === 'dispatch' ? '1px solid #3574de' : '1px solid #e2e8f0',
                                                                    backgroundColor: this.state.addressType === 'dispatch' ? '#e4f0f7' : 'transparent',
                                                                }}
                                                                onClick={() => this.setState({ addressType: 'dispatch' })}
                                                            >
                                                                <SelectableRadio checked={this.state.addressType === 'dispatch'} size="md" />
                                                                <span className="UI-label">Seller's Dispatch Details</span>
                                                            </div>
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    cursor: 'pointer',
                                                                    padding: '8px 16px',
                                                                    borderRadius: '50px',
                                                                    border: this.state.addressType === 'billing' ? '1px solid #3574de' : '1px solid #e2e8f0',
                                                                    backgroundColor: this.state.addressType === 'billing' ? '#e4f0f7' : 'transparent',
                                                                }}
                                                                onClick={() => this.setState({ addressType: 'billing' })}
                                                            >
                                                                <SelectableRadio checked={this.state.addressType === 'billing'} size="md" />
                                                                <span className="UI-label">Customer Billing Details</span>
                                                            </div>
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    cursor: 'pointer',
                                                                    padding: '8px 16px',
                                                                    borderRadius: '50px',
                                                                    border: this.state.addressType === 'shipping' ? '1px solid #3574de' : '1px solid #e2e8f0',
                                                                    backgroundColor: this.state.addressType === 'shipping' ? '#e4f0f7' : 'transparent',
                                                                }}
                                                                onClick={() => this.setState({ addressType: 'shipping' })}
                                                            >
                                                                <SelectableRadio checked={this.state.addressType === 'shipping'} size="md" />
                                                                <span className="UI-label">Customer Shipping Details</span>
                                                            </div>
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px',
                                                                    cursor: 'pointer',
                                                                    padding: '8px 16px',
                                                                    borderRadius: '50px',
                                                                    border: this.state.addressType === 'transport' ? '1px solid #3574de' : '1px solid #e2e8f0',
                                                                    backgroundColor: this.state.addressType === 'transport' ? '#e4f0f7' : 'transparent',
                                                                }}
                                                                onClick={() => this.setState({ addressType: 'transport' })}
                                                            >
                                                                <SelectableRadio checked={this.state.addressType === 'transport'} size="md" />
                                                                <span className="UI-label">Transport Details (Mandatory)</span>
                                                            </div>
                                                        </div>

                                                        <div style={{ backgroundColor: '#f9f9f9', padding: '16px', marginBottom: '16px', borderRadius: '4px' }}>
                                                            {/* Dispatch Details Tab */}
                                                            {this.state.addressType === 'dispatch' && (
                                                                <div className="UI-form-section-inner" >
                                                                    <div className="UI-form-group" style={{ marginBottom: '16px', marginLeft: '10px' }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={this.state.defaultdisadd}
                                                                                    onChange={this.handleDefaultdisadd}
                                                                                    icon={<SelectableRadio checked={false} />}
                                                                                    checkedIcon={<SelectableRadio checked={true} />}
                                                                                    sx={{ p: 0 }}
                                                                                />
                                                                            }
                                                                            label="Default dispatch address"
                                                                            className="UI-label"
                                                                            sx={{ gap: '8px' }}
                                                                            slotProps={{
                                                                                typography: {
                                                                                    style: { marginLeft: '8px' }
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Full Name</label>
                                                                            <input
                                                                                type="text"
                                                                                className={`UI-input ${this.state.disname === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                value={this.state.disname}
                                                                                onChange={(e) => this.setState({ disname: e.target.value, err: false })}
                                                                            />
                                                                            {this.state.disname === "" && this.state.err && (
                                                                                <div className="UI-error-text">Empty field!</div>
                                                                            )}
                                                                        </div>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Phone Number</label>
                                                                            <input
                                                                                type="text"
                                                                                className={`UI-input ${this.state.disphoneno === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                value={this.state.disphoneno}
                                                                                onChange={(e) => this.setState({ disphoneno: e.target.value, err: false })}
                                                                            />
                                                                            {this.state.disphoneno === "" && this.state.err && (
                                                                                <div className="UI-error-text">Empty field!</div>
                                                                            )}
                                                                        </div>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Pincode</label>
                                                                            <input
                                                                                type="number"
                                                                                className={`UI-input ${this.state.dispincode === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                value={this.state.dispincode}
                                                                                onChange={(e) => {
                                                                                    this.setState({ dispincode: e.target.value, err: false });
                                                                                    MasterService.getDistance(e.target.value, this.state.pincode).then((res) =>
                                                                                        this.setState({ distance: res.data })
                                                                                    );
                                                                                }}
                                                                            />
                                                                            {this.state.dispincode === "" && this.state.err && (
                                                                                <div className="UI-error-text">Empty field!</div>
                                                                            )}
                                                                        </div>

                                                                        {this.state.defaultdisadd ? (
                                                                            <>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Country</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="UI-input"
                                                                                        value={this.state.discountry}
                                                                                        onChange={(e) => this.setState({ discountry: e.target.value })}
                                                                                    />
                                                                                </div>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">State</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="UI-input"
                                                                                        value={this.state.disstate}
                                                                                        onChange={(e) => this.setState({ disstate: e.target.value })}
                                                                                    />
                                                                                </div>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">City</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="UI-input"
                                                                                        value={this.state.discity}
                                                                                        onChange={(e) => this.setState({ discity: e.target.value })}
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Country</label>
                                                                                    <Autocomplete
                                                                                        options={this.state.CountryData}
                                                                                        getOptionLabel={(option) => option.name}
                                                                                        onChange={this.handleDisCountryChange}
                                                                                        renderInput={(params) => (
                                                                                            <div ref={params.InputProps.ref}>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    {...params.inputProps}
                                                                                                    className={`UI-input ${this.state.discountry === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                                    placeholder="Select country"
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                    />
                                                                                    {this.state.discountry === "" && this.state.err && (
                                                                                        <div className="UI-error-text">Empty field!</div>
                                                                                    )}
                                                                                </div>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">State</label>
                                                                                    <Autocomplete
                                                                                        options={this.state.disStatesData}
                                                                                        getOptionLabel={(option) => option.name}
                                                                                        onChange={this.handleDisStateChange}
                                                                                        renderInput={(params) => (
                                                                                            <div ref={params.InputProps.ref}>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    {...params.inputProps}
                                                                                                    className={`UI-input ${this.state.disstate === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                                    placeholder="Select state"
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                    />
                                                                                    {this.state.disstate === "" && this.state.err && (
                                                                                        <div className="UI-error-text">Empty field!</div>
                                                                                    )}
                                                                                </div>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">City</label>
                                                                                    <Autocomplete
                                                                                        options={this.state.disCitiesData}
                                                                                        getOptionLabel={(option) => option.name}
                                                                                        onChange={this.handleDisCityChange}
                                                                                        renderInput={(params) => (
                                                                                            <div ref={params.InputProps.ref}>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    {...params.inputProps}
                                                                                                    className={`UI-input ${this.state.discity === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                                    placeholder="Select city"
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                    />
                                                                                    {this.state.discity === "" && this.state.err && (
                                                                                        <div className="UI-error-text">Empty field!</div>
                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        )}

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Address</label>
                                                                            <input
                                                                                type="text"
                                                                                className={`UI-input ${(this.state.dishouseno === "" || this.state.dishouseno.length > 250) && this.state.err ? 'UI-input-error' : ''}`}
                                                                                value={this.state.dishouseno}
                                                                                onChange={(e) => this.setState({ dishouseno: e.target.value, err: false })}
                                                                            />
                                                                            {(this.state.dishouseno === "" || this.state.dishouseno.length > 250) && this.state.err && (
                                                                                <div className="UI-error-text">
                                                                                    {this.state.dishouseno === "" ? "Empty field!" : "Max 250 characters"}
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Roadname/Area/Colony</label>
                                                                            <input
                                                                                type="text"
                                                                                className={`UI-input ${(this.state.disareaname === "" || this.state.disareaname.length > 100) && this.state.err ? 'UI-input-error' : ''}`}
                                                                                value={this.state.disareaname}
                                                                                onChange={(e) => this.setState({ disareaname: e.target.value, err: false })}
                                                                            />
                                                                            {(this.state.disareaname === "" || this.state.disareaname.length > 100) && this.state.err && (
                                                                                <div className="UI-error-text">
                                                                                    {this.state.disareaname === "" ? "Empty field!" : "Max 100 characters"}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Billing Details Tab */}
                                                            {this.state.addressType === 'billing' && (
                                                                <div className="UI-form-section-inner">
                                                                    <h5 className="UI-section-title">Billing Address (from customer)</h5>
                                                                    <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Full Name</label>
                                                                            <input type="text" className="UI-input UI-input-disabled" value={this.state.billname} disabled />
                                                                        </div>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Phone Number</label>
                                                                            <input type="text" className="UI-input UI-input-disabled" value={this.state.billphoneno} disabled />
                                                                        </div>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Pincode</label>
                                                                            <input type="text" className="UI-input UI-input-disabled" value={this.state.billpincode} disabled />
                                                                        </div>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Country</label>
                                                                            <input type="text" className="UI-input UI-input-disabled" value={this.state.billcountry} disabled />
                                                                        </div>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">State</label>
                                                                            <input type="text" className="UI-input UI-input-disabled" value={this.state.billstate} disabled />
                                                                        </div>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">City</label>
                                                                            <input type="text" className="UI-input UI-input-disabled" value={this.state.billcity} disabled />
                                                                        </div>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Address</label>
                                                                            <input type="text" className="UI-input UI-input-disabled" value={this.state.billhouseno} disabled />
                                                                        </div>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Roadname/Area/Colony</label>
                                                                            <input type="text" className="UI-input UI-input-disabled" value={this.state.billareaname} disabled />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Shipping Details Tab */}
                                                            {this.state.addressType === 'shipping' && (
                                                                <div className="UI-form-section-inner">
                                                                    <div className="UI-form-group" style={{ marginBottom: '16px', marginLeft: '10px' }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                <Checkbox
                                                                                    checked={this.state.defaultadd}
                                                                                    onChange={this.handleDefaultadd}
                                                                                    icon={<SelectableRadio checked={false} />}
                                                                                    checkedIcon={<SelectableRadio checked={true} />}
                                                                                    sx={{ p: 0 }}
                                                                                />
                                                                            }
                                                                            label="Same as billing address"
                                                                            className="UI-label"
                                                                            sx={{ gap: '8px' }}
                                                                            slotProps={{
                                                                                typography: {
                                                                                    style: { marginLeft: '8px' }
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Full Name</label>
                                                                            <input
                                                                                type="text"
                                                                                className={`UI-input ${this.state.name === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                value={this.state.name}
                                                                                onChange={(e) => this.setState({ name: e.target.value, err: false })}
                                                                            />
                                                                            {this.state.name === "" && this.state.err && (
                                                                                <div className="UI-error-text">Empty field!</div>
                                                                            )}
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Phone Number</label>
                                                                            <input
                                                                                type="text"
                                                                                className={`UI-input ${this.state.phoneno === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                value={this.state.phoneno}
                                                                                onChange={(e) => this.setState({ phoneno: e.target.value, err: false })}
                                                                            />
                                                                            {this.state.phoneno === "" && this.state.err && (
                                                                                <div className="UI-error-text">Empty field!</div>
                                                                            )}
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Pincode</label>
                                                                            <input
                                                                                type="number"
                                                                                className={`UI-input ${this.state.pincode === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                value={this.state.pincode}
                                                                                onChange={(e) => {
                                                                                    this.setState({ pincode: e.target.value, err: false });
                                                                                    MasterService.getDistance(this.state.dispincode, e.target.value).then((res) =>
                                                                                        this.setState({ distance: res.data })
                                                                                    );
                                                                                }}
                                                                            />
                                                                            {this.state.pincode === "" && this.state.err && (
                                                                                <div className="UI-error-text">Empty field!</div>
                                                                            )}
                                                                        </div>

                                                                        {this.state.defaultadd ? (
                                                                            <>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Country</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="UI-input"
                                                                                        value={this.state.country}
                                                                                        onChange={(e) => this.setState({ country: e.target.value })}
                                                                                    />
                                                                                </div>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">State</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="UI-input"
                                                                                        value={this.state.state}
                                                                                        onChange={(e) => this.setState({ state: e.target.value })}
                                                                                    />
                                                                                </div>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">City</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="UI-input"
                                                                                        value={this.state.city}
                                                                                        onChange={(e) => this.setState({ city: e.target.value })}
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">Country</label>
                                                                                    <Autocomplete
                                                                                        options={this.state.CountryData}
                                                                                        getOptionLabel={(option) => option.name}
                                                                                        onChange={this.handleCountryChange}
                                                                                        renderInput={(params) => (
                                                                                            <div ref={params.InputProps.ref}>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    {...params.inputProps}
                                                                                                    className={`UI-input ${this.state.country === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                                    placeholder="Select country"
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                    />
                                                                                    {this.state.country === "" && this.state.err && (
                                                                                        <div className="UI-error-text">Empty field!</div>
                                                                                    )}
                                                                                </div>

                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">State</label>
                                                                                    <Autocomplete
                                                                                        options={this.state.StatesData}
                                                                                        getOptionLabel={(option) => option.name}
                                                                                        onChange={this.handleStateChange}
                                                                                        renderInput={(params) => (
                                                                                            <div ref={params.InputProps.ref}>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    {...params.inputProps}
                                                                                                    className={`UI-input ${this.state.state === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                                    placeholder="Select state"
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                    />
                                                                                    {this.state.state === "" && this.state.err && (
                                                                                        <div className="UI-error-text">Empty field!</div>
                                                                                    )}
                                                                                </div>

                                                                                <div className="UI-form-group">
                                                                                    <label className="UI-label">City</label>
                                                                                    <Autocomplete
                                                                                        options={this.state.CitiesData}
                                                                                        getOptionLabel={(option) => option.name}
                                                                                        onChange={this.handleCityChange}
                                                                                        renderInput={(params) => (
                                                                                            <div ref={params.InputProps.ref}>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    {...params.inputProps}
                                                                                                    className={`UI-input ${this.state.city === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                                    placeholder="Select city"
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                    />
                                                                                    {this.state.city === "" && this.state.err && (
                                                                                        <div className="UI-error-text">Empty field!</div>
                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        )}

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Address</label>
                                                                            <input
                                                                                type="text"
                                                                                className={`UI-input ${(this.state.houseno === "" || this.state.houseno.length > 250) && this.state.err ? 'UI-input-error' : ''}`}
                                                                                value={this.state.houseno}
                                                                                onChange={(e) => this.setState({ houseno: e.target.value, err: false })}
                                                                            />
                                                                            {(this.state.houseno === "" || this.state.houseno.length > 250) && this.state.err && (
                                                                                <div className="UI-error-text">
                                                                                    {this.state.houseno === "" ? "Empty field!" : "Max 250 characters"}
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Roadname/Area/Colony</label>
                                                                            <input
                                                                                type="text"
                                                                                className={`UI-input ${(this.state.areaname === "" || this.state.areaname.length > 100) && this.state.err ? 'UI-input-error' : ''}`}
                                                                                value={this.state.areaname}
                                                                                onChange={(e) => this.setState({ areaname: e.target.value, err: false })}
                                                                            />
                                                                            {(this.state.areaname === "" || this.state.areaname.length > 100) && this.state.err && (
                                                                                <div className="UI-error-text">
                                                                                    {this.state.areaname === "" ? "Empty field!" : "Max 100 characters"}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Transport Details Tab (Mandatory) */}
                                                            {this.state.addressType === 'transport' && (
                                                                <div className="UI-form-section-inner">
                                                                    {this.state.einvoice && (
                                                                        <div className="UI-form-group" style={{ marginBottom: '16px' }}>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={this.state.samedaydelivery}
                                                                                        onChange={() => this.setState({ samedaydelivery: !this.state.samedaydelivery })}
                                                                                        color="primary"
                                                                                    />
                                                                                }
                                                                                label="Same day delivery"
                                                                            />
                                                                        </div>
                                                                    )}

                                                                    <h5 className="UI-section-title">Transportation Details</h5>
                                                                    <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Vehicle No.</label>
                                                                            <input
                                                                                type="text"
                                                                                className={`UI-input ${this.state.vehiclenum === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                value={this.state.vehiclenum}
                                                                                onChange={(e) => this.setState({ vehiclenum: e.target.value, err: false })}
                                                                            />
                                                                            {this.state.vehiclenum === "" && this.state.err && (
                                                                                <div className="UI-error-text">Empty field!</div>
                                                                            )}
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Approximate Distance (Km)</label>
                                                                            <input
                                                                                type="number"
                                                                                className={`UI-input ${this.state.distance === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                value={this.state.distance}
                                                                                onChange={(e) => this.setState({ distance: e.target.value, err: false })}
                                                                            />
                                                                            {this.state.distance === "" && this.state.err && (
                                                                                <div className="UI-error-text">Empty field!</div>
                                                                            )}
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Vehicle Type</label>
                                                                            <FormControl variant="standard" fullWidth>
                                                                                <Select
                                                                                    value={this.state.vehicletype}
                                                                                    onChange={(e) => this.setState({ vehicletype: e.target.value })}
                                                                                    disableUnderline
                                                                                    sx={{
                                                                                        '.MuiSelect-select': {
                                                                                            padding: '9px 12px',
                                                                                            border: '1px solid #d1d5db',
                                                                                            borderRadius: '6px',
                                                                                            backgroundColor: '#ffffff',
                                                                                            fontSize: '0.8rem',
                                                                                        },
                                                                                        '&:before, &:after': { display: 'none' },
                                                                                    }}
                                                                                >
                                                                                    {this.state.vehicletypes.map((e, i) => (
                                                                                        <MenuItem key={i} value={e.value}>{e.name}</MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            </FormControl>
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Transaction Type</label>
                                                                            <FormControl variant="standard" fullWidth>
                                                                                <Select
                                                                                    value={this.state.transactiontype}
                                                                                    onChange={(e) => this.setState({ transactiontype: e.target.value })}
                                                                                    disableUnderline
                                                                                    sx={{
                                                                                        '.MuiSelect-select': {
                                                                                            padding: '9px 12px',
                                                                                            border: '1px solid #d1d5db',
                                                                                            borderRadius: '6px',
                                                                                            backgroundColor: '#ffffff',
                                                                                            fontSize: '0.8rem',
                                                                                        },
                                                                                        '&:before, &:after': { display: 'none' },
                                                                                    }}
                                                                                >
                                                                                    <MenuItem value={1}>Regular</MenuItem>
                                                                                    <MenuItem value={2}>Bill To - Ship To</MenuItem>
                                                                                    <MenuItem value={3}>Bill From - Dispatch From</MenuItem>
                                                                                    <MenuItem value={4}>Combination of 2 and 3</MenuItem>
                                                                                </Select>
                                                                            </FormControl>
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Transportation Mode</label>
                                                                            <FormControl variant="standard" fullWidth>
                                                                                <Select
                                                                                    value={this.state.transportationmode}
                                                                                    onChange={(e) => this.setState({ transportationmode: e.target.value })}
                                                                                    disableUnderline
                                                                                    sx={{
                                                                                        '.MuiSelect-select': {
                                                                                            padding: '9px 12px',
                                                                                            border: '1px solid #d1d5db',
                                                                                            borderRadius: '6px',
                                                                                            backgroundColor: '#ffffff',
                                                                                            fontSize: '0.8rem',
                                                                                        },
                                                                                        '&:before, &:after': { display: 'none' },
                                                                                    }}
                                                                                >
                                                                                    <MenuItem value={1}>Road</MenuItem>
                                                                                    <MenuItem value={2}>Rail</MenuItem>
                                                                                    <MenuItem value={3}>Air</MenuItem>
                                                                                    <MenuItem value={4}>Ship</MenuItem>
                                                                                    <MenuItem value={5}>inTransit</MenuItem>
                                                                                </Select>
                                                                            </FormControl>
                                                                        </div>

                                                                        <div className="UI-form-group">
                                                                            <label className="UI-label">Supply Type</label>
                                                                            <FormControl variant="standard" fullWidth>
                                                                                <Select
                                                                                    value={this.state.supplytype}
                                                                                    onChange={(e) => this.setState({ supplytype: e.target.value })}
                                                                                    disableUnderline
                                                                                    sx={{
                                                                                        '.MuiSelect-select': {
                                                                                            padding: '9px 12px',
                                                                                            border: '1px solid #d1d5db',
                                                                                            borderRadius: '6px',
                                                                                            backgroundColor: '#ffffff',
                                                                                            fontSize: '0.8rem',
                                                                                        },
                                                                                        '&:before, &:after': { display: 'none' },
                                                                                    }}
                                                                                >
                                                                                    <MenuItem value={"I"}>Inward</MenuItem>
                                                                                    <MenuItem value={"O"}>Outward</MenuItem>
                                                                                </Select>
                                                                            </FormControl>
                                                                        </div>

                                                                        {this.state.einvoice && (
                                                                            <div className="UI-form-group" style={{ gridColumn: 'span 1' }}>
                                                                                <FormControlLabel
                                                                                    control={
                                                                                        <Checkbox
                                                                                            checked={this.state.transidreq}
                                                                                            onChange={() => this.setState({ transidreq: !this.state.transidreq, transporterid: null, transportername: null })}
                                                                                            color="primary"
                                                                                        />
                                                                                    }
                                                                                    label="Add transporter details for Part A?"
                                                                                />
                                                                            </div>
                                                                        )}

                                                                        {this.state.transidreq && (
                                                                            <>
                                                                                <div className="UI-form-group" style={{ display: 'flex', gap: '8px', gridColumn: 'span 2' }}>
                                                                                    <button
                                                                                        type="button"
                                                                                        className={`UI-tab-switch-btn ${!this.state.transporterselectiontype ? 'active' : ''}`}
                                                                                        onClick={() => this.setState({ transporterselectiontype: false, transportername: "", transporterid: "" })}
                                                                                    >
                                                                                        Enter Manually
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className={`UI-tab-switch-btn ${this.state.transporterselectiontype ? 'active' : ''}`}
                                                                                        onClick={() => this.setState({ transporterselectiontype: true, transportername: "", transporterid: "" })}
                                                                                    >
                                                                                        Select
                                                                                    </button>
                                                                                </div>

                                                                                {this.state.transporterselectiontype ? (
                                                                                    <>
                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">Transporter</label>
                                                                                            <Autocomplete
                                                                                                options={this.state.transporterslist}
                                                                                                getOptionLabel={(option) => option.transname}
                                                                                                onChange={this.handleTransporterChange}
                                                                                                renderInput={(params) => (
                                                                                                    <div ref={params.InputProps.ref}>
                                                                                                        <input
                                                                                                            type="text"
                                                                                                            {...params.inputProps}
                                                                                                            className={`UI-input ${this.state.transportername === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                                            placeholder="Select transporter"
                                                                                                        />
                                                                                                    </div>
                                                                                                )}
                                                                                            />
                                                                                            {this.state.transportername === "" && this.state.err && (
                                                                                                <div className="UI-error-text">Empty field!</div>
                                                                                            )}
                                                                                        </div>
                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">Transporter ID</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                className="UI-input UI-input-disabled"
                                                                                                value={this.state.transporterid}
                                                                                                disabled
                                                                                            />
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">Transporter Name</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                className={`UI-input ${this.state.transportername === "" && this.state.err ? 'UI-input-error' : ''}`}
                                                                                                value={this.state.transportername}
                                                                                                onChange={(e) => this.setState({ transportername: e.target.value, err: false })}
                                                                                            />
                                                                                            {this.state.transportername === "" && this.state.err && (
                                                                                                <div className="UI-error-text">Empty field!</div>
                                                                                            )}
                                                                                        </div>
                                                                                        <div className="UI-form-group">
                                                                                            <label className="UI-label">Transporter ID</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                className={`UI-input ${(this.state.transporterid === "" || !this.state.validtrnsid) && this.state.err ? 'UI-input-error' : ''}`}
                                                                                                value={this.state.transporterid}
                                                                                                onChange={this.TransporteridChange}
                                                                                            />
                                                                                            {(this.state.transporterid === "" || !this.state.validtrnsid) && this.state.err && (
                                                                                                <div className="UI-error-text">
                                                                                                    {this.state.transporterid === "" ? "Empty field!" : "Invalid Transporter ID"}
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                                {/* SECTION: Invoice Remarks */}
                                                <div className="UI-form-section" style={{ marginTop: '30px' }}>
                                                    <div className="UI-form-group">
                                                        <label className="UI-label">Invoice Remarks</label>
                                                        <textarea
                                                            className="UI-textarea"
                                                            rows="2"
                                                            value={this.state.invoiceremarks}
                                                            onChange={(e) => this.setState({ invoiceremarks: e.target.value })}
                                                        />
                                                    </div>
                                                </div>

                                                {/* SECTION: Form Actions */}
                                                <div className="UI-btn-actions">
                                                    {this.state.sotype === 1 || (this.state.invtype === "Direct Invoice" && this.state.servicecostwttax > 0) ? (
                                                        <button
                                                            type="button"
                                                            className="UI-btn UI-btn-primary"
                                                            onClick={this.handlesubmit}
                                                            disabled={this.state.loader}
                                                        >
                                                            {this.state.loader ? (
                                                                <>
                                                                    <span className="UI-spinner-small"></span> Saving...
                                                                </>
                                                            ) : (
                                                                "Save & send for approval"
                                                            )}
                                                        </button>
                                                    ) : this.state.accepteditems.length === 0 && this.state.completed === "" ? (
                                                        <button className="UI-btn UI-btn-primary" disabled>Save & send for approval</button>
                                                    ) : (
                                                        <button
                                                            type="button"
                                                            className="UI-btn UI-btn-primary"
                                                            onClick={this.handlesubmit}
                                                            disabled={this.state.loader}
                                                        >
                                                            {this.state.loader ? (
                                                                <>
                                                                    <span className="UI-spinner-small"></span> Saving...
                                                                </>
                                                            ) : ("Save & send for approval")}
                                                        </button>
                                                    )}
                                                    <Link
                                                        to={{ pathname: "/salesinvoice" }}
                                                        state={{
                                                            message: "",
                                                            type: this.state.pagename === "New Proforma Invoice" ? "Proforma Invoice" : "Tax Invoice",
                                                        }}
                                                        className="UI-btn UI-btn-outline"
                                                    >Cancel
                                                    </Link>
                                                </div>

                                                {this.state.errormsg.length > 0 && (
                                                    <div className="UI-error-text">
                                                        {typeof this.state.errormsg === "string"
                                                            ? this.state.errormsg
                                                            : this.state.errormsg.map((e, i) => e.ErrorMessage + ", ")}
                                                    </div>
                                                )}
                                            </Form>
                                        )}
                                    </Formik>
                                )}
                            </div>
                        </div>
                    </div>
                </div >

                <Modal
                    show={this.state.quantitywindow}
                    onHide={() => this.setState({ quantitywindow: false })}
                    backdrop="static"
                    keyboard={false}
                    centered
                    size="lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Select Quantity</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="UI-form-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
                            <div className="UI-form-group">
                                <label className="UI-label">Pending Quantity</label>
                                <div className="UI-static-value">{this.state.pendingquantity}</div>
                            </div>
                            <div className="UI-form-group">
                                <label className="UI-label">Total Quantity</label>
                                <div className="UI-static-value">{this.state.quantity}</div>
                            </div>
                        </div>

                        {this.state.itemquantitylist.length === 0 ? (
                            <div className="UI-helper-text">Out of Stock</div>
                        ) : (
                            <div className="UI-table-container">
                                <table className="UI-table">
                                    <thead className="UI-table-header">
                                        <tr>
                                            <th className="UI-th">Batch Id</th>
                                            <th className="UI-th">Price</th>
                                            <th className="UI-th">Date</th>
                                            <th className="UI-th">Available Quantity</th>
                                            <th className="UI-th">Enter Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.itemquantitylist.map((e, i) => (
                                            <tr key={i}>
                                                <td className="UI-td">{e.batchid}</td>
                                                <td className="UI-td UI-amount">
                                                    <NumericFormat displayType="text" value={e.price} decimalScale={2} fixedDecimalScale thousandSeparator thousandsGroupStyle={thousandsdisplay} />
                                                </td>
                                                <td className="UI-td">{moment(e.createdAt).format("DD-MM-YYYY hh:mm")}</td>
                                                <td className="UI-td">{e.currentstock}</td>
                                                <td className="UI-td">
                                                    <input
                                                        type="number"
                                                        className="UI-input"
                                                        value={e.enteredquantity}
                                                        onChange={(e) => this.handleQuantityChange(e.target.value, i)}
                                                        min="0"
                                                        max={e.currentstock}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {this.state.pendingquantity < this.state.quantity && (
                            <div className="UI-error-text">Exceeds quantity</div>
                        )}

                        <div className="UI-btn-actions">
                            <button className="UI-btn UI-btn-primary" onClick={this.handleSaveQuantity}>
                                Submit
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>

                <Footer />
            </div >
        );
    }
}

export default withRouter(Invoice);

